(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+00f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("J6GP");
exports.encode = exports.stringify = __webpack_require__("bvhO");

/***/ }),

/***/ "+3wn":
/***/ (function(module, exports, __webpack_require__) {

function n(n) {
  function r(n, r) {
    ~f.indexOf(n) || f.push(n), r && n(c);
  }function e(n) {
    var r = c;if (n !== r || null !== n && "object" == typeof n) {
      c = n, o.push.apply(o, f);for (var t = f.length, u = 0; u < t; u++) {
        o.pop()(c, r);
      }
    }
  }function i() {
    var n = u[u.length - 1];return n && r(n.n), c;
  }var c = n,
      f = [],
      p = function p(n) {
    if (!arguments.length) return i();e(n);
  };return p.subscribe = r, p.unsubscribe = function (n) {
    t(f, n);
  }, p;
}function r(n) {
  if (-1 !== u.indexOf(n)) throw Error("Circular computation detected");
}function t(n, r) {
  var t = n.indexOf(r);-1 !== t && n.splice(t, 1);
}var u = [],
    o = [];n.computed = function (t) {
  function o() {
    r(i), u.push(i);var n, o;try {
      o = t();
    } catch (r) {
      n = r;
    }if (u.pop(), n) throw n;e(o);
  }var e = n(),
      i = { n: o };return o(), e;
}, n.from = function (r) {
  var t = n();return r(t), t;
},  true ? module.exports = n : window.trkl = n;

/***/ }),

/***/ "+4GY":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__("M7z6");
var meta = __webpack_require__("AoVy").onFreeze;

__webpack_require__("s7uf")('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),

/***/ "+Bjj":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "+bQV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".uiContainer__nt6Vl{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;max-height:calc(80vh - 3em);overflow:hidden;width:90vw;max-width:20em}@media screen and (max-width:40em){.uiContainer__nt6Vl{width:100%;max-width:none;height:calc(100vh - 6em);max-height:calc(100vh - 6em)}}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/vertical-ui-container/C:/dev/globalTopBar/src/components/layout/vertical-ui-container/C:/dev/globalTopBar/src/components/layout/vertical-ui-container/styles.scss"],"names":[],"mappings":"AAAA,oBACE,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,yBAAA,sBAAA,wBACA,4BACA,gBACA,WACA,cAAe,CAEf,mCATF,oBAUI,WACA,eACA,yBACA,4BAA6B,CAEhC,CAAA","file":"styles.scss","sourcesContent":[".uiContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  max-height: calc(80vh - 3em);\n  overflow: hidden;\n  width: 90vw;\n  max-width: 20em;\n\n  @media screen and (max-width: 40em){\n    width: 100%;\n    max-width: initial;\n    height: calc(100vh - 6em);\n    max-height: calc(100vh - 6em);\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"uiContainer": "uiContainer__nt6Vl"
};

/***/ }),

/***/ "+ifB":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__("izCb");

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

/***/ }),

/***/ "+lQn":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("dJBs");
var repeat = __webpack_require__("UH4U");
var defined = __webpack_require__("+Bjj");

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

/***/ }),

/***/ "/o6G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("P9Ib") && !__webpack_require__("5BXi")(function () {
  return Object.defineProperty(__webpack_require__("/vZ6")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "/t3a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var at = __webpack_require__("x5yM")(true);

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

/***/ }),

/***/ "/vZ6":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("M7z6");
var document = __webpack_require__("5qf4").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "/wis":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "0B0p":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("JO4d");
var ITERATOR = __webpack_require__("44AI")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ "0JGj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("izCb");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("vn3S").set });

/***/ }),

/***/ "0NXb":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("nw8e");
var createDesc = __webpack_require__("uJ6d");
module.exports = __webpack_require__("P9Ib") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "0Yb5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbar__2qdIg{height:4em;border-bottom:1px solid #eee}.iconButton__1Q_eV{color:#0079b8;margin:0 .75em 0 1em;font-size:1.25em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/message-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/message-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/message-list/styles.scss"],"names":[],"mappings":"AAAA,gBACE,WACA,4BAA6B,CAC9B,mBAGC,cACA,qBACA,gBAAiB,CAClB","file":"styles.scss","sourcesContent":[".toolbar {\n  height: 4em;\n  border-bottom: 1px solid #eee;\n}\n\n.iconButton {\n  color: #0079b8;\n  margin: 0 .75em 0 1em;\n  font-size: 1.25em;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbar": "toolbar__2qdIg",
	"iconButton": "iconButton__1Q_eV"
};

/***/ }),

/***/ "0feo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbar__2xQfJ{height:4em;border-bottom:1px solid #ddd}.listContainer__rmHbu{background:#eee;padding:.5em .25em}.form__x0l7_{margin:0;width:100%;position:relative}.dateRow__2Cb6a,.form__x0l7_{display:-webkit-box;display:-ms-flexbox;display:flex}.dateRow__2Cb6a{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:1.5em auto .5em;position:-webkit-sticky;position:sticky;top:-.5em;background:#eee;z-index:10}.dateRow__2Cb6a span{font-size:.65em;text-transform:uppercase;font-weight:700;padding:.25em 1em;border-radius:1em;letter-spacing:.05em;display:inline-block;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/message-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/message-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/message-list/styles.scss"],"names":[],"mappings":"AAEA,gBACE,WACA,4BAA6B,CAC9B,sBAGC,gBACA,kBAAmB,CAGpB,aAGC,SACA,WACA,AACA,iBAAkB,CACnB,6BAFC,oBAAA,oBAAA,YACA,CAGF,AAFC,gBAIC,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,uBACA,wBAAA,gBACA,UACA,gBACA,UAAW,CARb,qBAWI,gBACA,yBACA,gBACA,kBACA,kBACA,qBACA,qBACA,mBAAA,oBAAA,YACA,oBAAA,aAAc,CACf","file":"styles.scss","sourcesContent":["$list-background: #eee;\n\n.toolbar {\n  height: 4em;\n  border-bottom: 1px solid #ddd;\n}\n\n.listContainer {\n  background: $list-background;\n  padding: .5em .25em;\n  //display: flex;\n  //flex-direction: column-reverse;\n}\n\n.form {\n  margin: 0;\n  width: 100%;\n  display: flex;\n  position: relative;\n}\n\n.dateRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 1.5em auto .5em;\n  position: sticky;\n  top: -.5em;\n  background: $list-background;\n  z-index: 10;\n\n  span {\n    font-size: 0.65em;\n    text-transform: uppercase;\n    font-weight: bold;\n    padding: .25em 1em;\n    border-radius: 1em;\n    letter-spacing: .05em;\n    display: inline-block;\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbar": "toolbar__2xQfJ",
	"listContainer": "listContainer__rmHbu",
	"form": "form__x0l7_",
	"dateRow": "dateRow__2Cb6a"
};

/***/ }),

/***/ "0jjw":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("U9a7");
var gOPS = __webpack_require__("EWMd");
var pIE = __webpack_require__("vjRp");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "167e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".appCard__3yIJV{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-decoration:none!important;color:#000!important;background:#fff;border-bottom:1px solid #eee}@media screen and (min-width:41em){.appCard__3yIJV:hover{background:#eee}}.appCardImage__OmV5u{-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:5em;width:5em;overflow:hidden}.appCardImage__OmV5u img{width:auto;max-width:70%;max-height:70%}.appCardImageError__1a-AV{width:80%;height:80%;background:#eee;border-radius:12em;-webkit-box-shadow:inset 0 .5em 1em rgba(0,0,0,.1);box-shadow:inset 0 .5em 1em rgba(0,0,0,.1)}.body__36ug7{overflow:hidden;padding:.5em}.body__36ug7 .name__i6VMi{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:700}.body__36ug7 .description__15z7-{overflow:hidden;font-size:.75em;line-height:1em;max-height:3em;padding-bottom:.5em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/apps/app-list-item/C:/dev/globalTopBar/src/components/sections/apps/app-list-item/C:/dev/globalTopBar/src/components/sections/apps/app-list-item/styles.scss"],"names":[],"mappings":"AAAA,gBACE,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,+BACA,qBACA,gBACA,4BAA6B,CAE7B,mCARF,sBAUM,eAAgB,CACjB,CAIL,qBACE,oBAAA,cACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,WACA,UACA,eAAgB,CAPlB,yBAUI,WACA,cACA,cAAe,CAChB,0BAID,UACA,WACA,gBACA,mBACA,mDAAA,0CAA6C,CAC9C,aAGC,gBACA,YAAa,CAFf,0BAKI,gBACA,uBACA,mBACA,eAAiB,CARrB,iCAYI,gBACA,gBACA,gBACA,eACA,mBAAoB,CACrB","file":"styles.scss","sourcesContent":[".appCard {\n  display: flex;\n  align-items: center;\n  text-decoration: none !important;\n  color: black !important;\n  background: white;\n  border-bottom: 1px solid #eee;\n\n  @media screen and (min-width: 41em) {\n    &:hover {\n      background: #eee;\n    }\n  }\n}\n\n.appCardImage {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 5em;\n  width: 5em;\n  overflow: hidden;\n\n  :global img {\n    width: auto;\n    max-width: 70%;\n    max-height: 70%;\n  }\n}\n\n.appCardImageError {\n  width: 80%;\n  height: 80%;\n  background: #eee;\n  border-radius: 12em;\n  box-shadow: inset 0 0.5em 1em rgba(0,0,0,0.1);\n}\n\n.body {\n  overflow: hidden;\n  padding: .5em;\n\n  .name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-weight: bold;\n  }\n\n  .description {\n    overflow: hidden;\n    font-size: 0.75em;\n    line-height: 1em;\n    max-height: 3em;\n    padding-bottom: .5em;\n  }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"appCard": "appCard__3yIJV",
	"appCardImage": "appCardImage__OmV5u",
	"appCardImageError": "appCardImageError__1a-AV",
	"body": "body__36ug7",
	"name": "name__i6VMi",
	"description": "description__15z7-"
};

/***/ }),

/***/ "16zj":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__("yjVO");
var toLength = __webpack_require__("dJBs");
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

/***/ }),

/***/ "1EYb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__("M7z6");

__webpack_require__("s7uf")('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),

/***/ "1FW4":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("M7z6");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

/***/ }),

/***/ "1Jo9":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__("izCb");

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),

/***/ "1wQ/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".container__NtyJ2{color:#666;fill:#666;width:100%;padding:1em;text-align:center;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.icon__1KIIu{display:block}.icon__1KIIu svg.mdi-icon{width:3em;height:3em;-webkit-transform:none;transform:none}.text__w_AJE{display:block}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/error-state/C:/dev/globalTopBar/src/components/common/error-state/C:/dev/globalTopBar/src/components/common/error-state/styles.scss"],"names":[],"mappings":"AAAA,kBACE,WACA,UACA,WACA,YACA,kBACA,YACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,sBAAuB,CAExB,aAGC,aAAc,CADhB,0BAGI,UACA,WACA,uBAAA,cAAe,CAChB,aAID,aAAc,CACf","file":"styles.scss","sourcesContent":[".container {\n  color: #666;\n  fill: #666;\n  width: 100%;\n  padding: 1em;\n  text-align: center;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n}\n\n.icon {\n  display: block;\n  :global svg.mdi-icon {\n    width: 3em;\n    height: 3em;\n    transform: none;\n  }\n}\n\n.text {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__NtyJ2",
	"icon": "icon__1KIIu",
	"text": "text__w_AJE"
};

/***/ }),

/***/ "28Ik":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("P06D");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2ZLW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WG/o");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2uHg":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "35hU":
/***/ (function(module, exports) {

module.exports = {"action.back":"Volver","action.load-next":"Cargar siguientes","action.load-previous":"Cargar anteriores","action.login":"Login","action.logout":"Logout","action.retry":"Inténtalo de nuevo","action.send":"Enviar","app.list.title":"Software","chat.group.form.title-description":"Descripción","chat.group.form.title-label":"Título","chat.group.new.title":"Nuevo grupo","chat.input-placeholder":"Escriba un mensaje","chat.list.empty":"Todavía no has iniciado ningún chat","chat.new.empty":"No hay contactos disponibles","chat.new.title":"Nueva chat","chat.read.empty":"Todavía no hay mensajes","chat.title":"Chat","configuration.loading.error":"La conexión con el servidor ha fallado.","error.loading":"Error de carga","help_desk_dropdown_title":"Servicio de asistencia","help_desk_link_text":"Solicitar asistencia","language.en":"Inglés","language.es":"Español","language.it":"Italiano","language_dropdown_title":"Idioma","manuals_dropdown_title":"Manuales","message.list":"Mensajes recibidos","message.list.empty":"No hay mensajes","notification.list":"Notificaciones","notification.list.empty":"No hay notificaciones","profile.attribute.email":"Correo electrónico ","profile.attribute.username":"Nombre de usuario","profile.edit":"Editar","profile.session_expiration":"Expiración de la sesión","profile.session_expiration_alert":"La sesión expirará si no se reconoce ninguna actividad.","profile.session_expiration_alert.short":"La sesión está a punto de expirar","profile.title":"Perfil","today":"hoy","user.not-logged":"No está conectado"}

/***/ }),

/***/ "3UmM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".dropdownMenu__26oIR{left:0!important;right:unset!important}.listContainer__36r-1{padding:1em;width:80vw}.buttonImage__Y6tHU{height:auto;display:block;width:11em;max-height:100%}@media screen and (max-width:24em){.buttonImage__Y6tHU{width:6em}}.logoButton__1qMs4{padding:0!important}@media screen and (max-width:40em) and (min-width:24em){.logoButton__1qMs4{margin-left:calc(50vw - 5.5em - 52px);padding:0!important}}@media screen and (max-width:24em){.logoButton__1qMs4{padding:0!important}}.toolbar__1fcyd{height:4em!important;border-bottom:1px solid #eee}.iconButton__aznJ_{color:#0079b8;margin:0 .75em 0 1em;font-size:1.25em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/apps/app-list/C:/dev/globalTopBar/src/components/sections/apps/app-list/C:/dev/globalTopBar/src/components/sections/apps/app-list/style.scss"],"names":[],"mappings":"AAAA,qBACE,iBACA,qBAAuB,CACxB,sBAGC,YACA,UAAW,CACZ,oBAGC,YACA,cACA,WACA,eAAgB,CAEhB,mCANF,oBAOI,SAAU,CAEb,CAGD,mBACE,mBAAqB,CAErB,wDAHF,mBAII,sCACA,mBAAqB,CAMxB,CAHC,mCARF,mBASI,mBAAqB,CAExB,CAED,gBACE,qBACA,4BAA6B,CAC9B,mBAGC,cACA,qBACA,gBAAiB,CAClB","file":"style.scss","sourcesContent":[".dropdownMenu {\n  left: 0 !important;\n  right: unset !important;\n}\n\n.listContainer {\n  padding: 1em;\n  width: 80vw;\n}\n\n.buttonImage {\n  height: auto;\n  display: block;\n  width: 11em;\n  max-height: 100%;\n\n  @media screen and (max-width: 24em) {\n    width: 6em;\n  }\n}\n\n\n.logoButton {\n  padding: 0 !important;\n\n  @media screen and (max-width: 40em) and (min-width: 24em) {\n    margin-left: calc(50vw - 5.5em - 52px);\n    padding: 0 !important;\n  }\n\n  @media screen and (max-width: 24em) {\n    padding: 0 !important;\n  }\n}\n\n.toolbar {\n  height: 4em !important;\n  border-bottom: 1px solid #eee;\n}\n\n.iconButton {\n  color: #0079b8;\n  margin: 0 .75em 0 1em;\n  font-size: 1.25em;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"dropdownMenu": "dropdownMenu__26oIR",
	"listContainer": "listContainer__36r-1",
	"buttonImage": "buttonImage__Y6tHU",
	"logoButton": "logoButton__1qMs4",
	"toolbar": "toolbar__1fcyd",
	"iconButton": "iconButton__aznJ_"
};

/***/ }),

/***/ "3d20":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("I6Kn");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3dZY":
/***/ (function(module, exports, __webpack_require__) {

!function (t, n) {
   true ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : t.dayjs = n();
}(this, function () {
  "use strict";
  var t = "millisecond",
      n = "second",
      e = "minute",
      r = "hour",
      i = "day",
      s = "week",
      u = "month",
      o = "quarter",
      a = "year",
      h = /^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/,
      f = /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      c = function c(t, n, e) {
    var r = String(t);return !r || r.length >= n ? t : "" + Array(n + 1 - r.length).join(e) + t;
  },
      d = { s: c, z: function z(t) {
      var n = -t.utcOffset(),
          e = Math.abs(n),
          r = Math.floor(e / 60),
          i = e % 60;return (n <= 0 ? "+" : "-") + c(r, 2, "0") + ":" + c(i, 2, "0");
    }, m: function m(t, n) {
      var e = 12 * (n.year() - t.year()) + (n.month() - t.month()),
          r = t.clone().add(e, u),
          i = n - r < 0,
          s = t.clone().add(e + (i ? -1 : 1), u);return Number(-(e + (n - r) / (i ? r - s : s - r)) || 0);
    }, a: function a(t) {
      return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
    }, p: function p(h) {
      return { M: u, y: a, w: s, d: i, D: "date", h: r, m: e, s: n, ms: t, Q: o }[h] || String(h || "").toLowerCase().replace(/s$/, "");
    }, u: function u(t) {
      return void 0 === t;
    } },
      $ = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") },
      l = "en",
      m = {};m[l] = $;var y = function y(t) {
    return t instanceof v;
  },
      M = function M(t, n, e) {
    var r;if (!t) return l;if ("string" == typeof t) m[t] && (r = t), n && (m[t] = n, r = t);else {
      var i = t.name;m[i] = t, r = i;
    }return !e && r && (l = r), r || !e && l;
  },
      g = function g(t, n, e) {
    if (y(t)) return t.clone();var r = n ? "string" == typeof n ? { format: n, pl: e } : n : {};return r.date = t, new v(r);
  },
      D = d;D.l = M, D.i = y, D.w = function (t, n) {
    return g(t, { locale: n.$L, utc: n.$u, $offset: n.$offset });
  };var v = function () {
    function c(t) {
      this.$L = this.$L || M(t.locale, null, !0), this.parse(t);
    }var d = c.prototype;return d.parse = function (t) {
      this.$d = function (t) {
        var n = t.date,
            e = t.utc;if (null === n) return new Date(NaN);if (D.u(n)) return new Date();if (n instanceof Date) return new Date(n);if ("string" == typeof n && !/Z$/i.test(n)) {
          var r = n.match(h);if (r) return e ? new Date(Date.UTC(r[1], r[2] - 1, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, r[7] || 0)) : new Date(r[1], r[2] - 1, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, r[7] || 0);
        }return new Date(n);
      }(t), this.init();
    }, d.init = function () {
      var t = this.$d;this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
    }, d.$utils = function () {
      return D;
    }, d.isValid = function () {
      return !("Invalid Date" === this.$d.toString());
    }, d.isSame = function (t, n) {
      var e = g(t);return this.startOf(n) <= e && e <= this.endOf(n);
    }, d.isAfter = function (t, n) {
      return g(t) < this.startOf(n);
    }, d.isBefore = function (t, n) {
      return this.endOf(n) < g(t);
    }, d.$g = function (t, n, e) {
      return D.u(t) ? this[n] : this.set(e, t);
    }, d.year = function (t) {
      return this.$g(t, "$y", a);
    }, d.month = function (t) {
      return this.$g(t, "$M", u);
    }, d.day = function (t) {
      return this.$g(t, "$W", i);
    }, d.date = function (t) {
      return this.$g(t, "$D", "date");
    }, d.hour = function (t) {
      return this.$g(t, "$H", r);
    }, d.minute = function (t) {
      return this.$g(t, "$m", e);
    }, d.second = function (t) {
      return this.$g(t, "$s", n);
    }, d.millisecond = function (n) {
      return this.$g(n, "$ms", t);
    }, d.unix = function () {
      return Math.floor(this.valueOf() / 1e3);
    }, d.valueOf = function () {
      return this.$d.getTime();
    }, d.startOf = function (t, o) {
      var h = this,
          f = !!D.u(o) || o,
          c = D.p(t),
          d = function d(t, n) {
        var e = D.w(h.$u ? Date.UTC(h.$y, n, t) : new Date(h.$y, n, t), h);return f ? e : e.endOf(i);
      },
          $ = function $(t, n) {
        return D.w(h.toDate()[t].apply(h.toDate(), (f ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(n)), h);
      },
          l = this.$W,
          m = this.$M,
          y = this.$D,
          M = "set" + (this.$u ? "UTC" : "");switch (c) {case a:
          return f ? d(1, 0) : d(31, 11);case u:
          return f ? d(1, m) : d(0, m + 1);case s:
          var g = this.$locale().weekStart || 0,
              v = (l < g ? l + 7 : l) - g;return d(f ? y - v : y + (6 - v), m);case i:case "date":
          return $(M + "Hours", 0);case r:
          return $(M + "Minutes", 1);case e:
          return $(M + "Seconds", 2);case n:
          return $(M + "Milliseconds", 3);default:
          return this.clone();}
    }, d.endOf = function (t) {
      return this.startOf(t, !1);
    }, d.$set = function (s, o) {
      var h,
          f = D.p(s),
          c = "set" + (this.$u ? "UTC" : ""),
          d = (h = {}, h[i] = c + "Date", h.date = c + "Date", h[u] = c + "Month", h[a] = c + "FullYear", h[r] = c + "Hours", h[e] = c + "Minutes", h[n] = c + "Seconds", h[t] = c + "Milliseconds", h)[f],
          $ = f === i ? this.$D + (o - this.$W) : o;if (f === u || f === a) {
        var l = this.clone().set("date", 1);l.$d[d]($), l.init(), this.$d = l.set("date", Math.min(this.$D, l.daysInMonth())).toDate();
      } else d && this.$d[d]($);return this.init(), this;
    }, d.set = function (t, n) {
      return this.clone().$set(t, n);
    }, d.get = function (t) {
      return this[D.p(t)]();
    }, d.add = function (t, o) {
      var h,
          f = this;t = Number(t);var c = D.p(o),
          d = function d(n) {
        var e = g(f);return D.w(e.date(e.date() + Math.round(n * t)), f);
      };if (c === u) return this.set(u, this.$M + t);if (c === a) return this.set(a, this.$y + t);if (c === i) return d(1);if (c === s) return d(7);var $ = (h = {}, h[e] = 6e4, h[r] = 36e5, h[n] = 1e3, h)[c] || 1,
          l = this.$d.getTime() + t * $;return D.w(l, this);
    }, d.subtract = function (t, n) {
      return this.add(-1 * t, n);
    }, d.format = function (t) {
      var n = this;if (!this.isValid()) return "Invalid Date";var e = t || "YYYY-MM-DDTHH:mm:ssZ",
          r = D.z(this),
          i = this.$locale(),
          s = this.$H,
          u = this.$m,
          o = this.$M,
          a = i.weekdays,
          h = i.months,
          c = function c(t, r, i, s) {
        return t && (t[r] || t(n, e)) || i[r].substr(0, s);
      },
          d = function d(t) {
        return D.s(s % 12 || 12, t, "0");
      },
          $ = i.meridiem || function (t, n, e) {
        var r = t < 12 ? "AM" : "PM";return e ? r.toLowerCase() : r;
      },
          l = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: o + 1, MM: D.s(o + 1, 2, "0"), MMM: c(i.monthsShort, o, h, 3), MMMM: h[o] || h(this, e), D: this.$D, DD: D.s(this.$D, 2, "0"), d: String(this.$W), dd: c(i.weekdaysMin, this.$W, a, 2), ddd: c(i.weekdaysShort, this.$W, a, 3), dddd: a[this.$W], H: String(s), HH: D.s(s, 2, "0"), h: d(1), hh: d(2), a: $(s, u, !0), A: $(s, u, !1), m: String(u), mm: D.s(u, 2, "0"), s: String(this.$s), ss: D.s(this.$s, 2, "0"), SSS: D.s(this.$ms, 3, "0"), Z: r };return e.replace(f, function (t, n) {
        return n || l[t] || r.replace(":", "");
      });
    }, d.utcOffset = function () {
      return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
    }, d.diff = function (t, h, f) {
      var c,
          d = D.p(h),
          $ = g(t),
          l = 6e4 * ($.utcOffset() - this.utcOffset()),
          m = this - $,
          y = D.m(this, $);return y = (c = {}, c[a] = y / 12, c[u] = y, c[o] = y / 3, c[s] = (m - l) / 6048e5, c[i] = (m - l) / 864e5, c[r] = m / 36e5, c[e] = m / 6e4, c[n] = m / 1e3, c)[d] || m, f ? y : D.a(y);
    }, d.daysInMonth = function () {
      return this.endOf(u).$D;
    }, d.$locale = function () {
      return m[this.$L];
    }, d.locale = function (t, n) {
      if (!t) return this.$L;var e = this.clone(),
          r = M(t, n, !0);return r && (e.$L = r), e;
    }, d.clone = function () {
      return D.w(this.$d, this);
    }, d.toDate = function () {
      return new Date(this.valueOf());
    }, d.toJSON = function () {
      return this.isValid() ? this.toISOString() : null;
    }, d.toISOString = function () {
      return this.$d.toISOString();
    }, d.toString = function () {
      return this.$d.toUTCString();
    }, c;
  }();return g.prototype = v.prototype, g.extend = function (t, n) {
    return t(n, v, g), g;
  }, g.locale = M, g.isDayjs = y, g.unix = function (t) {
    return g(1e3 * t);
  }, g.en = m[l], g.Ls = m, g;
});

/***/ }),

/***/ "3llM":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__("M7z6");
var meta = __webpack_require__("AoVy").onFreeze;

__webpack_require__("s7uf")('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),

/***/ "44AI":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("6zGc")('wks');
var uid = __webpack_require__("U49f");
var Symbol = __webpack_require__("5qf4").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "4Ca7":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("g6sb");
var toLength = __webpack_require__("dJBs");
var toAbsoluteIndex = __webpack_require__("vfEH");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "4JlF":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__("izCb");
var create = __webpack_require__("sYaK");
var aFunction = __webpack_require__("6kYj");
var anObject = __webpack_require__("eT53");
var isObject = __webpack_require__("M7z6");
var fails = __webpack_require__("5BXi");
var bind = __webpack_require__("h83E");
var rConstruct = (__webpack_require__("5qf4").Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() {/* empty */}
  return !(rConstruct(function () {/* empty */}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () {/* empty */});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0:
          return new Target();
        case 1:
          return new Target(args[0]);
        case 2:
          return new Target(args[0], args[1]);
        case 3:
          return new Target(args[0], args[1], args[2]);
        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),

/***/ "4NJ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__("izCb");
var $typed = __webpack_require__("fero");
var buffer = __webpack_require__("Ujpk");
var anObject = __webpack_require__("eT53");
var toAbsoluteIndex = __webpack_require__("vfEH");
var toLength = __webpack_require__("dJBs");
var isObject = __webpack_require__("M7z6");
var ArrayBuffer = __webpack_require__("5qf4").ArrayBuffer;
var speciesConstructor = __webpack_require__("Ex+G");
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__("5BXi")(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    }return result;
  }
});

__webpack_require__("5h4d")(ARRAY_BUFFER);

/***/ }),

/***/ "4bJO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var AppsIcon = function AppsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M16,20H20V16H16M16,14H20V10H16M10,8H14V4H10M16,8H20V4H16M10,14H14V10H10M4,14H8V10H4M4,20H8V16H4M10,20H14V16H10M4,8H8V4H4V8Z' }));
};

module.exports = AppsIcon;

/***/ }),

/***/ "4eQi":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0Yb5");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4fd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (__webpack_require__("P9Ib")) {
  var LIBRARY = __webpack_require__("H21C");
  var global = __webpack_require__("5qf4");
  var fails = __webpack_require__("5BXi");
  var $export = __webpack_require__("izCb");
  var $typed = __webpack_require__("fero");
  var $buffer = __webpack_require__("Ujpk");
  var ctx = __webpack_require__("E3Kh");
  var anInstance = __webpack_require__("yJTF");
  var propertyDesc = __webpack_require__("uJ6d");
  var hide = __webpack_require__("0NXb");
  var redefineAll = __webpack_require__("J0Tl");
  var toInteger = __webpack_require__("yjVO");
  var toLength = __webpack_require__("dJBs");
  var toIndex = __webpack_require__("16zj");
  var toAbsoluteIndex = __webpack_require__("vfEH");
  var toPrimitive = __webpack_require__("9y37");
  var has = __webpack_require__("2uHg");
  var classof = __webpack_require__("GM7B");
  var isObject = __webpack_require__("M7z6");
  var toObject = __webpack_require__("rfVX");
  var isArrayIter = __webpack_require__("0B0p");
  var create = __webpack_require__("sYaK");
  var getPrototypeOf = __webpack_require__("8q6y");
  var gOPN = __webpack_require__("Vzm0").f;
  var getIterFn = __webpack_require__("ia+4");
  var uid = __webpack_require__("U49f");
  var wks = __webpack_require__("44AI");
  var createArrayMethod = __webpack_require__("AuPh");
  var createArrayIncludes = __webpack_require__("4Ca7");
  var speciesConstructor = __webpack_require__("Ex+G");
  var ArrayIterators = __webpack_require__("6w+v");
  var Iterators = __webpack_require__("JO4d");
  var $iterDetect = __webpack_require__("md62");
  var setSpecies = __webpack_require__("5h4d");
  var arrayFill = __webpack_require__("hphS");
  var arrayCopyWithin = __webpack_require__("Oppn");
  var $DP = __webpack_require__("nw8e");
  var $GOPD = __webpack_require__("uIjZ");
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function toOffset(it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function validate(it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function allocate(C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    }return new C(length);
  };

  var speciesFromList = function speciesFromList(O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function fromList(C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) {
      result[index] = list[index++];
    }return result;
  };

  var addGetter = function addGetter(it, key, internal) {
    dP(it, key, { get: function get() {
        return this._d[internal];
      } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      }O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of() /* ...items */{
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) {
      result[index] = arguments[index++];
    }return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
    arrayToLocaleString.call(new Uint8Array(1));
  });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) {
      // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) {
      // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
      // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      }return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) {
      this[offset + index] = src[index++];
    }
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function isTAIndex(target, key) {
    return isObject(target) && target[TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
      target[key] = desc.value;
      return target;
    }return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () {
    arrayToString.call({});
  })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function constructor() {/* noop */},
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function get() {
      return this[TYPED_ARRAY];
    }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function getter(that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function setter(that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function addElement(that, index) {
      dP(that, index, {
        get: function get() {
          return getter(this, index);
        },
        set: function set(value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) {
          addElement(that, index++);
        }
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function get() {
          return NAME;
        }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () {
      Base.of.call(TypedArray, 1);
    }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () {/* empty */};

/***/ }),

/***/ "4shx":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__("izCb");

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

/***/ }),

/***/ "5BXi":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "5JoR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".icon__p9TUm{font-size:1em;width:2em;height:2em;border-radius:2em;background:#bbb;-ms-flex-negative:0;flex-shrink:0;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-weight:700;text-transform:uppercase;contain:strict;padding-right:.05em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/letter-icon/C:/dev/globalTopBar/src/components/common/letter-icon/C:/dev/globalTopBar/src/components/common/letter-icon/styles.scss"],"names":[],"mappings":"AAAA,aACE,cACA,UACA,WACA,kBACA,gBACA,oBAAA,cACA,kBACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,WACA,gBACA,yBACA,eACA,mBAAoB,CACrB","file":"styles.scss","sourcesContent":[".icon {\n  font-size: 1em;\n  width: 2em;\n  height: 2em;\n  border-radius: 2em;\n  background: #bbb;\n  flex-shrink: 0;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  text-transform: uppercase;\n  contain: strict;\n  padding-right: .05em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "icon__p9TUm"
};

/***/ }),

/***/ "5YsI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function isString(arg) {
    return typeof arg === 'string';
  },
  isObject: function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  },
  isNull: function isNull(arg) {
    return arg === null;
  },
  isNullOrUndefined: function isNullOrUndefined(arg) {
    return arg == null;
  }
};

/***/ }),

/***/ "5h4d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__("5qf4");
var dP = __webpack_require__("nw8e");
var DESCRIPTORS = __webpack_require__("P9Ib");
var SPECIES = __webpack_require__("44AI")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),

/***/ "5hZL":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("izCb");
var $task = __webpack_require__("KY9y");
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

/***/ }),

/***/ "5omu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".container__2dS6x{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.contactCheckbox__2xgQZ{display:block;width:1em;height:1em;background:rgba(0,0,0,.1);-ms-flex-negative:0;flex-shrink:0;margin-right:1em;position:relative;border-radius:3px;border:1px solid transparent;border-bottom:1px solid #ddd;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.39);box-shadow:inset 0 1px 2px rgba(0,0,0,.39)}.check__3NX9-{position:absolute;left:.125em;top:.125em;border-left:2px solid #000;border-bottom:2px solid #000;width:.7em;height:.4em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.contactBody__1BS4p{display:block;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;text-align:left;text-transform:none;font-weight:400}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/contact-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/contact-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/contact-item/styles.scss"],"names":[],"mappings":"AAAA,kBACE,oBAAA,oBAAA,aACA,yBAAA,sBAAA,kBAAmB,CACpB,wBAGC,cACA,UACA,WACA,0BACA,oBAAA,cACA,iBACA,kBACA,kBACA,6BACA,6BACA,mDAAA,0CAA2C,CAC5C,cAGC,kBACA,YACA,WACA,2BACA,6BACA,WACA,YACA,iCAAA,wBAAyB,CAC1B,oBAGC,cACA,WACA,mBACA,uBACA,gBACA,gBACA,oBACA,eAAmB,CACpB","file":"styles.scss","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n}\n\n.contactCheckbox {\n  display: block;\n  width: 1em;\n  height: 1em;\n  background: rgba(0,0,0,0.1);\n  flex-shrink: 0;\n  margin-right: 1em;\n  position: relative;\n  border-radius: 3px;\n  border: 1px solid transparent;\n  border-bottom: 1px solid #DDD;\n  box-shadow: inset 0 1px 2px rgba(0,0,0,.39);\n}\n\n.check {\n  position: absolute;\n  left: .125em;\n  top: .125em;\n  border-left: 2px solid #000;\n  border-bottom: 2px solid #000;\n  width: .7em;\n  height: .4em;\n  transform: rotate(-45deg);\n}\n\n.contactBody {\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  text-align: left;\n  text-transform: initial;\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__2dS6x",
	"contactCheckbox": "contactCheckbox__2xgQZ",
	"check": "check__3NX9-",
	"contactBody": "contactBody__1BS4p"
};

/***/ }),

/***/ "5qVI":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__("izCb");
var isInteger = __webpack_require__("T4z7");
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),

/***/ "5qf4":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "6WEV":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("M7z6");
var cof = __webpack_require__("Z5df");
var MATCH = __webpack_require__("44AI")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),

/***/ "6ano":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".warning__3oYwb{color:red;fill:red}.profileText__vrOk5{padding:0 1em 0 0}@media screen and (max-width:40em){.profileText__vrOk5{display:none}}.buttonContainer__1jh7c{height:100%}@media screen and (min-width:40em){.buttonContainer__1jh7c{height:100%}.buttonContainer__1jh7c:hover .tooltip__njt5U{display:block}}.badgeDanger__3ZJVz{background:none!important;color:red!important;-webkit-transform:scale(1.15);transform:scale(1.15)}.tooltip__njt5U{position:absolute;top:calc(100% + .5em);right:.5em;max-width:320px;word-break:break-word;width:auto;background:#bf0201;color:#fff;display:none;z-index:10000;padding:.5em 1em;border-radius:.25em;font-size:.875em;white-space:nowrap}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/profile-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/profile-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/profile-button/styles.scss"],"names":[],"mappings":"AAAA,gBACE,UACA,QAAQ,CACT,oBAGC,iBAAkB,CAElB,mCAHF,oBAII,YAAa,CAEhB,CAED,wBACE,WAAY,CAEZ,mCAHF,wBAII,WAAY,CAJhB,8CAOM,aAAc,CACf,CAIL,oBACE,0BACA,oBACA,8BAAA,qBAAsB,CACvB,gBAGC,kBACA,sBACA,WACA,gBACA,sBACA,WACA,mBACA,WACA,aACA,cACA,iBACA,oBACA,iBACA,kBAAmB,CACpB","file":"styles.scss","sourcesContent":[".warning {\n  color:red;\n  fill:red;\n}\n\n.profileText {\n  padding: 0 1em 0 0;\n\n  @media screen and (max-width: 40em) {\n    display: none;\n  }\n}\n\n.buttonContainer {\n  height: 100%;\n\n  @media screen and (min-width:40em) {\n    height: 100%;\n\n    &:hover .tooltip {\n      display: block;\n    }\n  }\n}\n\n.badgeDanger {\n  background: none !important;\n  color: red !important;\n  transform: scale(1.15);\n}\n\n.tooltip {\n  position: absolute;\n  top: calc(100% + .5em);\n  right: .5em;\n  max-width: 320px;\n  word-break: break-word;\n  width: auto;\n  background: #bf0201;\n  color: #fff;\n  display: none;\n  z-index: 10000;\n  padding: .5em 1em;\n  border-radius: .25em;\n  font-size: 0.875em;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"warning": "warning__3oYwb",
	"profileText": "profileText__vrOk5",
	"buttonContainer": "buttonContainer__1jh7c",
	"tooltip": "tooltip__njt5U",
	"badgeDanger": "badgeDanger__3ZJVz"
};

/***/ }),

/***/ "6kYj":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "6sAH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("eYdE");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6w+v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__("Z7e/");
var step = __webpack_require__("x8b3");
var Iterators = __webpack_require__("JO4d");
var toIObject = __webpack_require__("g6sb");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("mH0U")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),

/***/ "6zGc":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("ss9A");
var global = __webpack_require__("5qf4");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("H21C") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "7sVm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $export = __webpack_require__("izCb");
var $find = __webpack_require__("AuPh")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("Z7e/")(KEY);

/***/ }),

/***/ "86Ro":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var AccountEditIcon = function AccountEditIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.09 20.21,11.09 20.42,11.3L21.7,12.58C21.91,12.79 21.91,13.14 21.7,13.35M12,18.94L18.06,12.88L20.11,14.93L14.06,21H12V18.94M12,14C7.58,14 4,15.79 4,18V20H10V18.11L14,14.11C13.34,14.03 12.67,14 12,14M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4Z' }));
};

module.exports = AccountEditIcon;

/***/ }),

/***/ "8RlZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".profileToolbar__29xzS{border-bottom:1px solid #eee;height:4em;padding:0 .25em}.profileInfoContainer__3_bV_{border-bottom:1px solid #eee;padding:.5em}.profileInfoContainer__3_bV_:last-child{border:0}.profileRow__3taWl{height:3em;padding:0 .5em 0 .75em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.profileRowAlert__1Gl4R{background:#bf0201;color:#fff;padding:1em;margin:-.25em .5em .5em;font-size:.875em;line-height:1.25em;border-radius:.5em}.profileRowField__1AmC1{line-height:1em;font-size:.75em;text-transform:uppercase;letter-spacing:.05em;-ms-flex-negative:0;flex-shrink:0;margin-right:1em;font-weight:700}.profileRowField__1AmC1,.profileRowValue__hE2C-{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.profileRowValue__hE2C-{line-height:1.5em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/profile-box/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/profile-box/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/profile-box/styles.scss"],"names":[],"mappings":"AAAA,uBACE,6BACA,WACA,eAAgB,CACjB,6BAGC,6BACA,YAAa,CAFf,wCAKI,QAAS,CACV,mBAID,WACA,uBACA,oBAAA,oBAAA,aACA,8BAAA,6BAAA,uBAAA,mBACA,yBAAA,sBAAA,8BACA,yBAAA,sBAAA,kBAAmB,CACpB,wBAGC,mBACA,WACA,YACA,wBACA,iBACA,mBACA,kBAAmB,CACpB,wBAIC,gBACA,gBACA,yBACA,qBACA,AAGA,oBAAA,cACA,iBACA,eAAiB,CAClB,gDAXC,cACA,AAIA,gBACA,uBACA,kBACA,CAWD,AARA,wBAIC,iBACA,CAGD","file":"styles.scss","sourcesContent":[".profileToolbar {\n  border-bottom: 1px solid #eee;\n  height: 4em;\n  padding: 0 .25em;\n}\n\n.profileInfoContainer {\n  border-bottom: 1px solid #eee;\n  padding: .5em;\n\n  &:last-child {\n    border: 0;\n  }\n}\n\n.profileRow {\n  height: 3em;\n  padding: 0 .5em 0 .75em;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.profileRowAlert {\n  background: #bf0201;\n  color: white;\n  padding: 1em;\n  margin: -.25em .5em .5em .5em;\n  font-size: 0.875em;\n  line-height: 1.25em;\n  border-radius: .5em;\n}\n\n.profileRowField {\n  display: block;\n  line-height: 1em;\n  font-size: 0.75em;\n  text-transform: uppercase;\n  letter-spacing: .05em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin-right: 1em;\n  font-weight: bold;\n}\n\n.profileRowValue {\n  display: block;\n  line-height: 1.5em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"profileToolbar": "profileToolbar__29xzS",
	"profileInfoContainer": "profileInfoContainer__3_bV_",
	"profileRow": "profileRow__3taWl",
	"profileRowAlert": "profileRowAlert__1Gl4R",
	"profileRowField": "profileRowField__1AmC1",
	"profileRowValue": "profileRowValue__hE2C-"
};

/***/ }),

/***/ "8Rqe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var LogoutIcon = function LogoutIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z' }));
};

module.exports = LogoutIcon;

/***/ }),

/***/ "8aIi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__("nw8e").f;
var create = __webpack_require__("sYaK");
var redefineAll = __webpack_require__("J0Tl");
var ctx = __webpack_require__("E3Kh");
var anInstance = __webpack_require__("yJTF");
var forOf = __webpack_require__("Abke");
var $iterDefine = __webpack_require__("mH0U");
var step = __webpack_require__("x8b3");
var setSpecies = __webpack_require__("5h4d");
var DESCRIPTORS = __webpack_require__("P9Ib");
var fastKey = __webpack_require__("AoVy").fastKey;
var validate = __webpack_require__("1FW4");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function getEntry(that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME; // collection type
      that._i = create(null); // index
      that._f = undefined; // first entry
      that._l = undefined; // last entry
      that[SIZE] = 0; // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function _delete(key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        }return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) {
            entry = entry.p;
          }
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function get() {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
      // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key, // <- key
        v: value, // <- value
        p: prev = that._l, // <- previous entry
        n: undefined, // <- next entry
        r: false // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    }return that;
  },
  getEntry: getEntry,
  setStrong: function setStrong(C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind; // kind
      this._l = undefined; // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) {
        entry = entry.p;
      } // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),

/***/ "8lA1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ChatOutlineIcon = function ChatOutlineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M12,3C6.5,3 2,6.58 2,11C2.05,13.15 3.06,15.17 4.75,16.5C4.75,17.1 4.33,18.67 2,21C4.37,20.89 6.64,20 8.47,18.5C9.61,18.83 10.81,19 12,19C17.5,19 22,15.42 22,11C22,6.58 17.5,3 12,3M12,17C7.58,17 4,14.31 4,11C4,7.69 7.58,5 12,5C16.42,5 20,7.69 20,11C20,14.31 16.42,17 12,17Z' }));
};

module.exports = ChatOutlineIcon;

/***/ }),

/***/ "8q6y":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("2uHg");
var toObject = __webpack_require__("rfVX");
var IE_PROTO = __webpack_require__("NaGB")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),

/***/ "9SWN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__("izCb");
var $pad = __webpack_require__("+lQn");
var userAgent = __webpack_require__("O5uh");

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),

/***/ "9bbv":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "9mbT":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "9oST":
/***/ (function(module, exports, __webpack_require__) {

!function (e, o) {
   true ? module.exports = o(__webpack_require__("3dZY")) : "function" == typeof define && define.amd ? define(["dayjs"], o) : e.dayjs_locale_it = o(e.dayjs);
}(this, function (e) {
  "use strict";
  e = e && e.hasOwnProperty("default") ? e.default : e;var o = { name: "it", weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"), weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"), weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"), months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"), weekStart: 1, monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"), formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "tra %s", past: "%s fa", s: "qualche secondo", m: "un minuto", mm: "%d minuti", h: "un' ora", hh: "%d ore", d: "un giorno", dd: "%d giorni", M: "un mese", MM: "%d mesi", y: "un anno", yy: "%d anni" }, ordinal: function ordinal(e) {
      return e + "º";
    } };return e.locale(o, null, !0), o;
});

/***/ }),

/***/ "9y37":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("M7z6");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "A+f6":
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = !$expm1
// Old FF bug
|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
// Tor Browser bug
|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),

/***/ "A8J8":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("izCb");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("5BXi")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),

/***/ "Abke":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("E3Kh");
var call = __webpack_require__("RnO+");
var isArrayIter = __webpack_require__("0B0p");
var anObject = __webpack_require__("eT53");
var toLength = __webpack_require__("dJBs");
var getIterFn = __webpack_require__("ia+4");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

/***/ }),

/***/ "Ah+n":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("44AI")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),

/***/ "AmoX":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__("izCb");
var $expm1 = __webpack_require__("A+f6");

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

/***/ }),

/***/ "AoVy":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("U49f")('meta');
var isObject = __webpack_require__("M7z6");
var has = __webpack_require__("2uHg");
var setDesc = __webpack_require__("nw8e").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("5BXi")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),

/***/ "AuE7":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("44AI");

/***/ }),

/***/ "AuPh":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("E3Kh");
var IObject = __webpack_require__("nGau");
var toObject = __webpack_require__("rfVX");
var toLength = __webpack_require__("dJBs");
var asc = __webpack_require__("igas");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),

/***/ "BMSr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ClockIcon = function ClockIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z' }));
};

module.exports = ClockIcon;

/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "BNoi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var redefineAll = __webpack_require__("J0Tl");
var getWeak = __webpack_require__("AoVy").getWeak;
var anObject = __webpack_require__("eT53");
var isObject = __webpack_require__("M7z6");
var anInstance = __webpack_require__("yJTF");
var forOf = __webpack_require__("Abke");
var createArrayMethod = __webpack_require__("AuPh");
var $has = __webpack_require__("2uHg");
var validate = __webpack_require__("1FW4");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};
var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME; // collection type
      that._i = id++; // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function _delete(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),

/***/ "BQD8":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("izCb");
var ownKeys = __webpack_require__("kABk");
var toIObject = __webpack_require__("g6sb");
var gOPD = __webpack_require__("uIjZ");
var createProperty = __webpack_require__("JCwR");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

/***/ }),

/***/ "Bdam":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sBdN");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "BmyK":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__("izCb");
var anObject = __webpack_require__("eT53");
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),

/***/ "BvS8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("V1F4");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "C85R":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("izCb");

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__("UH4U")
});

/***/ }),

/***/ "D6DP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__("5qf4");
var each = __webpack_require__("AuPh")(0);
var redefine = __webpack_require__("PHot");
var meta = __webpack_require__("AoVy");
var assign = __webpack_require__("e3Bp");
var weak = __webpack_require__("BNoi");
var isObject = __webpack_require__("M7z6");
var validate = __webpack_require__("1FW4");
var NATIVE_WEAK_MAP = __webpack_require__("1FW4");
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function wrapper(get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("hWYB")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
        // store all the rest on native weakmap
      }return method.call(this, a, b);
    });
  });
}

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "Dt0g":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("aZF3");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DzYy":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__("izCb");

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

/***/ }),

/***/ "E3Kh":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("6kYj");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "EAOR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:bar-system-font;font-style:normal;font-weight:400;src:local(\".SFNSText-Light\"),local(\".HelveticaNeueDeskInterface-Light\"),local(\".LucidaGrandeUI\"),local(\"Ubuntu Light\"),local(\"Segoe UI\"),local(\"Roboto-Light\"),local(\"DroidSans\"),local(\"Tahoma\")}.clean__3zrqp{font-family:bar-system-font,sans-serif!important;-webkit-box-sizing:border-box;box-sizing:border-box}.clean__3zrqp *,.clean__3zrqp :after,.clean__3zrqp :before{-webkit-box-sizing:inherit;box-sizing:inherit}.clean__3zrqp address,.clean__3zrqp blockquote,.clean__3zrqp body,.clean__3zrqp dd,.clean__3zrqp dl,.clean__3zrqp dt,.clean__3zrqp h1,.clean__3zrqp h2,.clean__3zrqp h3,.clean__3zrqp h4,.clean__3zrqp h5,.clean__3zrqp h6,.clean__3zrqp html,.clean__3zrqp li,.clean__3zrqp ol,.clean__3zrqp p,.clean__3zrqp ul{margin:0;padding:0}.clean__3zrqp form{margin:0}.clean__3zrqp img{font-size:inherit}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/global-container/C:/dev/globalTopBar/src/components/layout/global-container/C:/dev/globalTopBar/src/components/layout/global-container/style-reset.scss"],"names":[],"mappings":"AAAA,WACE,4BACA,kBACA,gBACA,iMAAyM,CAG3M,cACE,iDACA,8BAAA,qBAAsB,CAFxB,2DAMM,2BAAA,kBACF,CAPJ,iTAUM,SACA,SACF,CAZJ,mBAeM,QAAS,CAff,kBAmBM,iBAAkB,CACnB","file":"style-reset.scss","sourcesContent":["@font-face {\n  font-family: bar-system-font;\n  font-style: normal;\n  font-weight: 400;\n  src: local(\".SFNSText-Light\"), local(\".HelveticaNeueDeskInterface-Light\"), local(\".LucidaGrandeUI\"), local(\"Ubuntu Light\"), local(\"Segoe UI\"), local(\"Roboto-Light\"), local(\"DroidSans\"), local(\"Tahoma\");\n}\n\n.clean {\n  font-family: \"bar-system-font\", sans-serif !important;\n  box-sizing: border-box;\n\n  :global {\n    *, *:before, *:after {\n      box-sizing: inherit\n    }\n\n    html, body, h1, h2, h3, h4, h5, h6, p, ol, ul, li, dl, dt, dd, blockquote, address {\n      margin: 0;\n      padding: 0\n    }\n\n    form {\n      margin: 0;\n    }\n\n    img {\n      font-size: inherit;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"clean": "clean__3zrqp"
};

/***/ }),

/***/ "EO7q":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("M7z6");
var meta = __webpack_require__("AoVy").onFreeze;

__webpack_require__("s7uf")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),

/***/ "EWMd":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "Ex+G":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("eT53");
var aFunction = __webpack_require__("6kYj");
var SPECIES = __webpack_require__("44AI")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),

/***/ "F0Xu":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__("izCb");
var aFunction = __webpack_require__("6kYj");
var anObject = __webpack_require__("eT53");
var rApply = (__webpack_require__("5qf4").Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__("5BXi")(function () {
  rApply(function () {/* empty */});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),

/***/ "FIMm":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function (root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module && !module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
		root = freeGlobal;
	}

	/**
  * The `punycode` object.
  * @name punycode
  * @type Object
  */
	var punycode,


	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647,
	    // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	    tMin = 1,
	    tMax = 26,
	    skew = 38,
	    damp = 700,
	    initialBias = 72,
	    initialN = 128,
	    // 0x80
	delimiter = '-',
	    // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	    regexNonASCII = /[^\x20-\x7E]/,
	    // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	    // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},


	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	    floor = Math.floor,
	    stringFromCharCode = String.fromCharCode,


	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
  * A generic error utility function.
  * @private
  * @param {String} type The error type.
  * @returns {Error} Throws a `RangeError` with the applicable error message.
  */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
  * A generic `Array#map` utility function.
  * @private
  * @param {Array} array The array to iterate over.
  * @param {Function} callback The function that gets called for every array
  * item.
  * @returns {Array} A new array of values returned by the callback function.
  */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
  * A simple `Array#map`-like wrapper to work with domain name strings or email
  * addresses.
  * @private
  * @param {String} domain The domain name or email address.
  * @param {Function} callback The function that gets called for every
  * character.
  * @returns {Array} A new string of characters returned by the callback
  * function.
  */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
  * Creates a string based on an array of numeric code points.
  * @see `punycode.ucs2.decode`
  * @memberOf punycode.ucs2
  * @name encode
  * @param {Array} codePoints The array of numeric code points.
  * @returns {String} The new Unicode string (UCS-2).
  */
	function ucs2encode(array) {
		return map(array, function (value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
  * Converts a basic code point into a digit/integer.
  * @see `digitToBasic()`
  * @private
  * @param {Number} codePoint The basic numeric code point value.
  * @returns {Number} The numeric value of a basic code point (for use in
  * representing integers) in the range `0` to `base - 1`, or `base` if
  * the code point does not represent a value.
  */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
  * Converts a digit/integer into a basic code point.
  * @see `basicToDigit()`
  * @private
  * @param {Number} digit The numeric value of a basic code point.
  * @returns {Number} The basic code point whose value (when used for
  * representing integers) is `digit`, which needs to be in the range
  * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
  * used; else, the lowercase form is used. The behavior is undefined
  * if `flag` is non-zero and `digit` has no uppercase form.
  */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
  * Bias adaptation function as per section 3.4 of RFC 3492.
  * https://tools.ietf.org/html/rfc3492#section-3.4
  * @private
  */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
  * Converts a Punycode string of ASCII-only symbols to a string of Unicode
  * symbols.
  * @memberOf punycode
  * @param {String} input The Punycode string of ASCII-only symbols.
  * @returns {String} The resulting string of Unicode symbols.
  */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,

		/** Cached calculation results */
		baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;
			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);
		}

		return ucs2encode(output);
	}

	/**
  * Converts a string of Unicode symbols (e.g. a domain name label) to a
  * Punycode string of ASCII-only symbols.
  * @memberOf punycode
  * @param {String} input The string of Unicode symbols.
  * @returns {String} The resulting Punycode string of ASCII-only symbols.
  */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],

		/** `inputLength` will hold the number of code points in `input`. */
		inputLength,

		/** Cached calculation results */
		handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base;; /* no condition */k += base) {
						t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;
		}
		return output.join('');
	}

	/**
  * Converts a Punycode string representing a domain name or an email address
  * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
  * it doesn't matter if you call it on a string that has already been
  * converted to Unicode.
  * @memberOf punycode
  * @param {String} input The Punycoded domain name or email address to
  * convert to Unicode.
  * @returns {String} The Unicode representation of the given Punycode
  * string.
  */
	function toUnicode(input) {
		return mapDomain(input, function (string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	}

	/**
  * Converts a Unicode string representing a domain name or an email address to
  * Punycode. Only the non-ASCII parts of the domain name will be converted,
  * i.e. it doesn't matter if you call it with a domain that's already in
  * ASCII.
  * @memberOf punycode
  * @param {String} input The domain name or email address to convert, as a
  * Unicode string.
  * @returns {String} The Punycode representation of the given domain name or
  * email address.
  */
	function toASCII(input) {
		return mapDomain(input, function (string) {
			return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
		'version': '1.4.1',
		/**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}
})(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("l262")(module), __webpack_require__("h6ac")))

/***/ }),

/***/ "Fckj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__("M7z6");

__webpack_require__("s7uf")('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),

/***/ "Fnqw":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__("izCb");
var expm1 = __webpack_require__("A+f6");
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),

/***/ "FqhM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowLeftIcon = function ArrowLeftIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z' }));
};

module.exports = ArrowLeftIcon;

/***/ }),

/***/ "FuY7":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__("izCb");
var _isFinite = __webpack_require__("5qf4").isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),

/***/ "GM7B":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("Z5df");
var TAG = __webpack_require__("44AI")('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ "GTru":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".cover__3m8V0{position:absolute;top:0;right:0;bottom:0;left:0;background:hsla(0,0%,100%,.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:10000}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/backdrop-cover/C:/dev/globalTopBar/src/components/common/backdrop-cover/C:/dev/globalTopBar/src/components/common/backdrop-cover/styles.scss"],"names":[],"mappings":"AAAA,cACE,kBACA,MACA,QACA,SACA,OACA,8BACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,aAAc,CACf","file":"styles.scss","sourcesContent":[".cover {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(white, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"cover": "cover__3m8V0"
};

/***/ }),

/***/ "GbTB":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("6WEV");
var defined = __webpack_require__("+Bjj");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),

/***/ "GkNt":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function () {
  'use strict';

  // Exit early if we're not running in a browser.

  if (typeof window !== 'object') {
    return;
  }

  // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }

  /**
   * A local reference to the document.
   */
  var document = window.document;

  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */
  var registry = [];

  /**
   * The signal updater for cross-origin intersection. When not null, it means
   * that the polyfill is configured to work in a cross-origin mode.
   * @type {function(DOMRect, DOMRect)}
   */
  var crossOriginUpdater = null;

  /**
   * The current cross-origin intersection. Only used in the cross-origin mode.
   * @type {DOMRect}
   */
  var crossOriginRect = null;

  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */
  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect;

    // Calculates the intersection ratio.
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;

    // Sets intersection ratio.
    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }

  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */
  function IntersectionObserver(callback, opt_options) {

    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    }

    // Binds and throttles `this._checkForIntersections`.
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

    // Private properties.
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);

    // Public properties.
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');

    /** @private @const {!Array<!Document>} */
    this._monitoringDocuments = [];
    /** @private @const {!Array<function()>} */
    this._monitoringUnsubscribes = [];
  }

  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */
  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */
  IntersectionObserver.prototype.POLL_INTERVAL = null;

  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */
  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

  /**
   * Sets up the polyfill in the cross-origin mode. The result is the
   * updater function that accepts two arguments: `boundingClientRect` and
   * `intersectionRect` - just as these fields would be available to the
   * parent via `IntersectionObserverEntry`. This function should be called
   * each time the iframe receives intersection information from the parent
   * window, e.g. via messaging.
   * @return {function(DOMRect, DOMRect)}
   */
  IntersectionObserver._setupCrossOriginUpdater = function () {
    if (!crossOriginUpdater) {
      /**
       * @param {DOMRect} boundingClientRect
       * @param {DOMRect} intersectionRect
       */
      crossOriginUpdater = function crossOriginUpdater(boundingClientRect, intersectionRect) {
        if (!boundingClientRect || !intersectionRect) {
          crossOriginRect = getEmptyRect();
        } else {
          crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
        }
        registry.forEach(function (observer) {
          observer._checkForIntersections();
        });
      };
    }
    return crossOriginUpdater;
  };

  /**
   * Resets the cross-origin mode.
   */
  IntersectionObserver._resetCrossOriginUpdater = function () {
    crossOriginUpdater = null;
    crossOriginRect = null;
  };

  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();
    this._observationTargets.push({ element: target, entry: null });
    this._monitorIntersections(target.ownerDocument);
    this._checkForIntersections();
  };

  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });
    this._unmonitorIntersections(target.ownerDocument);
    if (this._observationTargets.length == 0) {
      this._unregisterInstance();
    }
  };

  /**
   * Stops observing all target elements for intersection changes.
   */
  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];
    this._unmonitorAllIntersections();
    this._unregisterInstance();
  };

  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */
  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };

  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */
  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];

    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }
      return t !== a[i - 1];
    });
  };

  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */
  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }
      return { value: parseFloat(parts[1]), unit: parts[2] };
    });

    // Handles shorthand.
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];

    return margins;
  };

  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._monitorIntersections = function (doc) {
    var win = doc.defaultView;
    if (!win) {
      // Already destroyed.
      return;
    }
    if (this._monitoringDocuments.indexOf(doc) != -1) {
      // Already monitoring.
      return;
    }

    // Private state for monitoring.
    var callback = this._checkForIntersections;
    var monitoringInterval = null;
    var domObserver = null;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
    } else {
      addEvent(win, 'resize', callback, true);
      addEvent(doc, 'scroll', callback, true);
      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
        domObserver = new win.MutationObserver(callback);
        domObserver.observe(doc, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    this._monitoringDocuments.push(doc);
    this._monitoringUnsubscribes.push(function () {
      // Get the window object again. When a friendly iframe is destroyed, it
      // will be null.
      var win = doc.defaultView;

      if (win) {
        if (monitoringInterval) {
          win.clearInterval(monitoringInterval);
        }
        removeEvent(win, 'resize', callback, true);
      }

      removeEvent(doc, 'scroll', callback, true);
      if (domObserver) {
        domObserver.disconnect();
      }
    });

    // Also monitor the parent.
    if (doc != (this.root && this.root.ownerDocument || document)) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._monitorIntersections(frame.ownerDocument);
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
    var index = this._monitoringDocuments.indexOf(doc);
    if (index == -1) {
      return;
    }

    var rootDoc = this.root && this.root.ownerDocument || document;

    // Check if any dependent targets are still remaining.
    var hasDependentTargets = this._observationTargets.some(function (item) {
      var itemDoc = item.element.ownerDocument;
      // Target is in this context.
      if (itemDoc == doc) {
        return true;
      }
      // Target is nested in this context.
      while (itemDoc && itemDoc != rootDoc) {
        var frame = getFrameElement(itemDoc);
        itemDoc = frame && frame.ownerDocument;
        if (itemDoc == doc) {
          return true;
        }
      }
      return false;
    });
    if (hasDependentTargets) {
      return;
    }

    // Unsubscribe.
    var unsubscribe = this._monitoringUnsubscribes[index];
    this._monitoringDocuments.splice(index, 1);
    this._monitoringUnsubscribes.splice(index, 1);
    unsubscribe();

    // Also unmonitor the parent.
    if (doc != rootDoc) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._unmonitorIntersections(frame.ownerDocument);
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._unmonitorAllIntersections = function () {
    var unsubscribes = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0;
    this._monitoringUnsubscribes.length = 0;
    for (var i = 0; i < unsubscribes.length; i++) {
      unsubscribes[i]();
    }
  };

  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */
  IntersectionObserver.prototype._checkForIntersections = function () {
    if (!this.root && crossOriginUpdater && !crossOriginRect) {
      // Cross origin monitoring, but no initial data available yet.
      return;
    }

    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: crossOriginUpdater && !this.root ? null : rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };

  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} targetRect The bounding rect of the target.
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */
  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;

    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot && parent) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

      // If the parent isn't displayed, an intersection can't happen.
      if (parentComputedStyle.display == 'none') return null;

      if (parent == this.root || parent.nodeType == /* DOCUMENT */9) {
        atRoot = true;
        if (parent == this.root || parent == document) {
          if (crossOriginUpdater && !this.root) {
            if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
              // A 0-size cross-origin intersection means no-intersection.
              parent = null;
              parentRect = null;
              intersectionRect = null;
            } else {
              parentRect = crossOriginRect;
            }
          } else {
            parentRect = rootRect;
          }
        } else {
          // Check if there's a frame that can be navigated to.
          var frame = getParentNode(parent);
          var frameRect = frame && getBoundingClientRect(frame);
          var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
          if (frameRect && frameIntersect) {
            parent = frame;
            parentRect = convertFromParentRect(frameRect, frameIntersect);
          } else {
            parent = null;
            intersectionRect = null;
          }
        }
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        var doc = parent.ownerDocument;
        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      }

      // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
      }
      if (!intersectionRect) break;
      parent = parent && getParentNode(parent);
    }
    return intersectionRect;
  };

  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {Object} The expanded root rect.
   * @private
   */
  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;
    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };

  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {Object} rect The rect object to expand.
   * @return {Object} The expanded rect.
   * @private
   */
  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;

    return newRect;
  };

  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */
  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {

    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

    // Ignore unchanged ratios
    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];

      // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };

  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */
  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };

  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */
  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target) && (!this.root || this.root.ownerDocument == target.ownerDocument);
  };

  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */
  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };

  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */
  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };

  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */
  function now() {
    return window.performance && performance.now && performance.now();
  }

  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */
  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }

  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }

  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object} The intersection rect or undefined if no intersection
   *     is found.
   */
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;

    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    } || null;
  }

  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {Object} The (possibly shimmed) rect of the element.
   */
  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
      // Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect();

    // Older IE
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {Object} The empty rect.
   */
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  /**
   * Inverts the intersection and bounding rect from the parent (frame) BCR to
   * the local BCR space.
   * @param {Object} parentBoundingRect The parent's bound client rect.
   * @param {Object} parentIntersectionRect The parent's own intersection rect.
   * @return {Object} The local root bounding rect for the parent's children.
   */
  function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
    var top = parentIntersectionRect.top - parentBoundingRect.top;
    var left = parentIntersectionRect.left - parentBoundingRect.left;
    return {
      top: top,
      left: left,
      height: parentIntersectionRect.height,
      width: parentIntersectionRect.width,
      bottom: top + parentIntersectionRect.height,
      right: left + parentIntersectionRect.width
    };
  }

  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent) return true;

      node = getParentNode(node);
    }
    return false;
  }

  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */
  function getParentNode(node) {
    var parent = node.parentNode;

    if (node.nodeType == /* DOCUMENT */9 && node != document) {
      // If this node is a document node, look for the embedding frame.
      return getFrameElement(node);
    }

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    if (parent && parent.assignedSlot) {
      // If the parent is distributed in a <slot>, return the parent of a slot.
      return parent.assignedSlot.parentNode;
    }

    return parent;
  }

  /**
   * Returns the embedding frame element, if any.
   * @param {!Document} doc
   * @return {!Element}
   */
  function getFrameElement(doc) {
    try {
      return doc.defaultView && doc.defaultView.frameElement || null;
    } catch (e) {
      // Ignore the error.
      return null;
    }
  }

  // Exposes the constructors globally.
  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

/***/ }),

/***/ "H0qN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */

module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
      return port !== 80;

    case 'https':
    case 'wss':
      return port !== 443;

    case 'ftp':
      return port !== 21;

    case 'gopher':
      return port !== 70;

    case 'file':
      return false;
  }

  return port !== 0;
};

/***/ }),

/***/ "H21C":
/***/ (function(module, exports) {

module.exports = false;

/***/ }),

/***/ "HNLv":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3UmM");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "HyuQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".dropdownContainer__2vB-C{opacity:0;pointer-events:none;visibility:hidden;-webkit-transform:translateY(-1.5em);transform:translateY(-1.5em);position:absolute;top:100%;right:0;z-index:1000;background:#fff;margin:.5em;-webkit-box-shadow:0 .5em 1em 0 rgba(0,0,0,.2),0 0 0 1px #eee;box-shadow:0 .5em 1em 0 rgba(0,0,0,.2),0 0 0 1px #eee;color:#000;-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out}@media screen and (max-width:40em){.dropdownContainer__2vB-C{-webkit-transform:translateY(30%);transform:translateY(30%);position:fixed;z-index:100000;bottom:-1px;right:0!important;left:0!important;top:auto;margin:0;-webkit-box-shadow:0 0 0 200em rgba(0,0,0,.5);box-shadow:0 0 0 200em rgba(0,0,0,.5);-webkit-box-shadow:0 0 0 200vmax rgba(0,0,0,.5);box-shadow:0 0 0 200vmax rgba(0,0,0,.5);height:calc(100vh - 6em)}}.open__QHsFV{opacity:1;pointer-events:all;visibility:visible;-webkit-transform:translateY(0);transform:translateY(0)}.ie__1WFww{display:-webkit-box;display:-ms-flexbox;display:flex;width:100vw;max-width:20em}@media screen and (max-width:40em){.ie__1WFww{max-width:none}}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/dropdown/C:/dev/globalTopBar/src/components/common/dropdown/C:/dev/globalTopBar/src/components/common/dropdown/styles.scss"],"names":[],"mappings":"AAAA,0BACE,UACA,oBACA,kBACA,qCAAA,6BACA,kBACA,SACA,QACA,aACA,gBACA,YACA,8DAAA,sDACA,WACA,uCAAA,8BAAgC,CAEhC,mCAfF,0BAgBI,kCAAA,0BACA,eACA,eACA,YACA,kBACA,iBACA,SACA,SACA,8CAAA,sCACA,gDAAA,wCACA,wBAAyB,CAE5B,CAED,aACE,UACA,mBACA,mBACA,gCAAA,uBAAwB,CACzB,WAGC,oBAAA,oBAAA,aACA,YACA,cAAe,CAEf,mCALF,WAMI,cAAkB,CAErB,CAAA","file":"styles.scss","sourcesContent":[".dropdownContainer {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n  transform: translateY(-1.5em);\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 1000;\n  background: white;\n  margin: .5em;\n  box-shadow: 0 0.5em 1em 0 rgba(0,0,0,.2), 0 0 0 1px #eee;\n  color: black;\n  transition: all 0.3s ease-in-out;\n\n  @media screen and (max-width: 40em){\n    transform: translateY(30%);\n    position: fixed;\n    z-index: 100000;\n    bottom: -1px;\n    right: 0 !important;\n    left: 0 !important;\n    top: auto;\n    margin: 0;\n    box-shadow: 0 0 0 200em rgba(0,0,0,0.5);\n    box-shadow: 0 0 0 200vmax rgba(0,0,0,0.5);\n    height: calc(100vh - 6em);\n  }\n}\n\n.open {\n  opacity: 1;\n  pointer-events: all;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.ie {\n  display: flex;\n  width: 100vw;\n  max-width: 20em;\n\n  @media screen and (max-width: 40em){\n    max-width: initial;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"dropdownContainer": "dropdownContainer__2vB-C",
	"open": "open__QHsFV",
	"ie": "ie__1WFww"
};

/***/ }),

/***/ "I6Kn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".notificationListItem__-aCnc{width:100%;border-radius:0;border-bottom:1px solid #eee;font-size:14px;line-height:1.2;word-break:break-word;text-decoration:none;color:#000!important}.notificationListItem__-aCnc:hover,.notificationListItem__-aCnc:visited .notificationListItem__-aCnc:link{text-decoration:none;color:inherit!important}a.notificationListItem__-aCnc:hover{background:#eee}.unread__22YmH{font-weight:700}.notificationInner__2bZAR{display:-webkit-box;display:-ms-flexbox;display:flex;gap:.5em;padding:1.5em 1em}.notificationColumnIcon__13TU9{-webkit-box-flex:0;-ms-flex:0 0 2em;flex:0 0 2em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.notificationColumnContent__3326h{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:.25rem;overflow:hidden}.notificationIcon__2gB9x{width:2em;height:2em;border-radius:12em;font-size:1em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;contain:strict}.notificationTitle__1xEPP{font-weight:700}.notificationFooter__1H38N{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-size:11px;text-align:right;text-transform:uppercase;letter-spacing:.025em;gap:1em}.notificationFooter__1H38N>*{white-space:nowrap;text-overflow:ellipsis;width:auto;overflow:hidden}.notificationFooter__1H38N>.module__3Lwpr{-ms-flex-negative:2;flex-shrink:2}.notificationFooter__1H38N>.date__xrOd2{-ms-flex-negative:0;flex-shrink:0}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notification-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notification-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notification-list-item/styles.scss"],"names":[],"mappings":"AAAA,6BACE,WACA,gBACA,6BACA,eACA,gBACA,sBACA,qBACA,oBAAuB,CARzB,0GAWI,qBACA,uBAAyB,CAC1B,oCAID,eAAgB,CACjB,eAGC,eAAiB,CAClB,0BAGC,oBAAA,oBAAA,aACA,SACA,iBAAkB,CACnB,+BAGC,mBAAA,iBAAA,aACA,oBAAA,oBAAA,aACA,wBAAA,qBAAA,sBAAuB,CACxB,kCAGC,mBAAA,kBAAA,cACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,WACA,eAAgB,CACjB,yBAGC,UACA,WAEA,mBACA,cACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,cAAe,CAChB,0BAGC,eAAiB,CAClB,2BAOC,oBAAA,oBAAA,aACA,yBAAA,sBAAA,8BACA,eACA,iBACA,yBACA,sBACA,OAAQ,CAPV,6BAUI,mBACA,uBACA,WACA,eAAgB,CAbpB,0CAiBI,oBAAA,aAAc,CAjBlB,wCAqBI,oBAAA,aAAc,CACf","file":"styles.scss","sourcesContent":[".notificationListItem {\n  width: 100%;\n  border-radius: 0;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n  line-height: 1.2;\n  word-break: break-word;\n  text-decoration: none;\n  color: black !important;\n\n  &:hover, &:visited &:link {\n    text-decoration: none;\n    color: inherit !important;\n  }\n}\n\na.notificationListItem:hover {\n  background: #eee;\n}\n\n.unread {\n  font-weight: bold;\n}\n\n.notificationInner {\n  display: flex;\n  gap: .5em;\n  padding: 1.5em 1em;\n}\n\n.notificationColumnIcon {\n  flex: 0 0 2em;\n  display: flex;\n  justify-content: center;\n}\n\n.notificationColumnContent {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  gap: .25rem;\n  overflow: hidden;\n}\n\n.notificationIcon {\n  width: 2em;\n  height: 2em;\n  //background: #eee;\n  border-radius: 12em;\n  font-size: 1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  contain: strict;\n}\n\n.notificationTitle {\n  font-weight: bold;\n}\n\n.notificationBody {\n\n}\n\n.notificationFooter {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  text-align: right;\n  text-transform: uppercase;\n  letter-spacing: .025em;\n  gap: 1em;\n\n  > * {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: auto;\n    overflow: hidden;\n  }\n\n  > .module {\n    flex-shrink: 2;\n  }\n\n  > .date {\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"notificationListItem": "notificationListItem__-aCnc",
	"unread": "unread__22YmH",
	"notificationInner": "notificationInner__2bZAR",
	"notificationColumnIcon": "notificationColumnIcon__13TU9",
	"notificationColumnContent": "notificationColumnContent__3326h",
	"notificationIcon": "notificationIcon__2gB9x",
	"notificationTitle": "notificationTitle__1xEPP",
	"notificationFooter": "notificationFooter__1H38N",
	"module": "module__3Lwpr",
	"date": "date__xrOd2"
};

/***/ }),

/***/ "IBtt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".row__2En7x{margin-bottom:.5em}.row__2En7x:last-child{margin-bottom:0}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/form-row/C:/dev/globalTopBar/src/components/common/form-row/C:/dev/globalTopBar/src/components/common/form-row/styles.scss"],"names":[],"mappings":"AAAA,YACE,kBAAmB,CADrB,uBAII,eAAgB,CACjB","file":"styles.scss","sourcesContent":[".row {\n  margin-bottom: .5em;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"row": "row__2En7x"
};

/***/ }),

/***/ "IN9r":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+bQV");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "IkSs":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5JoR");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "J0Tl":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("PHot");
module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }return target;
};

/***/ }),

/***/ "J6GP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),

/***/ "JCwR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__("nw8e");
var createDesc = __webpack_require__("uJ6d");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),

/***/ "JO4d":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "JRlJ":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__("izCb");
var gOPD = __webpack_require__("uIjZ").f;
var anObject = __webpack_require__("eT53");

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),

/***/ "JTrm":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("Z5df");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.array-buffer.js
var es6_typed_array_buffer = __webpack_require__("4NJ0");
var es6_typed_array_buffer_default = /*#__PURE__*/__webpack_require__.n(es6_typed_array_buffer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.int8-array.js
var es6_typed_int8_array = __webpack_require__("wqM+");
var es6_typed_int8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int8_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint8-array.js
var es6_typed_uint8_array = __webpack_require__("QTtY");
var es6_typed_uint8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js
var es6_typed_uint8_clamped_array = __webpack_require__("Kqgs");
var es6_typed_uint8_clamped_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_clamped_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.int16-array.js
var es6_typed_int16_array = __webpack_require__("fEGw");
var es6_typed_int16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int16_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint16-array.js
var es6_typed_uint16_array = __webpack_require__("xyd6");
var es6_typed_uint16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint16_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.int32-array.js
var es6_typed_int32_array = __webpack_require__("hIko");
var es6_typed_int32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int32_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint32-array.js
var es6_typed_uint32_array = __webpack_require__("tNPN");
var es6_typed_uint32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint32_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.float32-array.js
var es6_typed_float32_array = __webpack_require__("/wis");
var es6_typed_float32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float32_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.float64-array.js
var es6_typed_float64_array = __webpack_require__("9mbT");
var es6_typed_float64_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float64_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__("ioKM");
var es6_map_default = /*#__PURE__*/__webpack_require__.n(es6_map);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("coyu");
var es6_set_default = /*#__PURE__*/__webpack_require__.n(es6_set);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.weak-map.js
var es6_weak_map = __webpack_require__("D6DP");
var es6_weak_map_default = /*#__PURE__*/__webpack_require__.n(es6_weak_map);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.weak-set.js
var es6_weak_set = __webpack_require__("bRUR");
var es6_weak_set_default = /*#__PURE__*/__webpack_require__.n(es6_weak_set);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.apply.js
var es6_reflect_apply = __webpack_require__("F0Xu");
var es6_reflect_apply_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_apply);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.construct.js
var es6_reflect_construct = __webpack_require__("4JlF");
var es6_reflect_construct_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_construct);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.define-property.js
var es6_reflect_define_property = __webpack_require__("S841");
var es6_reflect_define_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_define_property);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.delete-property.js
var es6_reflect_delete_property = __webpack_require__("JRlJ");
var es6_reflect_delete_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_delete_property);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.get.js
var es6_reflect_get = __webpack_require__("kv8Z");
var es6_reflect_get_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js
var es6_reflect_get_own_property_descriptor = __webpack_require__("zj1X");
var es6_reflect_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_own_property_descriptor);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.get-prototype-of.js
var es6_reflect_get_prototype_of = __webpack_require__("d0aC");
var es6_reflect_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.has.js
var es6_reflect_has = __webpack_require__("OWTq");
var es6_reflect_has_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_has);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.is-extensible.js
var es6_reflect_is_extensible = __webpack_require__("deHu");
var es6_reflect_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_is_extensible);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.own-keys.js
var es6_reflect_own_keys = __webpack_require__("e6SV");
var es6_reflect_own_keys_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_own_keys);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.prevent-extensions.js
var es6_reflect_prevent_extensions = __webpack_require__("BmyK");
var es6_reflect_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_prevent_extensions);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.set.js
var es6_reflect_set = __webpack_require__("K46i");
var es6_reflect_set_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.set-prototype-of.js
var es6_reflect_set_prototype_of = __webpack_require__("L5z5");
var es6_reflect_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__("Pjta");
var es6_promise_default = /*#__PURE__*/__webpack_require__.n(es6_promise);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__("uVn9");
var es6_symbol_default = /*#__PURE__*/__webpack_require__.n(es6_symbol);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.freeze.js
var es6_object_freeze = __webpack_require__("EO7q");
var es6_object_freeze_default = /*#__PURE__*/__webpack_require__.n(es6_object_freeze);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.seal.js
var es6_object_seal = __webpack_require__("+4GY");
var es6_object_seal_default = /*#__PURE__*/__webpack_require__.n(es6_object_seal);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.prevent-extensions.js
var es6_object_prevent_extensions = __webpack_require__("3llM");
var es6_object_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_object_prevent_extensions);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is-frozen.js
var es6_object_is_frozen = __webpack_require__("Z1rp");
var es6_object_is_frozen_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_frozen);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is-sealed.js
var es6_object_is_sealed = __webpack_require__("Fckj");
var es6_object_is_sealed_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_sealed);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is-extensible.js
var es6_object_is_extensible = __webpack_require__("1EYb");
var es6_object_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_extensible);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js
var es6_object_get_own_property_descriptor = __webpack_require__("nIty");
var es6_object_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_descriptor);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.get-prototype-of.js
var es6_object_get_prototype_of = __webpack_require__("ud3u");
var es6_object_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("m9aB");
var es6_object_keys_default = /*#__PURE__*/__webpack_require__.n(es6_object_keys);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.get-own-property-names.js
var es6_object_get_own_property_names = __webpack_require__("i23/");
var es6_object_get_own_property_names_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_names);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("K3/J");
var es6_object_assign_default = /*#__PURE__*/__webpack_require__.n(es6_object_assign);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is.js
var es6_object_is = __webpack_require__("MlqR");
var es6_object_is_default = /*#__PURE__*/__webpack_require__.n(es6_object_is);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.set-prototype-of.js
var es6_object_set_prototype_of = __webpack_require__("0JGj");
var es6_object_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_set_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("N3yi");
var es6_function_name_default = /*#__PURE__*/__webpack_require__.n(es6_function_name);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.raw.js
var es6_string_raw = __webpack_require__("t2/9");
var es6_string_raw_default = /*#__PURE__*/__webpack_require__.n(es6_string_raw);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.from-code-point.js
var es6_string_from_code_point = __webpack_require__("xSM3");
var es6_string_from_code_point_default = /*#__PURE__*/__webpack_require__.n(es6_string_from_code_point);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.code-point-at.js
var es6_string_code_point_at = __webpack_require__("zR9y");
var es6_string_code_point_at_default = /*#__PURE__*/__webpack_require__.n(es6_string_code_point_at);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.repeat.js
var es6_string_repeat = __webpack_require__("C85R");
var es6_string_repeat_default = /*#__PURE__*/__webpack_require__.n(es6_string_repeat);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("w2SA");
var es6_string_starts_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_starts_with);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.ends-with.js
var es6_string_ends_with = __webpack_require__("zRn7");
var es6_string_ends_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_ends_with);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("fH7p");
var es6_string_includes_default = /*#__PURE__*/__webpack_require__.n(es6_string_includes);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.flags.js
var es6_regexp_flags = __webpack_require__("pDhD");
var es6_regexp_flags_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_flags);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__("RTfC");
var es6_regexp_match_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_match);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("KGao");
var es6_regexp_replace_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_replace);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("a/o/");
var es6_regexp_split_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_split);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.search.js
var es6_regexp_search = __webpack_require__("zOab");
var es6_regexp_search_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_search);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__("RRcs");
var es6_array_from_default = /*#__PURE__*/__webpack_require__.n(es6_array_from);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.of.js
var es6_array_of = __webpack_require__("RB6b");
var es6_array_of_default = /*#__PURE__*/__webpack_require__.n(es6_array_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.copy-within.js
var es6_array_copy_within = __webpack_require__("tWTB");
var es6_array_copy_within_default = /*#__PURE__*/__webpack_require__.n(es6_array_copy_within);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("Qppk");
var es6_array_find_default = /*#__PURE__*/__webpack_require__.n(es6_array_find);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__("7sVm");
var es6_array_find_index_default = /*#__PURE__*/__webpack_require__.n(es6_array_find_index);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__("hUQ6");
var es6_array_fill_default = /*#__PURE__*/__webpack_require__.n(es6_array_fill);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("6w+v");
var es6_array_iterator_default = /*#__PURE__*/__webpack_require__.n(es6_array_iterator);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-finite.js
var es6_number_is_finite = __webpack_require__("FuY7");
var es6_number_is_finite_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_finite);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-integer.js
var es6_number_is_integer = __webpack_require__("pwRL");
var es6_number_is_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-safe-integer.js
var es6_number_is_safe_integer = __webpack_require__("5qVI");
var es6_number_is_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_safe_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-nan.js
var es6_number_is_nan = __webpack_require__("SsgJ");
var es6_number_is_nan_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_nan);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.epsilon.js
var es6_number_epsilon = __webpack_require__("DzYy");
var es6_number_epsilon_default = /*#__PURE__*/__webpack_require__.n(es6_number_epsilon);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.min-safe-integer.js
var es6_number_min_safe_integer = __webpack_require__("+ifB");
var es6_number_min_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_min_safe_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.max-safe-integer.js
var es6_number_max_safe_integer = __webpack_require__("4shx");
var es6_number_max_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_max_safe_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.acosh.js
var es6_math_acosh = __webpack_require__("py3/");
var es6_math_acosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_acosh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.asinh.js
var es6_math_asinh = __webpack_require__("ob11");
var es6_math_asinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_asinh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.atanh.js
var es6_math_atanh = __webpack_require__("iUik");
var es6_math_atanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_atanh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.cbrt.js
var es6_math_cbrt = __webpack_require__("YRuK");
var es6_math_cbrt_default = /*#__PURE__*/__webpack_require__.n(es6_math_cbrt);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.clz32.js
var es6_math_clz32 = __webpack_require__("R2Qc");
var es6_math_clz32_default = /*#__PURE__*/__webpack_require__.n(es6_math_clz32);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.cosh.js
var es6_math_cosh = __webpack_require__("nEse");
var es6_math_cosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_cosh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.expm1.js
var es6_math_expm1 = __webpack_require__("AmoX");
var es6_math_expm1_default = /*#__PURE__*/__webpack_require__.n(es6_math_expm1);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.fround.js
var es6_math_fround = __webpack_require__("vmlq");
var es6_math_fround_default = /*#__PURE__*/__webpack_require__.n(es6_math_fround);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.hypot.js
var es6_math_hypot = __webpack_require__("kLut");
var es6_math_hypot_default = /*#__PURE__*/__webpack_require__.n(es6_math_hypot);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.imul.js
var es6_math_imul = __webpack_require__("A8J8");
var es6_math_imul_default = /*#__PURE__*/__webpack_require__.n(es6_math_imul);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.log1p.js
var es6_math_log1p = __webpack_require__("qtpC");
var es6_math_log1p_default = /*#__PURE__*/__webpack_require__.n(es6_math_log1p);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.log10.js
var es6_math_log10 = __webpack_require__("VUW8");
var es6_math_log10_default = /*#__PURE__*/__webpack_require__.n(es6_math_log10);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.log2.js
var es6_math_log2 = __webpack_require__("1Jo9");
var es6_math_log2_default = /*#__PURE__*/__webpack_require__.n(es6_math_log2);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.sign.js
var es6_math_sign = __webpack_require__("mZl9");
var es6_math_sign_default = /*#__PURE__*/__webpack_require__.n(es6_math_sign);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.sinh.js
var es6_math_sinh = __webpack_require__("m0zb");
var es6_math_sinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_sinh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.tanh.js
var es6_math_tanh = __webpack_require__("Fnqw");
var es6_math_tanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_tanh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.trunc.js
var es6_math_trunc = __webpack_require__("tiOR");
var es6_math_trunc_default = /*#__PURE__*/__webpack_require__.n(es6_math_trunc);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("TLss");
var es7_array_includes_default = /*#__PURE__*/__webpack_require__.n(es7_array_includes);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__("Ltmz");
var es7_object_values_default = /*#__PURE__*/__webpack_require__.n(es7_object_values);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__("gxEP");
var es7_object_entries_default = /*#__PURE__*/__webpack_require__.n(es7_object_entries);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("BQD8");
var es7_object_get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(es7_object_get_own_property_descriptors);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.string.pad-start.js
var es7_string_pad_start = __webpack_require__("9SWN");
var es7_string_pad_start_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_start);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.string.pad-end.js
var es7_string_pad_end = __webpack_require__("n20m");
var es7_string_pad_end_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_end);

// EXTERNAL MODULE: ../node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__("OTsy");
var web_timers_default = /*#__PURE__*/__webpack_require__.n(web_timers);

// EXTERNAL MODULE: ../node_modules/core-js/modules/web.immediate.js
var web_immediate = __webpack_require__("5hZL");
var web_immediate_default = /*#__PURE__*/__webpack_require__.n(web_immediate);

// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("v6Aj");
var web_dom_iterable_default = /*#__PURE__*/__webpack_require__.n(web_dom_iterable);

// EXTERNAL MODULE: ../node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__("GkNt");
var intersection_observer_default = /*#__PURE__*/__webpack_require__.n(intersection_observer);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// CONCATENATED MODULE: ../node_modules/preact-habitat/dist/preact-habitat.es.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Removes `-` fron a string and capetalize the letter after
 * example: data-props-hello-world =>  dataPropsHelloWorld
 * Used for props passed from host DOM element
 * @param  {String} str string
 * @return {String} Capetalized string
 */
var camelcasize = function camelcasize(str) {
  return str.replace(/-([a-z])/gi, function (all, letter) {
    return letter.toUpperCase();
  });
};

/**
 * [getExecutedScript internal widget to provide the currently executed script]
 * @param  {document} document [Browser document object]
 * @return {HTMLElement}     [script Element]
 */
var getExecutedScript = function getExecutedScript() {
  return document.currentScript || function () {
    var scripts = document.getElementsByTagName("script");
    return scripts[scripts.length - 1];
  }();
};

/**
 * Get the props from a host element's data attributes
 * @param  {Element} tag The host element
 * @return {Object}  props object to be passed to the component
 */
var collectPropsFromElement = function collectPropsFromElement(element, defaultProps) {
  if (defaultProps === void 0) defaultProps = {};

  var attrs = element.attributes;

  var props = _extends({}, defaultProps);

  // collect from element
  Object.keys(attrs).forEach(function (key) {
    if (attrs.hasOwnProperty(key)) {
      var dataAttrName = attrs[key].name;
      if (!dataAttrName || typeof dataAttrName !== "string") {
        return false;
      }
      var propName = dataAttrName.split(/(data-props?-)/).pop() || '';
      propName = camelcasize(propName);
      if (dataAttrName !== propName) {
        var propValue = attrs[key].nodeValue;
        props[propName] = propValue;
      }
    }
  });

  // check for child script text/props or application/json
  [].forEach.call(element.getElementsByTagName('script'), function (scrp) {
    var propsObj = {};
    if (scrp.hasAttribute('type')) {
      if (scrp.getAttribute("type") !== "text/props" && scrp.getAttribute("type") !== "application/json") {
        return;
      }
      try {
        propsObj = JSON.parse(scrp.innerHTML);
      } catch (e) {
        throw new Error(e);
      }
      _extends(props, propsObj);
    }
  });

  return props;
};

var getHabitatSelectorFromClient = function getHabitatSelectorFromClient(currentScript) {
  var scriptTagAttrs = currentScript.attributes;
  var selector = null;
  // check for another props attached to the tag
  Object.keys(scriptTagAttrs).forEach(function (key) {
    if (scriptTagAttrs.hasOwnProperty(key)) {
      var dataAttrName = scriptTagAttrs[key].name;
      if (dataAttrName === 'data-mount-in') {
        selector = scriptTagAttrs[key].nodeValue;
      }
    }
  });
  return selector;
};

/**
 * Return array of 0 or more elements that will host our widget
 * @param  {id} attrId the data widget id attribute the host should have
 * @param  {document} scope  Docuemnt object or DOM Element as a scope
 * @return {Array}        Array of matching habitats
 */
var widgetDOMHostElements = function widgetDOMHostElements(ref) {
  var selector = ref.selector;
  var inline = ref.inline;
  var clientSpecified = ref.clientSpecified;

  var hostNodes = [];
  var currentScript = getExecutedScript();

  if (inline === true) {
    var parentNode = currentScript.parentNode;
    hostNodes.push(parentNode);
  }
  if (clientSpecified === true && !selector) {
    // user did not specify where to mount - get it from script tag attributes
    selector = getHabitatSelectorFromClient(currentScript);
  }
  if (selector) {
    [].forEach.call(document.querySelectorAll(selector), function (queriedTag) {
      hostNodes.push(queriedTag);
    });
  }
  return hostNodes;
};

/**
 * preact render function that will be queued if the DOM is not ready
 * and executed immeidatly if DOM is ready
 */
var preact_habitat_es_preactRender = function preactRender(widget, hostElements, root, cleanRoot, defaultProps) {
  hostElements.forEach(function (elm) {
    var hostNode = elm;
    if (hostNode._habitat) {
      return;
    }
    hostNode._habitat = true;
    var props = collectPropsFromElement(elm, defaultProps) || defaultProps;
    if (cleanRoot) {
      hostNode.innerHTML = "";
    }
    return Object(preact_min["render"])(Object(preact_min["h"])(widget, props), hostNode, root);
  });
};

var habitat = function habitat(Widget) {
  // Widget represents the Preact component we need to mount
  var widget = Widget;
  // preact root render helper
  var root = null;

  var render$$1 = function render$$1(ref) {
    if (ref === void 0) ref = {};
    var selector = ref.selector;if (selector === void 0) selector = null;
    var inline = ref.inline;if (inline === void 0) inline = false;
    var clean = ref.clean;if (clean === void 0) clean = false;
    var clientSpecified = ref.clientSpecified;if (clientSpecified === void 0) clientSpecified = false;
    var defaultProps = ref.defaultProps;if (defaultProps === void 0) defaultProps = {};

    var elements = widgetDOMHostElements({
      selector: selector,
      inline: inline,
      clientSpecified: clientSpecified
    });
    var loaded = function loaded() {
      if (elements.length > 0) {
        var elements$1 = widgetDOMHostElements({
          selector: selector,
          inline: inline,
          clientSpecified: clientSpecified
        });

        return preact_habitat_es_preactRender(widget, elements$1, root, clean, defaultProps);
      }
    };
    loaded();
    document.addEventListener("DOMContentLoaded", loaded);
    document.addEventListener("load", loaded);
  };

  return { render: render$$1 };
};

/* harmony default export */ var preact_habitat_es = (habitat);
//# sourceMappingURL=preact-habitat.es.js.map
// EXTERNAL MODULE: ./components/layout/global-container/style.scss
var style = __webpack_require__("Sj4M");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/layout/global-container/style-reset.scss
var style_reset = __webpack_require__("twy8");
var style_reset_default = /*#__PURE__*/__webpack_require__.n(style_reset);

// EXTERNAL MODULE: ./components/layout/section-container/style.scss
var section_container_style = __webpack_require__("M12F");
var section_container_style_default = /*#__PURE__*/__webpack_require__.n(section_container_style);

// CONCATENATED MODULE: ./components/layout/section-container/index.js
var _class, section_container__temp;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var section_container_SectionContainer = (section_container__temp = _class = function (_Component) {
    _inherits(SectionContainer, _Component);

    function SectionContainer() {
        _classCallCheck(this, SectionContainer);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SectionContainer.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { className: section_container_style_default.a.sectionContainer, style: props.style },
            props.children
        );
    };

    return SectionContainer;
}(preact_min["Component"]), _class.defaultProps = {
    justifyContent: 'center',
    flex: 1
}, section_container__temp);

// EXTERNAL MODULE: ./components/sections/apps/app-list/style.scss
var app_list_style = __webpack_require__("HNLv");
var app_list_style_default = /*#__PURE__*/__webpack_require__.n(app_list_style);

// EXTERNAL MODULE: ./components/layout/section-component/styles.scss
var styles = __webpack_require__("nwv8");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// CONCATENATED MODULE: ./components/layout/section-component/index.js


function section_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function section_component__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function section_component__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var section_component_SectionComponent = function (_Component) {
    section_component__inherits(SectionComponent, _Component);

    function SectionComponent() {
        section_component__classCallCheck(this, SectionComponent);

        return section_component__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SectionComponent.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { "class": styles_default.a.sectionComponent, style: props.style },
            props.children
        );
    };

    return SectionComponent;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/common/toolbar-button/styles.scss
var toolbar_button_styles = __webpack_require__("jfh9");
var toolbar_button_styles_default = /*#__PURE__*/__webpack_require__.n(toolbar_button_styles);

// CONCATENATED MODULE: ./utilities/detectIE.js
function isIE() {
    return (/MSIE|Trident/.test(window.navigator.userAgent)
    );
}
// CONCATENATED MODULE: ./components/common/toolbar-button/index.js
var toolbar_button__class, toolbar_button__temp;



function toolbar_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function toolbar_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function toolbar_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var toolbar_button_ToolbarButton = (toolbar_button__temp = toolbar_button__class = function (_Component) {
    toolbar_button__inherits(ToolbarButton, _Component);

    function ToolbarButton() {
        toolbar_button__classCallCheck(this, ToolbarButton);

        return toolbar_button__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToolbarButton.prototype.render = function render(props, state, context) {
        var additionalClasses = [];
        if (props.type) props.type.split(' ').forEach(function (type) {
            return additionalClasses.push(toolbar_button_styles_default.a[type]);
        });
        if (props.class) additionalClasses.push(props.class);
        if (isIE()) additionalClasses.push(toolbar_button_styles_default.a.ie);
        if (props.disabled) additionalClasses.push(toolbar_button_styles_default.a.disabled);

        return Object(preact_min["h"])(
            "button",
            { type: "button",
                "class": [toolbar_button_styles_default.a.customButton].concat(additionalClasses).join(' '),
                style: props.style,
                onClick: !props.disabled && this.props.onClick,
                tabIndex: props.disabled ? -1 : 0,
                title: props.title,
                disabled: props.disabled
            },
            Object(preact_min["h"])(
                "span",
                null,
                props.children
            )
        );
    };

    return ToolbarButton;
}(preact_min["Component"]), toolbar_button__class.defaultProps = {
    type: '',
    style: {},
    disabled: false,
    title: ''
}, toolbar_button__temp);

// EXTERNAL MODULE: ./components/sections/apps/app-list-item/styles.scss
var app_list_item_styles = __webpack_require__("ljC3");
var app_list_item_styles_default = /*#__PURE__*/__webpack_require__.n(app_list_item_styles);

// EXTERNAL MODULE: ../node_modules/trkl/trkl-min.js
var trkl_min = __webpack_require__("+3wn");
var trkl_min_default = /*#__PURE__*/__webpack_require__.n(trkl_min);

// CONCATENATED MODULE: ./services/ConfigService.js
function ConfigService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ConfigService_ConfigStore = function ConfigStore() {
    ConfigService__classCallCheck(this, ConfigStore);

    this.modules = trkl_min_default()([]);
    this.localization = trkl_min_default()({});
    this.userProfile = trkl_min_default()({});
    this.domainActions = trkl_min_default()([]);
    this.currentAppKey = trkl_min_default()('extranet');
    this.organigrammaServerUrl = trkl_min_default()('');
    this.cdnConfiguration = trkl_min_default()({});

    this.navigateFunction = function (url) {
        return window.location = url;
    };

    this.manuals = trkl_min_default()([]);
    this.helpdeskUrl = trkl_min_default()('');
    this.homepageUrl = trkl_min_default()('');
    this.iconBaseUrl = trkl_min_default()('https://cdn.digitalpa.it/dpa-icons/v1');
    this.jwt = trkl_min_default()('');
    this.refreshToken = trkl_min_default()('');
    this.logoutRedirectUrl = trkl_min_default()('');

    this.logoutCallback = function () {};

    this.authFailureCallback = function () {};

    this.currentLanguage = trkl_min_default()('it');
    this.availableLanguages = trkl_min_default()(['it', 'en', 'es']);

    this.setCurrentLanguage = function () {};
}
// self


// context


// authentication


// localization
;

var ConfigService = new ConfigService_ConfigStore();
/* harmony default export */ var services_ConfigService = (ConfigService);
// EXTERNAL MODULE: ./assets/translations/it.json
var it = __webpack_require__("irmv");
var it_default = /*#__PURE__*/__webpack_require__.n(it);

// EXTERNAL MODULE: ./assets/translations/en.json
var en = __webpack_require__("Szfd");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./assets/translations/es.json
var es = __webpack_require__("35hU");
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// CONCATENATED MODULE: ./services/TranslateService.js
function TranslateService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var TranslateService_TranslationStore = function () {
    function TranslationStore() {
        TranslateService__classCallCheck(this, TranslationStore);

        this.translations = {
            it: it_default.a || {},
            en: en_default.a || {},
            es: es_default.a || {}
        };
    }

    TranslationStore.prototype.t = function t(key, language) {
        var lang = language || services_ConfigService.currentLanguage();

        if (this.translations[lang] && this.translations[lang][key]) {
            return this.translations[lang][key];
        } else return key;
    };

    TranslationStore.prototype.translatable = function translatable(item, language) {
        if (!item) return '';
        if (typeof item === 'string') return item;
        var lang = language || services_ConfigService.currentLanguage();
        return item[lang] || Object.values(item).length && Object.values(item)[0] || '';
    };

    return TranslationStore;
}();

var TranslateService = new TranslateService_TranslationStore();

function translate(key, language) {
    return TranslateService.t(key, language);
}
// CONCATENATED MODULE: ./services/CdnResourceResolverService.js
function CdnResourceResolverService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CdnResourceResolverService_CdnResourceResolverClass = function () {
    function CdnResourceResolverClass() {
        CdnResourceResolverService__classCallCheck(this, CdnResourceResolverClass);

        this.getCdnConfiguration = function () {
            return services_ConfigService.cdnConfiguration();
        };
    }

    CdnResourceResolverClass.prototype.getResource = function getResource(name, parameters) {
        var pattern = this.getPattern(name);
        if (pattern === null || !this.validate(pattern, parameters)) {
            return null;
        }

        return this.renderUrl(pattern, parameters);
    };

    CdnResourceResolverClass.prototype.renderUrl = function renderUrl(pattern, parameters) {
        var url = this.getCdnConfiguration().baseUrl + '/' + pattern.basePath + '/';

        var path = pattern.pathPattern.replace(/%[^%]+%/g, function (placeholder) {
            var parameter = placeholder.slice(1, -1);
            if (parameters.hasOwnProperty(parameter)) {
                return parameters[parameter];
            } else {
                return '';
            }
        });

        return url + path.replace(/[\/]{2,}/g, '/');
    };

    CdnResourceResolverClass.prototype.getPattern = function getPattern(name) {
        if (this.getCdnConfiguration().patterns.hasOwnProperty(name)) {
            return this.getCdnConfiguration().patterns[name];
        }

        return null;
    };

    CdnResourceResolverClass.prototype.validate = function validate(pattern, parameters) {
        for (var _iterator = pattern.required, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var field = _ref;

            if (!parameters.hasOwnProperty(field)) {
                console.error(field + ' \xE8 richiesto ma non impostato');
                return false;
            }
        }

        return true;
    };

    return CdnResourceResolverClass;
}();

var CdnResourceResolverService = new CdnResourceResolverService_CdnResourceResolverClass();
/* harmony default export */ var services_CdnResourceResolverService = (CdnResourceResolverService);
// CONCATENATED MODULE: ./services/ModuleLogoLinkProvider.js
function ModuleLogoLinkProvider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ModuleLogoLinkProvider_ModuleLogoLinkProviderClass = function () {
    function ModuleLogoLinkProviderClass() {
        ModuleLogoLinkProvider__classCallCheck(this, ModuleLogoLinkProviderClass);

        this.pattern = 'module-logo';
        this.allowedProperties = ['reverse'];
    }

    ModuleLogoLinkProviderClass.prototype.transform = function transform(moduleKey, extension) {
        var _this = this;

        var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var pattern = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.pattern;

        var parameters = { extension: extension };
        parameters.denomination = moduleKey;
        if (properties.length) parameters.properties = properties.filter(function (p) {
            return _this.allowedProperties.includes(p);
        }).sort().map(function (p) {
            return '-' + p;
        }).join('');
        return services_CdnResourceResolverService.getResource(pattern, parameters);
    };

    return ModuleLogoLinkProviderClass;
}();

var ModuleLogoLinkProvider = new ModuleLogoLinkProvider_ModuleLogoLinkProviderClass();
/* harmony default export */ var services_ModuleLogoLinkProvider = (ModuleLogoLinkProvider);
// CONCATENATED MODULE: ./components/sections/apps/app-list-item/index.js
var app_list_item__class, app_list_item__temp;



function app_list_item__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app_list_item__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app_list_item__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var app_list_item_AppListItem = (app_list_item__temp = app_list_item__class = function (_Component) {
    app_list_item__inherits(AppListItem, _Component);

    function AppListItem(props) {
        app_list_item__classCallCheck(this, AppListItem);

        var _this = app_list_item__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onImageError = function () {
            _this.setState({
                error: true
            });
        };

        _this.state = {
            error: false
        };
        return _this;
    }

    AppListItem.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var app = this.props.app;
        var name = TranslateService.translatable(app.denomination);
        var description = TranslateService.translatable(app.description);
        var link = app.urls.backend;
        var navigate = function navigate(event) {
            event.preventDefault();
            event.stopPropagation();
            services_ConfigService.navigateFunction(link);
        };

        var image = function image() {
            return _this2.state.error ? Object(preact_min["h"])("div", { "class": app_list_item_styles_default.a.appCardImageError }) : Object(preact_min["h"])("img", { src: services_ModuleLogoLinkProvider.transform(app.key, 'svg', [], 'module-pictogram-color'), alt: name, onError: _this2.onImageError });
        };

        return link ? Object(preact_min["h"])(
            "a",
            { href: link, "class": app_list_item_styles_default.a.appCard, onClick: navigate },
            Object(preact_min["h"])(
                "div",
                { "class": app_list_item_styles_default.a.appCardImage },
                image()
            ),
            Object(preact_min["h"])(
                "div",
                { "class": app_list_item_styles_default.a.body },
                Object(preact_min["h"])(
                    "div",
                    { "class": app_list_item_styles_default.a.name },
                    name
                ),
                Object(preact_min["h"])(
                    "div",
                    { "class": app_list_item_styles_default.a.description },
                    description
                )
            )
        ) : Object(preact_min["h"])(
            "a",
            { className: app_list_item_styles_default.a.appCard },
            Object(preact_min["h"])(
                "div",
                { className: app_list_item_styles_default.a.appCardImage },
                image()
            ),
            Object(preact_min["h"])(
                "div",
                { className: app_list_item_styles_default.a.body },
                Object(preact_min["h"])(
                    "div",
                    { className: app_list_item_styles_default.a.name },
                    name
                ),
                Object(preact_min["h"])(
                    "div",
                    { className: app_list_item_styles_default.a.description },
                    description
                )
            )
        );
    };

    return AppListItem;
}(preact_min["Component"]), app_list_item__class.defaultProps = {
    app: {}
}, app_list_item__temp);

// EXTERNAL MODULE: ./components/common/dropdown/styles.scss
var dropdown_styles = __webpack_require__("yW3h");
var dropdown_styles_default = /*#__PURE__*/__webpack_require__.n(dropdown_styles);

// CONCATENATED MODULE: ./components/common/dropdown/index.js
var dropdown__class, dropdown__temp;



function dropdown__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var dropdown_DropDownMenu = (dropdown__temp = dropdown__class = function (_Component) {
    dropdown__inherits(DropDownMenu, _Component);

    function DropDownMenu() {
        dropdown__classCallCheck(this, DropDownMenu);

        return dropdown__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DropDownMenu.prototype.componentDidUpdate = function componentDidUpdate(previousProps, previousState, previousContext) {
        var _this2 = this;

        if (previousProps.open === false && this.props.open === true) {
            // if (window.location.hash.length) {
            //     const url = window.location.href;
            //     url.replace(/#\S*/, '#' + Date.now());
            //     window.history.replaceState(window.history.state, null, url);
            // } else {
            //     window.location.hash = '#' + Date.now();
            // }
            setTimeout(function () {
                return window.addEventListener('popstate', _this2.props.closeFunction);
            });
        } else if (previousProps.open === true && this.props.open === false) {
            setTimeout(function () {
                return window.removeEventListener('popstate', _this2.props.closeFunction);
            });
        }
    };

    DropDownMenu.prototype.componentDidMount = function componentDidMount() {
        this.base.addEventListener('closeDropdown', this.props.closeFunction);
    };

    DropDownMenu.prototype.componentWillUnmount = function componentWillUnmount() {
        this.base.removeEventListener('closeDropdown', this.props.closeFunction);
    };

    DropDownMenu.prototype.render = function render(props, state, context) {
        var classes = [[dropdown_styles_default.a.dropdownContainer], props.class, props.open && isIE() ? [dropdown_styles_default.a.ie] : undefined, props.open ? [dropdown_styles_default.a.open] : undefined].filter(function (i) {
            return i;
        }).join(' ');

        return Object(preact_min["h"])(
            "div",
            { "class": classes, style: props.customStyle },
            props.children
        );
    };

    return DropDownMenu;
}(preact_min["Component"]), dropdown__class.defaultProps = {
    open: false,
    class: '',
    customStyle: {},
    closeFunction: function closeFunction() {}
}, dropdown__temp);

// CONCATENATED MODULE: ./utilities/outsideClick.js
function outsideClick(elements, eventHandler) {

    // Handle the click and fire the event handler if needed
    var handleClick = function handleClick(e) {
        for (var target = e.target; target; target = target.parentNode) {
            var found = elements.indexOf(target) > -1;
            if (found) return;
        }

        if (document.body.getBoundingClientRect().width < 641) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        eventHandler(e);
    };

    // Remove the event listeners
    var off = function off() {
        document.removeEventListener('click', handleClick, { capture: true });
    };

    // If just one element is passed in instead of an array, convert it
    if (!elements.indexOf) {
        elements = [elements];
    }

    document.addEventListener('click', handleClick, { capture: true });

    return {
        off: off
    };
};
// CONCATENATED MODULE: ./components/layout/outside-click-wrapper/index.js
var outside_click_wrapper__class, outside_click_wrapper__temp;

function outside_click_wrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function outside_click_wrapper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function outside_click_wrapper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var outside_click_wrapper_OutsideClickWrapper = (outside_click_wrapper__temp = outside_click_wrapper__class = function (_Component) {
    outside_click_wrapper__inherits(OutsideClickWrapper, _Component);

    function OutsideClickWrapper(props) {
        outside_click_wrapper__classCallCheck(this, OutsideClickWrapper);

        return outside_click_wrapper__possibleConstructorReturn(this, _Component.call(this, props));
    }

    OutsideClickWrapper.prototype.render = function render(props, state, context) {
        return props.children[0];
    };

    OutsideClickWrapper.prototype.componentDidUpdate = function componentDidUpdate(previousProps, previousState, previousContext) {
        var _this2 = this;

        if (!previousProps.watch && this.props.watch) {
            setTimeout(function () {
                _this2.watchOutsideClick();
            });
        } else if (previousProps.watch && !this.props.watch) {
            this.stopWatchingOutsideClick();
        }
    };

    OutsideClickWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
        this.stopWatchingOutsideClick();
    };

    OutsideClickWrapper.prototype.watchOutsideClick = function watchOutsideClick() {
        this.outsideClick = outsideClick(this.base, this.props.onOutsideClick);
    };

    OutsideClickWrapper.prototype.stopWatchingOutsideClick = function stopWatchingOutsideClick() {
        if (this.outsideClick) this.outsideClick.off();
    };

    return OutsideClickWrapper;
}(preact_min["Component"]), outside_click_wrapper__class.defaultProps = {
    watch: false,
    onOutsideClick: function onOutsideClick() {}
}, outside_click_wrapper__temp);
// EXTERNAL MODULE: ./components/layout/vertical-ui-container/styles.scss
var vertical_ui_container_styles = __webpack_require__("IN9r");
var vertical_ui_container_styles_default = /*#__PURE__*/__webpack_require__.n(vertical_ui_container_styles);

// CONCATENATED MODULE: ./components/layout/vertical-ui-container/index.js


function vertical_ui_container__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function vertical_ui_container__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function vertical_ui_container__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var vertical_ui_container_VerticalUiContainer = function (_Component) {
    vertical_ui_container__inherits(VerticalUiContainer, _Component);

    function VerticalUiContainer() {
        vertical_ui_container__classCallCheck(this, VerticalUiContainer);

        return vertical_ui_container__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    VerticalUiContainer.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { "class": vertical_ui_container_styles_default.a.uiContainer, style: props.style },
            props.children
        );
    };

    return VerticalUiContainer;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/layout/scrollable-section/styles.scss
var scrollable_section_styles = __webpack_require__("Bdam");
var scrollable_section_styles_default = /*#__PURE__*/__webpack_require__.n(scrollable_section_styles);

// CONCATENATED MODULE: ./components/layout/scrollable-section/index.js
var scrollable_section__class, scrollable_section__temp;



function scrollable_section__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function scrollable_section__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function scrollable_section__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var scrollable_section_ScrollableSection = (scrollable_section__temp = scrollable_section__class = function (_Component) {
    scrollable_section__inherits(ScrollableSection, _Component);

    function ScrollableSection(props) {
        scrollable_section__classCallCheck(this, ScrollableSection);

        var _this = scrollable_section__possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidUpdate = function () {
            if (_this.state.area === null) {
                _this.onScroll();
            }
        };

        _this.ref = Object(preact_min["createRef"])();

        _this.onScroll = function () {
            var area = _this.calcArea();
            if (area !== _this.state.area) {
                _this.setState({ area: area });
                _this.props.onAreaChange(area);
            }
        };

        _this.calcArea = function () {
            var el = _this.ref.current;
            var maxScroll = el.scrollHeight - el.offsetHeight;
            var scrollPos = el.scrollTop;

            if (scrollPos === 0) return 'top';else if (scrollPos === maxScroll) return 'bottom';else if (scrollPos < _this.props.scrollTreshold) return 'top';else if (scrollPos > maxScroll - _this.props.scrollTreshold) return 'bottom';else return 'middle';
        };

        _this.state = {
            area: null
        };
        return _this;
    }

    ScrollableSection.prototype.render = function render(props, state, context) {
        var classes = [scrollable_section_styles_default.a.scrollableContainer, props.class].filter(function (i) {
            return i;
        }).join(' ');

        return Object(preact_min["h"])(
            'div',
            { 'class': classes, ref: this.ref, style: props.style, onScroll: this.onScroll },
            props.children
        );
    };

    ScrollableSection.prototype.scrollBottom = function scrollBottom() {
        var el = this.ref.current;
        return el.scrollHeight - el.scrollTop;
    };

    ScrollableSection.prototype.scrollFromBottom = function scrollFromBottom(value) {
        var el = this.ref.current;
        el.scrollTop = el.scrollHeight - value;
    };

    return ScrollableSection;
}(preact_min["Component"]), scrollable_section__class.defaultProps = {
    scrollTreshold: 50,
    onAreaChange: function onAreaChange() {}
}, scrollable_section__temp);

// EXTERNAL MODULE: ../node_modules/mdi-preact/AppsIcon.js
var AppsIcon = __webpack_require__("4bJO");
var AppsIcon_default = /*#__PURE__*/__webpack_require__.n(AppsIcon);

// EXTERNAL MODULE: ./components/layout/toolbar/styles.scss
var toolbar_styles = __webpack_require__("PFYP");
var toolbar_styles_default = /*#__PURE__*/__webpack_require__.n(toolbar_styles);

// CONCATENATED MODULE: ./components/layout/toolbar/index.js


function toolbar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function toolbar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function toolbar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var toolbar_Toolbar = function (_Component) {
    toolbar__inherits(Toolbar, _Component);

    function Toolbar() {
        toolbar__classCallCheck(this, Toolbar);

        return toolbar__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Toolbar.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            'div',
            { 'class': [toolbar_styles_default.a.toolbarContainer, props.class].filter(function (i) {
                    return i;
                }).join(' '), style: props.style },
            props.children
        );
    };

    return Toolbar;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/layout/toolbar-title/styles.scss
var toolbar_title_styles = __webpack_require__("a0xl");
var toolbar_title_styles_default = /*#__PURE__*/__webpack_require__.n(toolbar_title_styles);

// CONCATENATED MODULE: ./components/layout/toolbar-title/index.js


function toolbar_title__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function toolbar_title__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function toolbar_title__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var toolbar_title_ToolbarTitle = function (_Component) {
    toolbar_title__inherits(ToolbarTitle, _Component);

    function ToolbarTitle() {
        toolbar_title__classCallCheck(this, ToolbarTitle);

        return toolbar_title__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToolbarTitle.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { "class": toolbar_title_styles_default.a.toolbarTitle },
            props.children
        );
    };

    return ToolbarTitle;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/common/text/index.js
var text__class, _temp2;

function text__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function text__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function text__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var text_Text = (_temp2 = text__class = function (_Component) {
    text__inherits(Text, _Component);

    function Text() {
        var _temp, _this, _ret;

        text__classCallCheck(this, Text);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = text__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateText = function () {
            _this.forceUpdate();
        }, _temp), text__possibleConstructorReturn(_this, _ret);
    }

    Text.prototype.componentDidMount = function componentDidMount() {
        services_ConfigService.currentLanguage.subscribe(this.updateText);
    };

    Text.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ConfigService.currentLanguage.unsubscribe(this.updateText);
    };

    Text.prototype.render = function render(props, state, context) {
        return props.text ? translate(props.text) : props.translatable ? TranslateService.translatable(props.translatable) : '';
    };

    return Text;
}(preact_min["Component"]), text__class.defaultProps = {
    text: null,
    translatable: null
}, _temp2);

// EXTERNAL MODULE: ../node_modules/url-parse/index.js
var url_parse = __webpack_require__("xKrr");
var url_parse_default = /*#__PURE__*/__webpack_require__.n(url_parse);

// EXTERNAL MODULE: ../node_modules/urljoin/index.js
var urljoin = __webpack_require__("kG2B");
var urljoin_default = /*#__PURE__*/__webpack_require__.n(urljoin);

// CONCATENATED MODULE: ./utilities/url.js



var utilities_url_parse = function parse(url) {
    return new url_parse_default.a(url);
};

/**
 * @returns {String}
 * @param urls {string[]}
 */
var url_join = function join(urls) {
    return urljoin_default.a.apply(undefined, urls);
};
// EXTERNAL MODULE: ../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__("3dZY");
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);

// CONCATENATED MODULE: ./services/ModuleInfoProvider.js
function ModuleInfoProvider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ModuleInfoProvider_ModuleInfoProviderClass = function () {
    function ModuleInfoProviderClass() {
        ModuleInfoProvider__classCallCheck(this, ModuleInfoProviderClass);

        this.enabled = {};
    }

    ModuleInfoProviderClass.prototype.createFlatModuleArray = function createFlatModuleArray(modules) {
        var _this = this;

        var filteredApps = [];
        modules.forEach(function (module) {
            filteredApps.push(module);
            if (module.modules.length) filteredApps.push.apply(filteredApps, _this.createFlatModuleArray(module.modules));
        });
        return filteredApps;
    };

    ModuleInfoProviderClass.prototype.getModule = function getModule(key) {
        return services_ConfigService.modules().find(function (m) {
            return m.key === key;
        });
    };

    ModuleInfoProviderClass.prototype.getModuleByReference = function getModuleByReference(reference) {
        var parts = (reference || '').split('/');
        return this.getModule(parts[parts.length - 1]);
    };

    ModuleInfoProviderClass.prototype.getModuleBaseUrl = function getModuleBaseUrl(key, urlKey) {
        var module = this.getModule(key);
        var url = utilities_url_parse(module.urls[urlKey]);
        url.pathname = '';
        return url.toString(null);
    };

    ModuleInfoProviderClass.prototype.getModuleWebServiceUrl = function getModuleWebServiceUrl(key) {
        var module = this.getModule(key);
        return module.urls['ws'];
    };

    ModuleInfoProviderClass.prototype.getModuleBackendUrl = function getModuleBackendUrl(key) {
        var module = this.getModule(key);
        return module.urls['backend'];
    };

    ModuleInfoProviderClass.prototype.isEnabled = function isEnabled(key) {
        if (this.enabled.hasOwnProperty(key)) return this.enabled[key];
        var module = this.getModule(key);
        if (!module) return false;
        if (!module['purchased']) return false;
        var start = dayjs_min_default()(module['license']['startDate']).set('hour', 0).set('minute', 0).set('second', 0);
        var end = dayjs_min_default()(module['license']['endDate']).set('hour', 23).set('minute', 59).set('second', 59);
        var now = dayjs_min_default()();
        var readOnlyDeadline = now.clone().add(module['license']['readOnlyDuration'] || 0, 'day');
        var readOnly = now.isAfter(end) && now.isBefore(readOnlyDeadline);
        var enabled = now.isAfter(start) && now.isBefore(end) || readOnly;
        this.enabled[key] = enabled;
        return enabled;
    };

    return ModuleInfoProviderClass;
}();

var ModuleInfoProvider = new ModuleInfoProvider_ModuleInfoProviderClass();
/* harmony default export */ var services_ModuleInfoProvider = (ModuleInfoProvider);
// CONCATENATED MODULE: ./components/sections/apps/app-list/index.js
var app_list__class, app_list__temp;



function app_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var app_list__ref2 = Object(preact_min["h"])(AppsIcon_default.a, null);

var _ref3 = Object(preact_min["h"])(AppsIcon_default.a, null);

var _ref4 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'app.list.title' })
);

var app_list_OrganigrammaAppList = (app_list__temp = app_list__class = function (_Component) {
    app_list__inherits(OrganigrammaAppList, _Component);

    function OrganigrammaAppList(props) {
        app_list__classCallCheck(this, OrganigrammaAppList);

        var _this = app_list__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onLogoError = function () {
            _this.setState({
                logoError: true
            });
        };

        _this.toggleMenu = function () {
            _this.setState({ open: !_this.state.open });
        };

        _this.navigateToHomePage = function () {
            services_ConfigService.navigateFunction(services_ConfigService.homepageUrl());
        };

        _this.state = {
            open: false,
            logoError: false
        };
        return _this;
    }

    OrganigrammaAppList.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var apps = this.getSortedAreaApps(this.props.apps);
        var currentAppName = TranslateService.translatable(props.currentApp.denomination);
        var buttonStyles = this.state.open ? { background: '#0079B8' } : {};

        var _ref = Object(preact_min["h"])(
            "span",
            null,
            currentAppName
        );

        var logo = function logo() {
            return _this2.state.logoError ? _ref : Object(preact_min["h"])("img", { "class": app_list_style_default.a.buttonImage,
                src: services_ModuleLogoLinkProvider.transform(_this2.props.currentApp.key, 'svg', [], 'module-logo-reverse'),
                alt: currentAppName,
                onError: _this2.onLogoError
            });
        };

        return Object(preact_min["h"])(
            section_component_SectionComponent,
            null,
            Object(preact_min["h"])(
                outside_click_wrapper_OutsideClickWrapper,
                { watch: this.state.open, onOutsideClick: this.toggleMenu },
                Object(preact_min["h"])(
                    "div",
                    { style: { height: '100%' } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.toggleMenu, title: translate('app.list.title'), style: buttonStyles },
                        app_list__ref2
                    ),
                    Object(preact_min["h"])(
                        dropdown_DropDownMenu,
                        { open: this.state.open, "class": app_list_style_default.a.dropdownMenu, closeFunction: this.toggleMenu },
                        Object(preact_min["h"])(
                            vertical_ui_container_VerticalUiContainer,
                            null,
                            Object(preact_min["h"])(
                                toolbar_Toolbar,
                                { "class": app_list_style_default.a.toolbar },
                                Object(preact_min["h"])(
                                    "div",
                                    { "class": app_list_style_default.a.iconButton },
                                    _ref3
                                ),
                                _ref4
                            ),
                            Object(preact_min["h"])(
                                scrollable_section_ScrollableSection,
                                { style: { paddingBottom: '.5em' } },
                                apps.map(function (a) {
                                    return Object(preact_min["h"])(app_list_item_AppListItem, { app: a });
                                })
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                toolbar_button_ToolbarButton,
                { onClick: this.navigateToHomePage, "class": app_list_style_default.a.logoButton },
                logo()
            )
        );
    };

    OrganigrammaAppList.prototype.getSortedAreaApps = function getSortedAreaApps(apps) {
        var filteredApps = apps.filter(function (app) {
            return app.tags.includes('area') && app.urls.hasOwnProperty('backend') && services_ModuleInfoProvider.isEnabled(app.key);
        });
        return filteredApps.sort(function (a, b) {
            if (a.position < b.position) return -1;
            if (a.position > b.position) return 1;else return 0;
        });
    };

    return OrganigrammaAppList;
}(preact_min["Component"]), app_list__class.defaultProps = {
    currentApp: {},
    apps: []
}, app_list__temp);

// EXTERNAL MODULE: ./components/common/spinner/style.scss
var spinner_style = __webpack_require__("Dt0g");
var spinner_style_default = /*#__PURE__*/__webpack_require__.n(spinner_style);

// CONCATENATED MODULE: ./components/common/spinner/index.js


function spinner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function spinner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function spinner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var spinner_Spinner = function (_Component) {
    spinner__inherits(Spinner, _Component);

    function Spinner() {
        spinner__classCallCheck(this, Spinner);

        return spinner__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Spinner.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])("div", { "class": spinner_style_default.a.spinner });
    };

    return Spinner;
}(preact_min["Component"]);


// CONCATENATED MODULE: ../node_modules/whatwg-fetch/fetch.js
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob: 'FileReader' in self && 'Blob' in self && function () {
    try {
      new Blob();
      return true;
    } catch (e) {
      return false;
    }
  }(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
};

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj);
}

if (support.arrayBuffer) {
  var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

  var isArrayBufferView = ArrayBuffer.isView || function (obj) {
    return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
  };
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name);
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name');
  }
  return name.toLowerCase();
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }
  return value;
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function next() {
      var value = items.shift();
      return { done: value === undefined, value: value };
    }
  };

  if (support.iterable) {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}

function Headers(headers) {
  this.map = {};

  if (headers instanceof Headers) {
    headers.forEach(function (value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function (header) {
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function (name) {
      this.append(name, headers[name]);
    }, this);
  }
}

Headers.prototype.append = function (name, value) {
  name = normalizeName(name);
  value = normalizeValue(value);
  var oldValue = this.map[name];
  this.map[name] = oldValue ? oldValue + ', ' + value : value;
};

Headers.prototype['delete'] = function (name) {
  delete this.map[normalizeName(name)];
};

Headers.prototype.get = function (name) {
  name = normalizeName(name);
  return this.has(name) ? this.map[name] : null;
};

Headers.prototype.has = function (name) {
  return this.map.hasOwnProperty(normalizeName(name));
};

Headers.prototype.set = function (name, value) {
  this.map[normalizeName(name)] = normalizeValue(value);
};

Headers.prototype.forEach = function (callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this);
    }
  }
};

Headers.prototype.keys = function () {
  var items = [];
  this.forEach(function (value, name) {
    items.push(name);
  });
  return iteratorFor(items);
};

Headers.prototype.values = function () {
  var items = [];
  this.forEach(function (value) {
    items.push(value);
  });
  return iteratorFor(items);
};

Headers.prototype.entries = function () {
  var items = [];
  this.forEach(function (value, name) {
    items.push([name, value]);
  });
  return iteratorFor(items);
};

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'));
  }
  body.bodyUsed = true;
}

function fileReaderReady(reader) {
  return new Promise(function (resolve, reject) {
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function () {
      reject(reader.error);
    };
  });
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise;
}

function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsText(blob);
  return promise;
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }
  return chars.join('');
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0);
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer;
  }
}

function Body() {
  this.bodyUsed = false;

  this._initBody = function (body) {
    this._bodyInit = body;
    if (!body) {
      this._bodyText = '';
    } else if (typeof body === 'string') {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer);
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8');
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      }
    }
  };

  if (support.blob) {
    this.blob = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob');
      } else {
        return Promise.resolve(new Blob([this._bodyText]));
      }
    };

    this.arrayBuffer = function () {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
      } else {
        return this.blob().then(readBlobAsArrayBuffer);
      }
    };
  }

  this.text = function () {
    var rejected = consumed(this);
    if (rejected) {
      return rejected;
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob);
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text');
    } else {
      return Promise.resolve(this._bodyText);
    }
  };

  if (support.formData) {
    this.formData = function () {
      return this.text().then(decode);
    };
  }

  this.json = function () {
    return this.text().then(JSON.parse);
  };

  return this;
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method;
}

function Request(input, options) {
  options = options || {};
  var body = options.body;

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read');
    }
    this.url = input.url;
    this.credentials = input.credentials;
    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }
    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;
    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }

  this.credentials = options.credentials || this.credentials || 'same-origin';
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }
  this.method = normalizeMethod(options.method || this.method || 'GET');
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal;
  this.referrer = null;

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests');
  }
  this._initBody(body);
}

Request.prototype.clone = function () {
  return new Request(this, { body: this._bodyInit });
};

function decode(body) {
  var form = new FormData();
  body.trim().split('&').forEach(function (bytes) {
    if (bytes) {
      var split = bytes.split('=');
      var name = split.shift().replace(/\+/g, ' ');
      var value = split.join('=').replace(/\+/g, ' ');
      form.append(decodeURIComponent(name), decodeURIComponent(value));
    }
  });
  return form;
}

function parseHeaders(rawHeaders) {
  var headers = new Headers();
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
  preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
    var parts = line.split(':');
    var key = parts.shift().trim();
    if (key) {
      var value = parts.join(':').trim();
      headers.append(key, value);
    }
  });
  return headers;
}

Body.call(Request.prototype);

function Response(bodyInit, options) {
  if (!options) {
    options = {};
  }

  this.type = 'default';
  this.status = options.status === undefined ? 200 : options.status;
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = 'statusText' in options ? options.statusText : 'OK';
  this.headers = new Headers(options.headers);
  this.url = options.url || '';
  this._initBody(bodyInit);
}

Body.call(Response.prototype);

Response.prototype.clone = function () {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  });
};

Response.error = function () {
  var response = new Response(null, { status: 0, statusText: '' });
  response.type = 'error';
  return response;
};

var redirectStatuses = [301, 302, 303, 307, 308];

Response.redirect = function (url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code');
  }

  return new Response(null, { status: status, headers: { location: url } });
};

var DOMException = self.DOMException;
try {
  new DOMException();
} catch (err) {
  DOMException = function DOMException(message, name) {
    this.message = message;
    this.name = name;
    var error = Error(message);
    this.stack = error.stack;
  };
  DOMException.prototype = Object.create(Error.prototype);
  DOMException.prototype.constructor = DOMException;
}

function fetch_fetch(input, init) {
  return new Promise(function (resolve, reject) {
    var request = new Request(input, init);

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'));
    }

    var xhr = new XMLHttpRequest();

    function abortXhr() {
      xhr.abort();
    }

    xhr.onload = function () {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      };
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
      var body = 'response' in xhr ? xhr.response : xhr.responseText;
      resolve(new Response(body, options));
    };

    xhr.onerror = function () {
      reject(new TypeError('Network request failed'));
    };

    xhr.ontimeout = function () {
      reject(new TypeError('Network request failed'));
    };

    xhr.onabort = function () {
      reject(new DOMException('Aborted', 'AbortError'));
    };

    xhr.open(request.method, request.url, true);

    if (request.credentials === 'include') {
      xhr.withCredentials = true;
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false;
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob';
    }

    request.headers.forEach(function (value, name) {
      xhr.setRequestHeader(name, value);
    });

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr);

      xhr.onreadystatechange = function () {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr);
        }
      };
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
  });
}

fetch_fetch.polyfill = true;

if (!self.fetch) {
  self.fetch = fetch_fetch;
  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;
}
// CONCATENATED MODULE: ./services/CallbackService.js
function execute(functionOrPromise, callback) {
    var result = functionOrPromise();
    if (result && result.then) {
        return result.then(callback);
    } else {
        return callback();
    }
}
// CONCATENATED MODULE: ./services/JWTClient.js
var JWTClient__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function JWTClient__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var JWTClient_Client = function () {
    function Client() {
        JWTClient__classCallCheck(this, Client);
    }

    Client.prototype.fetch = function fetch() {
        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        var _this = this;

        var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var retry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var options = fetchOptions || {};
        var jwt = services_ConfigService.jwt();
        var headers = { Authorization: 'Bearer ' + jwt };
        var presetHeaders = options.headers || {};
        options.headers = JWTClient__extends(presetHeaders, headers);

        return fetch_fetch(url, options).then(function (res) {
            if (res.ok) {
                return res.json();
            } else {
                if (res.status === 401 && retry) {
                    return execute(services_ConfigService.authFailureCallback, function () {
                        return _this.fetch(url, fetchOptions, false);
                    });
                } else {
                    throw Error('Connection error');
                }
            }
        }).then(function (json) {
            return json;
        });
    };

    return Client;
}();

var JWTClient = new JWTClient_Client();
/* harmony default export */ var services_JWTClient = (JWTClient);
// EXTERNAL MODULE: ../node_modules/mdi-preact/BellIcon.js
var BellIcon = __webpack_require__("RGSg");
var BellIcon_default = /*#__PURE__*/__webpack_require__.n(BellIcon);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/notification/notifications-button/styles.scss
var notifications_button_styles = __webpack_require__("bFYF");
var notifications_button_styles_default = /*#__PURE__*/__webpack_require__.n(notifications_button_styles);

// CONCATENATED MODULE: ./services/JsonApiDeserializer.js
function JsonApiDeserializer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JsonApiDeserializerClass = function () {
    function JsonApiDeserializerClass() {
        JsonApiDeserializer__classCallCheck(this, JsonApiDeserializerClass);
    }

    JsonApiDeserializerClass.prototype.deserializeItems = function deserializeItems(data, includedEntities) {
        var _this = this;

        var allData = data.concat(includedEntities).filter(function (v) {
            return v;
        });
        var entityMap = {};
        this.createEntities(allData, entityMap);
        this.connectRelationships(allData, entityMap);
        return data.map(function (item) {
            return _this.getEntity(item, entityMap);
        });
    };

    JsonApiDeserializerClass.prototype.deserializeItem = function deserializeItem(item, includedEntities) {
        return this.deserializeItems([item], includedEntities)[0];
    };

    JsonApiDeserializerClass.prototype.createEntities = function createEntities(items, entityMap) {
        for (var _iterator = items, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var item = _ref;

            var entity = this.parseSerializedItem(item);
            if (entity) {
                var id = this.createEntityId(item);
                entityMap[id] = entity;
            }
        }
    };

    JsonApiDeserializerClass.prototype.parseSerializedItem = function parseSerializedItem(item) {
        var object = item.attributes;
        object.id = item.id;
        return object;
    };

    JsonApiDeserializerClass.prototype.connectRelationships = function connectRelationships(items, entityMap) {
        var _this2 = this;

        var _loop = function _loop(item) {
            if (item.hasOwnProperty('relationships')) {
                Object.keys(item.relationships).forEach(function (relationshipName) {
                    var relationship = item.relationships[relationshipName];

                    if (Array.isArray(relationship.data)) {
                        var relatedEntities = [];
                        var relatedIdentifiers = relationship.data;
                        for (var _iterator3 = relatedIdentifiers, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                            var _ref3;

                            if (_isArray3) {
                                if (_i3 >= _iterator3.length) break;
                                _ref3 = _iterator3[_i3++];
                            } else {
                                _i3 = _iterator3.next();
                                if (_i3.done) break;
                                _ref3 = _i3.value;
                            }

                            var identifier = _ref3;

                            if (_this2.hasEntity(identifier, entityMap)) {
                                relatedEntities.push(_this2.getEntity(identifier, entityMap));
                            }
                        }
                        _this2.setOnEntity(item, entityMap, relationshipName, relatedEntities);
                    } else {
                        if (relationship.data) {
                            var relatedEntity = _this2.getEntity(relationship.data, entityMap);
                            _this2.setOnEntity(item, entityMap, relationshipName, relatedEntity);
                        }
                    }
                });
            }
        };

        for (var _iterator2 = items, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var item = _ref2;

            _loop(item);
        }
    };

    JsonApiDeserializerClass.prototype.createEntityId = function createEntityId(item) {
        return [item.type, item.id].join('.');
    };

    JsonApiDeserializerClass.prototype.getEntity = function getEntity(id, entityMap) {
        return entityMap[this.createEntityId(id)];
    };

    JsonApiDeserializerClass.prototype.hasEntity = function hasEntity(id, entityMap) {
        var entityId = this.createEntityId(id);
        return entityMap.hasOwnProperty(entityId) && entityMap[entityId];
    };

    JsonApiDeserializerClass.prototype.setOnEntity = function setOnEntity(id, entityMap, property, value) {
        if (this.hasEntity(id, entityMap)) {
            this.getEntity(id, entityMap)[property] = value;
        }
    };

    return JsonApiDeserializerClass;
}();

var JsonApiDeserializer = new JsonApiDeserializerClass();
/* harmony default export */ var services_JsonApiDeserializer = (JsonApiDeserializer);
// CONCATENATED MODULE: ./utilities/list-manager.js
function list_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var list_manager_ListManager = function ListManager() {
    var _this = this;

    list_manager__classCallCheck(this, ListManager);

    this.list = [];
    this.loadingPrev = false;
    this.errorPrev = true;
    this.loadingNext = false;
    this.errorNext = true;
    this.reachedLimit = false;

    this.getPrevRequest = function () {
        return new Promise(function (resolve, reject) {});
    };

    this.getNextRequest = function () {
        return new Promise(function (resolve, reject) {});
    };

    this.getPrev = function () {
        _this.loadingPrev = true;
        _this.errorPrev = false;

        return _this.getPrevRequest().then(function (res) {
            var _list;

            var items = services_JsonApiDeserializer.deserializeItems(res.data, res.included);
            (_list = _this.list).unshift.apply(_list, items);
            _this.loadingPrev = false;
            return items;
        }).catch(function (e) {
            console.log(e);
            _this.loadingPrev = false;
            _this.errorPrev = true;
            return e;
        });
    };

    this.getNext = function () {
        if (_this.reachedLimit) return new Promise(function (resolve, reject) {
            return [];
        });

        _this.loadingNext = true;
        _this.errorNext = false;

        return _this.getNextRequest().then(function (res) {
            var _list2;

            var items = services_JsonApiDeserializer.deserializeItems(res.data, res.included);
            (_list2 = _this.list).push.apply(_list2, items);
            _this.loadingNext = false;
            _this.reachedLimit = res.meta.pagination.total_pages === res.meta.pagination.current_page;
            return items;
        }).catch(function (e) {
            console.log(e);
            _this.errorNext = true;
            _this.loadingNext = false;
            return e;
        });
    };
};
// EXTERNAL MODULE: ./components/common/backdrop-cover/styles.scss
var backdrop_cover_styles = __webpack_require__("uDeg");
var backdrop_cover_styles_default = /*#__PURE__*/__webpack_require__.n(backdrop_cover_styles);

// CONCATENATED MODULE: ./components/common/backdrop-cover/index.js


function backdrop_cover__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function backdrop_cover__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function backdrop_cover__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var backdrop_cover_BackdropCover = function (_Component) {
    backdrop_cover__inherits(BackdropCover, _Component);

    function BackdropCover() {
        backdrop_cover__classCallCheck(this, BackdropCover);

        return backdrop_cover__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    BackdropCover.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { "class": backdrop_cover_styles_default.a.cover, onClick: function onClick() {
                    return false;
                } },
            props.children
        );
    };

    return BackdropCover;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/mdi-preact/DotsHorizontalIcon.js
var DotsHorizontalIcon = __webpack_require__("K8tU");
var DotsHorizontalIcon_default = /*#__PURE__*/__webpack_require__.n(DotsHorizontalIcon);

// EXTERNAL MODULE: ./components/common/empty-state/styles.scss
var empty_state_styles = __webpack_require__("2ZLW");
var empty_state_styles_default = /*#__PURE__*/__webpack_require__.n(empty_state_styles);

// CONCATENATED MODULE: ./components/common/empty-state/index.js


function empty_state__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function empty_state__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function empty_state__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var empty_state__ref = Object(preact_min["h"])(DotsHorizontalIcon_default.a, null);

var empty_state_EmptyState = function (_Component) {
    empty_state__inherits(EmptyState, _Component);

    function EmptyState() {
        empty_state__classCallCheck(this, EmptyState);

        return empty_state__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    EmptyState.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            'div',
            { 'class': empty_state_styles_default.a.container },
            Object(preact_min["h"])(
                'div',
                { 'class': empty_state_styles_default.a.icon },
                empty_state__ref
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': empty_state_styles_default.a.text },
                this.props.children
            )
        );
    };

    return EmptyState;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/common/error-state/styles.scss
var error_state_styles = __webpack_require__("hO6G");
var error_state_styles_default = /*#__PURE__*/__webpack_require__.n(error_state_styles);

// EXTERNAL MODULE: ../node_modules/mdi-preact/ExclamationIcon.js
var ExclamationIcon = __webpack_require__("RwSX");
var ExclamationIcon_default = /*#__PURE__*/__webpack_require__.n(ExclamationIcon);

// CONCATENATED MODULE: ./components/common/error-state/index.js


function error_state__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function error_state__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function error_state__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var error_state__ref = Object(preact_min["h"])(ExclamationIcon_default.a, null);

var error_state_ErrorState = function (_Component) {
    error_state__inherits(ErrorState, _Component);

    function ErrorState() {
        error_state__classCallCheck(this, ErrorState);

        return error_state__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ErrorState.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { "class": error_state_styles_default.a.container },
            Object(preact_min["h"])(
                "div",
                { "class": error_state_styles_default.a.icon },
                error_state__ref
            ),
            Object(preact_min["h"])(
                "div",
                { "class": error_state_styles_default.a.text },
                this.props.children
            )
        );
    };

    return ErrorState;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/common/infinite-scroll-list/index.js


function infinite_scroll_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function infinite_scroll_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function infinite_scroll_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var infinite_scroll_list__ref = Object(preact_min["h"])(
    backdrop_cover_BackdropCover,
    null,
    Object(preact_min["h"])(spinner_Spinner, null)
);

var infinite_scroll_list__ref2 = Object(preact_min["h"])(text_Text, { text: 'error.loading' });

var infinite_scroll_list__ref3 = Object(preact_min["h"])(text_Text, { text: 'action.retry' });

var infinite_scroll_list_InfiniteScrollList = function (_Component) {
    infinite_scroll_list__inherits(InfiniteScrollList, _Component);

    function InfiniteScrollList(props) {
        infinite_scroll_list__classCallCheck(this, InfiniteScrollList);

        var _this = infinite_scroll_list__possibleConstructorReturn(this, _Component.call(this, props));

        _this.scrollRef = Object(preact_min["createRef"])();
        _this.emptyStateMessage = 'list.empty';

        _this.renderItem = function (i) {
            return Object(preact_min["h"])(
                "div",
                null,
                i
            );
        };

        _this.getPrevRequest = function () {
            return new Promise(function () {});
        };

        _this.getNextRequest = function () {
            return new Promise(function () {});
        };

        _this.getRefreshRequest = function () {
            return new Promise(function () {});
        };

        _this.getPrev = function () {
            _this.setState({ loadingPrev: true, errorPrev: false });

            return _this.getPrevRequest().then(function (res) {
                var items = services_JsonApiDeserializer.deserializeItems(res.data, res['included']);
                var list = _this.state.list;
                list.unshift.apply(list, items);
                _this.setState({ loadingPrev: false, list: list });
            }).catch(function (e) {
                console.error(e);
                _this.setState({ loadingPrev: false, errorPrev: true });
            });
        };

        _this.getNext = function () {
            if (_this.state.reachedLimit) return;

            _this.setState({ loadingNext: true, errorNext: false });

            return _this.getNextRequest().then(function (res) {
                var items = services_JsonApiDeserializer.deserializeItems(res.data, res['included']);
                var list = _this.state.list;
                list.push.apply(list, items);
                _this.setState({
                    loadingNext: false,
                    list: list,
                    reachedLimit: res.meta['pagination']['total_pages'] === res.meta['pagination']['current_page']
                });
            }).catch(function (e) {
                console.error(e);
                _this.setState({ errorNext: true, loadingNext: false });
            });
        };

        _this.refresh = function () {
            return _this.getRefreshRequest().then(function (res) {
                var items = services_JsonApiDeserializer.deserializeItems(res.data, res['included']);
                _this.setState({
                    loadingPrev: false,
                    list: items,
                    reachedLimit: res.meta['pagination']['total_pages'] === res.meta['pagination']['current_page']
                });
            }).catch(function (e) {
                console.error(e);
            });
        };

        _this.onAreaChange = function (area) {
            if (area === 'bottom' && !_this.state.loadingNext) {
                _this.getNext();
            }
        };

        _this.state = {
            list: [],
            loadingPrev: false,
            errorPrev: true,
            loadingNext: false,
            errorNext: true,
            reachedLimit: false
        };
        return _this;
    }

    InfiniteScrollList.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var spinner = Object(preact_min["h"])(
            toolbar_Toolbar,
            null,
            Object(preact_min["h"])(
                section_component_SectionComponent,
                { style: { flexGrow: 2 } },
                infinite_scroll_list__ref
            )
        );

        var emptyState = Object(preact_min["h"])(
            empty_state_EmptyState,
            null,
            Object(preact_min["h"])(text_Text, { text: this.emptyStateMessage })
        );

        var errorState = Object(preact_min["h"])(
            error_state_ErrorState,
            null,
            infinite_scroll_list__ref2,
            Object(preact_min["h"])(
                toolbar_button_ToolbarButton,
                { type: 'primary fill', style: { marginTop: '1em' }, onClick: this.getNext },
                infinite_scroll_list__ref3
            )
        );

        return Object(preact_min["h"])(
            scrollable_section_ScrollableSection,
            { onAreaChange: this.onAreaChange },
            Object(preact_min["h"])(
                "div",
                { ref: this.scrollRef },
                !state.loadingNext && !state.list.length && !state.errorNext ? emptyState : null,
                state.list.map(function (i) {
                    return _this2.renderItem(i);
                }),
                this.state.loadingNext ? spinner : null,
                !state.loadingNext && state.errorNext ? errorState : null
            )
        );
    };

    return InfiniteScrollList;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/sections/personal-area/sections/notification/notification-list-item/styles.scss
var notification_list_item_styles = __webpack_require__("3d20");
var notification_list_item_styles_default = /*#__PURE__*/__webpack_require__.n(notification_list_item_styles);

// CONCATENATED MODULE: ./utilities/create-event.js
function createEvent(event, params) {
    if (typeof CustomEvent === 'function') {
        // If not IE
        return new CustomEvent(event, params);
    }

    return function (customizedEvent, parameters) {
        parameters = parameters || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(customizedEvent, parameters.bubbles, parameters.cancelable, parameters.detail);
        return evt;
    }(event, params);
}
// CONCATENATED MODULE: ./utilities/date.js


function newDate(dateString) {
    if (typeof dateString === 'number') return new Date(dateString);
    var string = dateString;
    if (isIE() && string.indexOf('+') >= 0) {
        string = string.slice(0, string.indexOf('+'));
    }
    return new Date(string);
}
// CONCATENATED MODULE: ./components/common/date/simple-date/index.js
var simple_date__class, simple_date__temp;



function simple_date__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function simple_date__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function simple_date__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var simple_date_SimpleDate = (simple_date__temp = simple_date__class = function (_Component) {
    simple_date__inherits(SimpleDate, _Component);

    function SimpleDate() {
        simple_date__classCallCheck(this, SimpleDate);

        return simple_date__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SimpleDate.prototype.render = function render(props, state, context) {
        if (!props.date) return null;

        var date = dayjs_min_default()(newDate(props.date)).locale(services_ConfigService.currentLanguage());

        var format = 'YYYY-MM-DD HH:mm';
        var dateString = date.format(format);
        var relativeDateString = '';

        var now = dayjs_min_default()(new Date());
        if (date.isSame(now, 'day')) {
            relativeDateString = date.format('HH:mm');
        } else if (date.isSame(now, 'year')) {
            relativeDateString = date.format('DD MMMM');
        } else {
            relativeDateString = date.format('YYYY-MM-DD');
        }

        return Object(preact_min["h"])(
            "span",
            { title: dateString },
            relativeDateString
        );
    };

    return SimpleDate;
}(preact_min["Component"]), simple_date__class.defaultProps = {
    date: null
}, simple_date__temp);

// CONCATENATED MODULE: ./utilities/color.js
/**
 * Calculate brightness value by RGB or HEX color.
 * @param inputColor (String) The color value in RGB or HEX (for example: #000000 || #000 || rgb(0,0,0) || rgba(0,0,0,0))
 * @returns (Number) The brightness value (dark) 0 ... 255 (light)
 */
function brightnessByColor(inputColor) {
    var c = getColorParts(inputColor);
    // sqrt( 0.299*R^2 + 0.587*G^2 + 0.114*B^2 )
    return c ? Math.floor(Math.sqrt(0.299 * Math.pow(c.r, 2) + 0.750 * Math.pow(c.g, 2) + 0.114 * Math.pow(c.b, 2))) : null;
}

function getColorParts(inputColor) {
    var color = String(inputColor);
    var isHEX = color.includes("#");
    var isRGB = color.includes("rgb");
    var r = undefined;
    var g = undefined;
    var b = undefined;
    if (isHEX) {
        var hasFullSpec = color.length === 7;
        var m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
        if (m) {
            r = parseInt(m[0] + (hasFullSpec ? '' : m[0]), 16);
            g = parseInt(m[1] + (hasFullSpec ? '' : m[1]), 16);
            b = parseInt(m[2] + (hasFullSpec ? '' : m[2]), 16);
        }
    }
    if (isRGB) {
        var _m = color.match(/(\d+){3}/g);
        if (_m) {
            r = _m[0];
            g = _m[1];
            b = _m[2];
        }
    }
    return [r, g, b].some(function (i) {
        return i === undefined;
    }) ? null : { r: r, g: g, b: b };
}
// EXTERNAL MODULE: ./components/common/icon/styles.scss
var icon_styles = __webpack_require__("cUGc");
var icon_styles_default = /*#__PURE__*/__webpack_require__.n(icon_styles);

// CONCATENATED MODULE: ./components/common/icon/index.js
var icon__class, icon__temp;



function icon__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function icon__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function icon__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var icon_Icon = (icon__temp = icon__class = function (_Component) {
    icon__inherits(Icon, _Component);

    function Icon() {
        icon__classCallCheck(this, Icon);

        var _this = icon__possibleConstructorReturn(this, _Component.call(this));

        _this.updateIcon = function () {
            if (_this.state.request) _this.state.request.abort();
            var request = new XMLHttpRequest();
            request.addEventListener('load', function () {
                return _this.setState({ iconRequest: { value: request.status === 200 ? request.responseText : null, loading: false, error: false } });
            });
            request.addEventListener('error', function () {
                return _this.setState({ iconRequest: { value: null, loading: false, error: true } });
            });
            request.addEventListener('abort', function () {
                return _this.setState({ iconRequest: { value: null, loading: false, error: true } });
            });
            request.addEventListener('timeout', function () {
                return _this.setState({ iconRequest: { value: null, loading: false, error: true } });
            });
            request.addEventListener('loadend', function () {
                return _this.setState({ request: null });
            });
            request.open('GET', services_ConfigService.iconBaseUrl() + "/" + _this.props.icon + ".svg");
            request.send();
            _this.setState({ request: request });
        };

        _this.state = {
            request: null,
            iconRequest: { value: null, error: false, loading: true }
        };
        return _this;
    }

    Icon.prototype.componentDidMount = function componentDidMount() {
        services_ConfigService.iconBaseUrl.subscribe(this.updateIcon, true);
    };

    Icon.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ConfigService.iconBaseUrl.unsubscribe(this.updateIcon);
    };

    Icon.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { className: icon_styles_default.a.container },
            state.iconRequest.loading ? Object(preact_min["h"])("span", { className: icon_styles_default.a.loading }) : null,
            !state.iconRequest.loading && (state.iconRequest.error || !state.iconRequest.value) ? Object(preact_min["h"])("span", { className: icon_styles_default.a.error }) : null,
            !state.iconRequest.loading && !state.iconRequest.error && state.iconRequest.value ? Object(preact_min["h"])("span", { className: icon_styles_default.a.success, dangerouslySetInnerHTML: { __html: state.iconRequest.value } }) : null
        );
    };

    return Icon;
}(preact_min["Component"]), icon__class.defaultProps = {
    icon: null
}, icon__temp);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/notification/notification-list-item/index.js
var notification_list_item__class, notification_list_item__temp2;



function notification_list_item__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function notification_list_item__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function notification_list_item__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var notification_list_item_NotificationListItem = (notification_list_item__temp2 = notification_list_item__class = function (_Component) {
    notification_list_item__inherits(NotificationListItem, _Component);

    function NotificationListItem() {
        var _temp, _this, _ret;

        notification_list_item__classCallCheck(this, NotificationListItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = notification_list_item__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.navigateToLink = function (event) {
            _this.base.dispatchEvent(createEvent('closeDropdown', { bubbles: true }));
            event.preventDefault();
            event.stopPropagation();
            services_ConfigService.navigateFunction(_this.props.notification.url);
        }, _temp), notification_list_item__possibleConstructorReturn(_this, _ret);
    }

    NotificationListItem.prototype.render = function render(props, state, context) {
        var content = this.props.notification.content;
        var url = this.props.notification.url;
        var read = this.props.notification.visualized;
        var classes = [notification_list_item_styles_default.a.notificationListItem, !read ? notification_list_item_styles_default.a.unread : null].filter(function (i) {
            return i;
        }).join(' ');
        var date = Object(preact_min["h"])(simple_date_SimpleDate, { date: this.props.notification.createdAt });
        var module = props.notification.module ? services_ModuleInfoProvider.getModuleByReference(props.notification.module) : null;

        var statusColors = {
            'info': '#00a8ff',
            'success': '#49d400',
            'warning': '#e07c00',
            'danger': '#e02200'
        };

        var iconBackground = getColorParts(props.notification.color) ? props.notification.color : statusColors[props.notification.status || 'info'];
        var iconBackgroundLightness = brightnessByColor(iconBackground);
        var iconColor = iconBackgroundLightness > 175 ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.9)';

        var statusIcons = {
            'info': 'fas-info',
            'success': 'fas-check',
            'warning': 'far-bell',
            'danger': 'fas-exclamation'
        };
        var iconName = props.notification.icon || statusIcons[props.notification.status || 'info'];

        var _ref = Object(preact_min["h"])(icon_Icon, { icon: iconName });

        var _ref2 = Object(preact_min["h"])(text_Text, { translatable: content });

        var innerTemplate = function innerTemplate() {
            return Object(preact_min["h"])(
                "div",
                { "class": notification_list_item_styles_default.a.notificationInner },
                Object(preact_min["h"])(
                    "div",
                    { className: notification_list_item_styles_default.a.notificationColumnIcon },
                    Object(preact_min["h"])(
                        "div",
                        { className: notification_list_item_styles_default.a.notificationIcon, style: { color: iconBackground } },
                        _ref
                    )
                ),
                Object(preact_min["h"])(
                    "div",
                    { className: notification_list_item_styles_default.a.notificationColumnContent },
                    props.notification.title ? Object(preact_min["h"])(
                        "div",
                        { className: notification_list_item_styles_default.a.notificationTitle },
                        Object(preact_min["h"])(text_Text, { translatable: props.notification.title })
                    ) : null,
                    Object(preact_min["h"])(
                        "div",
                        { className: notification_list_item_styles_default.a.notificationBody },
                        _ref2
                    ),
                    Object(preact_min["h"])(
                        "div",
                        { className: notification_list_item_styles_default.a.notificationFooter },
                        Object(preact_min["h"])(
                            "div",
                            { className: notification_list_item_styles_default.a.module },
                            module ? Object(preact_min["h"])(text_Text, { translatable: module.denomination }) : null
                        ),
                        Object(preact_min["h"])(
                            "div",
                            { className: notification_list_item_styles_default.a.date },
                            date
                        )
                    )
                )
            );
        };

        return url ? Object(preact_min["h"])(
            "a",
            { href: url, "class": classes, onClick: this.navigateToLink },
            innerTemplate()
        ) : Object(preact_min["h"])(
            "div",
            { "class": classes },
            innerTemplate()
        );
    };

    return NotificationListItem;
}(preact_min["Component"]), notification_list_item__class.defaultProps = {
    notification: {}
}, notification_list_item__temp2);

// CONCATENATED MODULE: ./services/NotificationService.js
function NotificationService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var NotificationService_NotificationServiceClass = function NotificationServiceClass() {
    var _this = this;

    NotificationService__classCallCheck(this, NotificationServiceClass);

    this.observable = trkl_min_default()(newDate('2000-01-01T00:00:00+0000'));
    this.badge = trkl_min_default()(0);

    this.start = function () {
        if (_this.intervalId !== undefined) return;
        _this.intervalId = setInterval(_this.checkForUpdates, 60000);
    };

    this.stop = function () {
        if (_this.intervalId === undefined) return;
        clearInterval(_this.intervalId);
    };

    this.checkForUpdates = function () {
        if (!services_ConfigService.userProfile()) return;

        var url = services_ModuleInfoProvider.getModuleWebServiceUrl('notification-store') + '/api/v1/notification?sortBy=-id&limit=1';
        services_JWTClient.fetch(url).then(function (res) {
            var data = services_JsonApiDeserializer.deserializeItems(res.data, res.included);
            var date = data.length ? newDate(data[0].updatedAt) : new Date();
            if (date.getTime() > _this.observable().getTime()) {
                _this.observable(date);
            }
        }).catch(function () {});
    };
};

var NotificationService = new NotificationService_NotificationServiceClass();
/* harmony default export */ var services_NotificationService = (NotificationService);
// CONCATENATED MODULE: ./components/sections/personal-area/sections/notification/notification-infinite-scroll-list/index.js
var notification_infinite_scroll_list__class, notification_infinite_scroll_list__temp;



function notification_infinite_scroll_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function notification_infinite_scroll_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function notification_infinite_scroll_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var notification_infinite_scroll_list_NotificationInfiniteScrollList = (notification_infinite_scroll_list__temp = notification_infinite_scroll_list__class = function (_InfiniteScrollList) {
    notification_infinite_scroll_list__inherits(NotificationInfiniteScrollList, _InfiniteScrollList);

    function NotificationInfiniteScrollList(props) {
        notification_infinite_scroll_list__classCallCheck(this, NotificationInfiniteScrollList);

        var _this = notification_infinite_scroll_list__possibleConstructorReturn(this, _InfiniteScrollList.call(this, props));

        _this.emptyStateMessage = 'notification.list.empty';
        _this.notificationStoreDomain = '';
        _this.observer = null;
        _this.visibleIds = {};
        _this.visualizedIds = {};
        _this.visualizationCheckInterval = null;

        _this.renderItem = function (item) {
            return Object(preact_min["h"])(
                "div",
                { className: "obsItem", "data-id": item.visualized ? 0 : item.id },
                Object(preact_min["h"])(notification_list_item_NotificationListItem, { notification: item })
            );
        };

        _this.getPrevRequest = function () {
            var list = _this.state.list;
            var boundId = list.length ? list[0].id : 0;
            return services_JWTClient.fetch(_this.notificationStoreDomain + '/api/v1/notification?limit=100&sortBy=-id&afterId=' + boundId);
        };

        _this.getNextRequest = function () {
            var list = _this.state.list;
            var boundId = list.length ? list[list.length - 1].id : 100000000;
            return services_JWTClient.fetch(_this.notificationStoreDomain + '/api/v1/notification?limit=10&sortBy=-id&beforeId=' + boundId);
        };

        _this.onIntersection = function (intersections) {
            if (_this.props.freeze || !intersections) return;
            for (var _iterator = intersections, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var intersection = _ref;

                if (intersection.isIntersecting && parseInt(intersection.target.dataset.id) > 0) {
                    _this.visibleIds[intersection.target.dataset.id] = true;
                }
            }
        };

        _this.notificationStoreDomain = services_ModuleInfoProvider.getModuleWebServiceUrl('notification-store');
        return _this;
    }

    NotificationInfiniteScrollList.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        this.getNext();
        services_NotificationService.observable.subscribe(this.getPrev);
        this.visualizationCheckInterval = setInterval(function () {
            return _this2.markNotificationsAsVisualized();
        }, 1000);
    };

    NotificationInfiniteScrollList.prototype.componentWillUnmount = function componentWillUnmount() {
        services_NotificationService.observable.unsubscribe(this.getPrev);
        if (this.observer) this.observer.disconnect();
        clearInterval(this.visualizationCheckInterval);
    };

    NotificationInfiniteScrollList.prototype.componentDidUpdate = function componentDidUpdate(previousProps, previousState, previousContext) {
        var scrollEl = this.scrollRef.current.parentElement;
        var children = scrollEl.querySelectorAll('.obsItem');

        if (!this.observer) {
            var options = {
                root: scrollEl,
                rootMargin: '0px',
                threshold: 0.5
            };
            this.observer = new IntersectionObserver(this.onIntersection, options);
        }

        this.observer.disconnect();

        for (var _iterator2 = children, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var child = _ref2;

            this.observer.observe(child);
        }
    };

    NotificationInfiniteScrollList.prototype.markNotificationsAsVisualized = function markNotificationsAsVisualized() {
        var _this3 = this;

        var visibleIds = Object.keys(this.visibleIds);
        if (!visibleIds.length) return;

        var ids = visibleIds.filter(function (id) {
            return Object.keys(_this3.visualizedIds).indexOf(id) < 0;
        }).map(function (i) {
            return parseInt(i);
        });
        if (!ids.length) return;

        var domain = this.notificationStoreDomain;
        services_JWTClient.fetch(domain + '/api/v1/notification/visualized', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                data: ids
            })
        }).then(function () {
            _this3.props.onVisualized();
            for (var _iterator3 = ids, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var id = _ref3;

                _this3.visualizedIds[id] = true;
            }
            for (var _iterator4 = _this3.state.list, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref4;

                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref4 = _i4.value;
                }

                var item = _ref4;

                if (_this3.visualizedIds.hasOwnProperty(item.id)) {
                    item.visualized = true;
                }
            }
            _this3.forceUpdate();
        });
    };

    return NotificationInfiniteScrollList;
}(infinite_scroll_list_InfiniteScrollList), notification_infinite_scroll_list__class.defaultProps = {
    onVisualized: function onVisualized() {},
    freeze: true
}, notification_infinite_scroll_list__temp);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/notification/notification-list/styles.scss
var notification_list_styles = __webpack_require__("fzty");
var notification_list_styles_default = /*#__PURE__*/__webpack_require__.n(notification_list_styles);

// EXTERNAL MODULE: ../node_modules/mdi-preact/BellOutlineIcon.js
var BellOutlineIcon = __webpack_require__("le1D");
var BellOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(BellOutlineIcon);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/notification/notification-list/index.js
var notification_list__class, notification_list__temp2;



function notification_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function notification_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function notification_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var notification_list__ref = Object(preact_min["h"])(BellOutlineIcon_default.a, null);

var notification_list__ref2 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'notification.list' })
);

var notification_list_NotificationList = (notification_list__temp2 = notification_list__class = function (_Component) {
    notification_list__inherits(NotificationList, _Component);

    function NotificationList() {
        var _temp, _this, _ret;

        notification_list__classCallCheck(this, NotificationList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = notification_list__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.manager = new list_manager_ListManager(), _this.notificationStoreDomain = '', _this.scrollRef = Object(preact_min["createRef"])(), _temp), notification_list__possibleConstructorReturn(_this, _ret);
    }

    NotificationList.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { "class": notification_list_styles_default.a.toolbar },
                Object(preact_min["h"])(
                    section_container_SectionContainer,
                    { style: { flexGrow: 2, justifyContent: 'flex-start' } },
                    Object(preact_min["h"])(
                        "div",
                        { className: notification_list_styles_default.a.iconButton },
                        notification_list__ref
                    ),
                    notification_list__ref2
                )
            ),
            Object(preact_min["h"])(notification_infinite_scroll_list_NotificationInfiniteScrollList, { onVisualized: props.onVisualized, freeze: props.freeze })
        );
    };

    return NotificationList;
}(preact_min["Component"]), notification_list__class.defaultProps = {
    onVisualized: function onVisualized() {},
    freeze: true
}, notification_list__temp2);

// EXTERNAL MODULE: ./components/common/simple-badge/styles.scss
var simple_badge_styles = __webpack_require__("g1JJ");
var simple_badge_styles_default = /*#__PURE__*/__webpack_require__.n(simple_badge_styles);

// CONCATENATED MODULE: ./components/common/simple-badge/index.js


function simple_badge__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function simple_badge__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function simple_badge__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var simple_badge_SimpleBadge = function (_Component) {
    simple_badge__inherits(SimpleBadge, _Component);

    function SimpleBadge() {
        simple_badge__classCallCheck(this, SimpleBadge);

        return simple_badge__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SimpleBadge.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            'div',
            { 'class': [simple_badge_styles_default.a.badge, props.class].filter(function (i) {
                    return i;
                }).join(' ') },
            props.children
        );
    };

    return SimpleBadge;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sections/personal-area/sections/notification/notifications-button/index.js


function notifications_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function notifications_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function notifications_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var notifications_button__ref = Object(preact_min["h"])(BellIcon_default.a, null);

var notifications_button_NotificationsButton = function (_Component) {
    notifications_button__inherits(NotificationsButton, _Component);

    function NotificationsButton(props) {
        notifications_button__classCallCheck(this, NotificationsButton);

        var _this = notifications_button__possibleConstructorReturn(this, _Component.call(this, props));

        _this.toggleDropdown = function () {
            _this.setState({ open: !_this.state.open });
        };

        _this.closeDropDown = function () {
            _this.setState({ open: false });
        };

        _this.fetchNotifications = function () {
            _this.setState({ loading: true, error: false });
            var domain = services_ModuleInfoProvider.getModuleWebServiceUrl('notification-store');

            services_JWTClient.fetch(domain + '/api/v1/notification?visualized=0&limit=1').then(function (res) {
                _this.setState({
                    notifications: [],
                    loading: false,
                    error: false,
                    unreadCount: res.meta.pagination.total
                });
                services_NotificationService.badge(res.meta.pagination.total);
            }).catch(function (e) {
                console.log(e);
                _this.setState({ loading: false, error: true, notifications: [], unreadCount: 0 });
                services_NotificationService.badge(0);
            });
        };

        _this.state = {
            loading: true,
            error: false,
            notifications: [],
            unreadCount: 0,
            open: false
        };
        return _this;
    }

    NotificationsButton.prototype.componentDidMount = function componentDidMount() {
        this.fetchNotifications();
        services_NotificationService.start();
        services_NotificationService.observable.subscribe(this.fetchNotifications);
    };

    NotificationsButton.prototype.componentWillUnmount = function componentWillUnmount() {
        services_NotificationService.stop();
        services_NotificationService.observable.unsubscribe(this.fetchNotifications);
    };

    NotificationsButton.prototype.render = function render(props) {
        var _this2 = this;

        var purchased = services_ModuleInfoProvider.getModule('notification-store').purchased;
        if (!purchased) return null;

        var unreadBadge = function unreadBadge() {
            return _this2.state.unreadCount ? Object(preact_min["h"])(
                simple_badge_SimpleBadge,
                null,
                _this2.state.unreadCount
            ) : null;
        };
        var notificationList = function notificationList() {
            return Object(preact_min["h"])(notification_list_NotificationList, { freeze: !_this2.state.open, onVisualized: _this2.fetchNotifications });
        };
        var buttonStyles = this.state.open ? { background: '#0079B8' } : {};

        return Object(preact_min["h"])(
            outside_click_wrapper_OutsideClickWrapper,
            { watch: this.state.open, onOutsideClick: this.toggleDropdown },
            Object(preact_min["h"])(
                section_component_SectionComponent,
                null,
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { onClick: this.toggleDropdown, title: translate('notification.list'), style: buttonStyles },
                    notifications_button__ref,
                    unreadBadge()
                ),
                Object(preact_min["h"])(
                    dropdown_DropDownMenu,
                    { open: this.state.open, closeFunction: this.toggleDropdown },
                    notificationList()
                )
            )
        );
    };

    return NotificationsButton;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/mdi-preact/AccountIcon.js
var AccountIcon = __webpack_require__("efTI");
var AccountIcon_default = /*#__PURE__*/__webpack_require__.n(AccountIcon);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/user/profile-button/styles.scss
var profile_button_styles = __webpack_require__("UVb7");
var profile_button_styles_default = /*#__PURE__*/__webpack_require__.n(profile_button_styles);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/user/profile-box/styles.scss
var profile_box_styles = __webpack_require__("PHVl");
var profile_box_styles_default = /*#__PURE__*/__webpack_require__.n(profile_box_styles);

// EXTERNAL MODULE: ../node_modules/mdi-preact/LogOutIcon.js
var LogOutIcon = __webpack_require__("8Rqe");
var LogOutIcon_default = /*#__PURE__*/__webpack_require__.n(LogOutIcon);

// EXTERNAL MODULE: ./components/common/letter-icon/styles.scss
var letter_icon_styles = __webpack_require__("IkSs");
var letter_icon_styles_default = /*#__PURE__*/__webpack_require__.n(letter_icon_styles);

// CONCATENATED MODULE: ./components/common/letter-icon/index.js


function letter_icon__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function letter_icon__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function letter_icon__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var letter_icon_LetterIcon = function (_Component) {
    letter_icon__inherits(LetterIcon, _Component);

    function LetterIcon() {
        var _temp, _this, _ret;

        letter_icon__classCallCheck(this, LetterIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = letter_icon__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#C0CA33', '#FFB300', '#FB8C00', '#FF5722'], _temp), letter_icon__possibleConstructorReturn(_this, _ret);
    }

    LetterIcon.prototype.render = function render(_ref, state, context) {
        var text = _ref.text;

        var stringText = text || ' ';
        var letter = stringText[0];

        var index = 0;
        stringText.split('').forEach(function (c, i) {
            index += stringText.charCodeAt(i);
        });
        index = (index + stringText.length) % this.colors.length;

        return Object(preact_min["h"])(
            'div',
            { 'class': letter_icon_styles_default.a.icon, style: { backgroundColor: this.colors[index] } },
            letter
        );
    };

    return LetterIcon;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/mdi-preact/AccountEditIcon.js
var AccountEditIcon = __webpack_require__("86Ro");
var AccountEditIcon_default = /*#__PURE__*/__webpack_require__.n(AccountEditIcon);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/user/language-flag-icon/styles.scss
var language_flag_icon_styles = __webpack_require__("ZVay");
var language_flag_icon_styles_default = /*#__PURE__*/__webpack_require__.n(language_flag_icon_styles);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/user/language-flag-icon/index.js
var language_flag_icon__class, language_flag_icon__temp;



function language_flag_icon__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function language_flag_icon__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function language_flag_icon__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var language_flag_icon_LanguageFlagIcon = (language_flag_icon__temp = language_flag_icon__class = function (_Component) {
    language_flag_icon__inherits(LanguageFlagIcon, _Component);

    function LanguageFlagIcon(props) {
        language_flag_icon__classCallCheck(this, LanguageFlagIcon);

        var _this = language_flag_icon__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onImageError = function () {
            _this.setState({ imageError: true });
        };

        _this.state = {
            imageError: false
        };
        return _this;
    }

    LanguageFlagIcon.prototype.render = function render(props, state, context) {
        return this.state.imageError ? null : Object(preact_min["h"])("img", {
            "class": language_flag_icon_styles_default.a.flag,
            src: services_CdnResourceResolverService.getResource('bandiere', { country: props.language, extension: 'svg' }),
            onError: this.onImageError
        });
    };

    return LanguageFlagIcon;
}(preact_min["Component"]), language_flag_icon__class.defaultProps = {
    language: ''
}, language_flag_icon__temp);

// CONCATENATED MODULE: ./services/JWTService.js
function JWTService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var JWTService_JWTServiceClass = function JWTServiceClass() {
    var _this = this;

    JWTService__classCallCheck(this, JWTServiceClass);

    this.observable = trkl_min_default()({});

    this.updateJWTContent = function () {
        var jwtParts = services_ConfigService.jwt().split('.');
        var jwtContent = jwtParts.length === 3 ? JSON.parse(atob(jwtParts[1])) : {};
        _this.observable(jwtContent);
    };

    services_ConfigService.jwt.subscribe(this.updateJWTContent, true);
};

var JWTService = new JWTService_JWTServiceClass();
/* harmony default export */ var services_JWTService = (JWTService);
// CONCATENATED MODULE: ./services/ProfileService.js
function ProfileService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ProfileService_ProfileServiceClass = function ProfileServiceClass() {
    var _this = this;

    ProfileService__classCallCheck(this, ProfileServiceClass);

    this.sessionExpiring = trkl_min(false);
    this.expirationTimestamp = trkl_min();

    this.checkSessionExpiration = function () {
        var data = services_JWTService.observable();
        if (!data || !data.hasOwnProperty('refresh_token_expiration_date')) return;
        var timestamp = data.refresh_token_expiration_date;
        if (!timestamp) return;

        var expiration = parseInt(timestamp);
        if (!expiration) return;
        var isExpiring = expiration - new Date().getTime() / 1000 < 7200;
        _this.expirationTimestamp(expiration);
        _this.sessionExpiring(isExpiring);
    };

    services_JWTService.observable.subscribe(this.checkSessionExpiration, true);
    setInterval(this.checkSessionExpiration, 600000);
};

var ProfileService = new ProfileService_ProfileServiceClass();
/* harmony default export */ var services_ProfileService = (ProfileService);
// CONCATENATED MODULE: ./components/sections/personal-area/sections/user/profile-box/index.js
var profile_box__class, profile_box__temp;



function profile_box__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function profile_box__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function profile_box__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var profile_box__ref = Object(preact_min["h"])(
    backdrop_cover_BackdropCover,
    null,
    Object(preact_min["h"])(spinner_Spinner, null)
);

var profile_box__ref2 = Object(preact_min["h"])(text_Text, { text: 'profile.session_expiration' });

var profile_box__ref3 = Object(preact_min["h"])(text_Text, { text: 'profile.session_expiration_alert' });

var profile_box__ref4 = Object(preact_min["h"])(text_Text, { text: 'profile.attribute.username' });

var _ref5 = Object(preact_min["h"])(text_Text, { text: 'profile.attribute.email' });

var profile_box__ref6 = Object(preact_min["h"])(text_Text, { text: 'language_dropdown_title' });

var _ref8 = Object(preact_min["h"])(text_Text, { text: 'action.logout' });

var _ref9 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'profile.title' })
);

var _ref10 = Object(preact_min["h"])(text_Text, { text: 'profile.edit' });

var profile_box_ProfileBox = (profile_box__temp = profile_box__class = function (_Component) {
    profile_box__inherits(ProfileBox, _Component);

    function ProfileBox(props) {
        profile_box__classCallCheck(this, ProfileBox);

        var _this = profile_box__possibleConstructorReturn(this, _Component.call(this, props));

        _this.update = function () {
            return _this.forceUpdate();
        };

        _this.openLanguageSelector = function () {
            _this.props.onNavigate('language');
        };

        _this.navigateToProfile = function () {
            _this.base.dispatchEvent(createEvent('closeDropdown', { bubbles: true }));
            services_ConfigService.navigateFunction(url_join([services_ModuleInfoProvider.getModuleBackendUrl('extranet'), '/profile']));
        };

        _this.logout = function () {
            _this.base.dispatchEvent(createEvent('closeDropdown', { bubbles: true }));
            _this.setState({ loading: true });
            execute(services_ConfigService.logoutCallback, function () {
                var urlParts = [services_ModuleInfoProvider.getModuleBaseUrl('extranet', 'backend'), '/logout?redirectUrl=' + services_ConfigService.logoutRedirectUrl()];
                services_ConfigService.navigateFunction(url_join(urlParts));
                _this.setState({ loading: false });
            });
        };

        _this.state = {
            loading: false,
            error: false,
            sessionExpiration: null
        };
        return _this;
    }

    ProfileBox.prototype.componentDidMount = function componentDidMount() {
        services_ProfileService.expirationTimestamp.subscribe(this.update);
    };

    ProfileBox.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ProfileService.expirationTimestamp.unsubscribe(this.update);
    };

    ProfileBox.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var spinner = profile_box__ref;
        var profile = services_ConfigService.userProfile();
        var hasProfile = Object.keys(profile || {}).length;
        var language = services_ConfigService.currentLanguage();

        var expiration = function expiration() {
            return !services_ProfileService.expirationTimestamp() ? null : Object(preact_min["h"])(
                "div",
                { className: profile_box_styles_default.a.profileInfoContainer },
                Object(preact_min["h"])(
                    "div",
                    { className: profile_box_styles_default.a.profileRow },
                    Object(preact_min["h"])(
                        "span",
                        { className: profile_box_styles_default.a.profileRowField },
                        profile_box__ref2
                    ),
                    Object(preact_min["h"])(
                        "span",
                        { className: profile_box_styles_default.a.profileRowValue },
                        Object(preact_min["h"])(simple_date_SimpleDate, { date: services_ProfileService.expirationTimestamp() * 1000 })
                    )
                ),
                !services_ProfileService.sessionExpiring() ? null : Object(preact_min["h"])(
                    "div",
                    { "class": profile_box_styles_default.a.profileRowAlert },
                    profile_box__ref3
                )
            );
        };

        var _ref7 = Object(preact_min["h"])(language_flag_icon_LanguageFlagIcon, { language: language });

        var profileInfo = function profileInfo() {
            return Object(preact_min["h"])(
                scrollable_section_ScrollableSection,
                null,
                Object(preact_min["h"])(
                    "div",
                    { "class": profile_box_styles_default.a.profileInfoContainer },
                    Object(preact_min["h"])(
                        "div",
                        { "class": profile_box_styles_default.a.profileRow },
                        Object(preact_min["h"])(
                            "span",
                            { "class": profile_box_styles_default.a.profileRowField },
                            profile_box__ref4
                        ),
                        Object(preact_min["h"])(
                            "span",
                            { "class": profile_box_styles_default.a.profileRowValue },
                            profile.username
                        )
                    ),
                    Object(preact_min["h"])(
                        "div",
                        { "class": profile_box_styles_default.a.profileRow },
                        Object(preact_min["h"])(
                            "span",
                            { "class": profile_box_styles_default.a.profileRowField },
                            _ref5
                        ),
                        Object(preact_min["h"])(
                            "span",
                            { "class": profile_box_styles_default.a.profileRowValue },
                            profile.email
                        )
                    )
                ),
                Object(preact_min["h"])(
                    "div",
                    { "class": profile_box_styles_default.a.profileInfoContainer, style: { paddingRight: ".25em" } },
                    Object(preact_min["h"])(
                        "div",
                        { "class": profile_box_styles_default.a.profileRow, style: { paddingRight: "0" } },
                        Object(preact_min["h"])(
                            "span",
                            { "class": profile_box_styles_default.a.profileRowField },
                            profile_box__ref6
                        ),
                        Object(preact_min["h"])(
                            "span",
                            { "class": profile_box_styles_default.a.profileRowValue },
                            Object(preact_min["h"])(
                                toolbar_button_ToolbarButton,
                                { type: 'classic tertiary text', onClick: _this2.openLanguageSelector },
                                Object(preact_min["h"])(
                                    "div",
                                    { style: { display: 'flex', alignItems: 'center' } },
                                    _ref7,
                                    Object(preact_min["h"])(text_Text, { text: 'language.' + language })
                                )
                            )
                        )
                    )
                ),
                expiration(),
                Object(preact_min["h"])(
                    "div",
                    { className: profile_box_styles_default.a.profileInfoContainer, style: { padding: '.5em' } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: _this2.logout, type: 'secondary text classic' },
                        Object(preact_min["h"])(LogOutIcon_default.a, { style: { marginRight: '.25em' } }),
                        _ref8
                    )
                )
            );
        };

        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            this.state.loading ? spinner : null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { "class": profile_box_styles_default.a.profileToolbar },
                Object(preact_min["h"])(
                    section_container_SectionContainer,
                    { style: { justifyContent: 'flex-start', flex: 2 } },
                    Object(preact_min["h"])(
                        "div",
                        { style: { margin: '0 .5em 0 .85em' } },
                        Object(preact_min["h"])(letter_icon_LetterIcon, { text: profile.username })
                    ),
                    _ref9
                ),
                Object(preact_min["h"])(
                    section_container_SectionContainer,
                    { style: { flex: "0 0 auto" } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.navigateToProfile, type: 'text tertiary classic' },
                        Object(preact_min["h"])(AccountEditIcon_default.a, { style: { marginRight: '.5em' } }),
                        " ",
                        _ref10
                    )
                )
            ),
            hasProfile ? profileInfo() : ''
        );
    };

    return ProfileBox;
}(preact_min["Component"]), profile_box__class.defaultProps = {
    onNavigate: function onNavigate() {}
}, profile_box__temp);

// EXTERNAL MODULE: ../node_modules/mdi-preact/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__("FqhM");
var ArrowLeftIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftIcon);

// EXTERNAL MODULE: ../node_modules/mdi-preact/CheckIcon.js
var CheckIcon = __webpack_require__("hJCV");
var CheckIcon_default = /*#__PURE__*/__webpack_require__.n(CheckIcon);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/user/language-selector-item/index.js
var language_selector_item__class, language_selector_item__temp2;



function language_selector_item__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function language_selector_item__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function language_selector_item__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var language_selector_item_LanguageSelectorItem = (language_selector_item__temp2 = language_selector_item__class = function (_Component) {
    language_selector_item__inherits(LanguageSelectorItem, _Component);

    function LanguageSelectorItem() {
        var _temp, _this, _ret;

        language_selector_item__classCallCheck(this, LanguageSelectorItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = language_selector_item__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onImageError = function () {
            _this.setState({ imageError: true });
        }, _temp), language_selector_item__possibleConstructorReturn(_this, _ret);
    }

    LanguageSelectorItem.prototype.render = function render(props, state, context) {
        var language = services_ConfigService.currentLanguage();

        return Object(preact_min["h"])(
            toolbar_button_ToolbarButton,
            { type: 'fill text', onClick: props.onClick },
            Object(preact_min["h"])(language_flag_icon_LanguageFlagIcon, { language: props.language }),
            Object(preact_min["h"])(text_Text, { text: 'language.' + props.language }),
            props.language === language ? Object(preact_min["h"])(CheckIcon_default.a, { style: { float: 'right' } }) : null
        );
    };

    return LanguageSelectorItem;
}(preact_min["Component"]), language_selector_item__class.defaultProps = {
    language: '',
    onClick: function onClick() {}
}, language_selector_item__temp2);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/user/language-selector/index.js
var language_selector__class, language_selector__temp2;



function language_selector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function language_selector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function language_selector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var language_selector__ref = Object(preact_min["h"])(ArrowLeftIcon_default.a, null);

var language_selector__ref2 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'language_dropdown_title' })
);

var language_selector_LanguageSelector = (language_selector__temp2 = language_selector__class = function (_Component) {
    language_selector__inherits(LanguageSelector, _Component);

    function LanguageSelector() {
        var _temp, _this, _ret;

        language_selector__classCallCheck(this, LanguageSelector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = language_selector__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.backToProfile = function () {
            _this.props.onNavigate('profile');
        }, _this.updateLanguage = function (language) {
            services_JWTClient.fetch(services_ConfigService.organigrammaServerUrl() + '/user-preference', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    preference: "preferredLocale",
                    value: language
                })
            }).then(function () {
                execute(function () {
                    return services_ConfigService.setCurrentLanguage(language);
                }, function () {
                    services_ConfigService.currentLanguage(language);
                });
                _this.backToProfile();
            });
        }, _temp), language_selector__possibleConstructorReturn(_this, _ret);
    }

    LanguageSelector.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var language = services_ConfigService.currentLanguage();
        var languageList = services_ConfigService.availableLanguages();
        if (languageList.length < 2) {
            setTimeout(this.backToProfile);
            return null;
        }

        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { style: { borderBottom: '1px solid #eee' } },
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexGrow: 0 } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.backToProfile, title: translate('action.back') },
                        language_selector__ref
                    )
                ),
                language_selector__ref2
            ),
            Object(preact_min["h"])(
                scrollable_section_ScrollableSection,
                null,
                languageList.map(function (i) {
                    return Object(preact_min["h"])(
                        toolbar_Toolbar,
                        null,
                        Object(preact_min["h"])(language_selector_item_LanguageSelectorItem, { onClick: function onClick() {
                                _this2.updateLanguage(i);
                            }, language: i })
                    );
                })
            )
        );
    };

    return LanguageSelector;
}(preact_min["Component"]), language_selector__class.defaultProps = {
    onNavigate: function onNavigate() {}
}, language_selector__temp2);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/user/profile-main/index.js


function profile_main__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function profile_main__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function profile_main__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var profile_main_ProfileMain = function (_Component) {
    profile_main__inherits(ProfileMain, _Component);

    function ProfileMain(props) {
        profile_main__classCallCheck(this, ProfileMain);

        var _this = profile_main__possibleConstructorReturn(this, _Component.call(this, props));

        _this.navigate = function (page) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _this.setState({
                page: page,
                params: params || {}
            });
        };

        _this.state = {
            page: 'profile',
            params: {}
        };
        return _this;
    }

    ProfileMain.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var pages = {
            profile: function profile() {
                return Object(preact_min["h"])(profile_box_ProfileBox, { onNavigate: _this2.navigate });
            },
            language: function language() {
                return Object(preact_min["h"])(language_selector_LanguageSelector, { onNavigate: _this2.navigate });
            }
        };

        return pages[this.state.page]();
    };

    return ProfileMain;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/mdi-preact/ClockIcon.js
var ClockIcon = __webpack_require__("BMSr");
var ClockIcon_default = /*#__PURE__*/__webpack_require__.n(ClockIcon);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/user/profile-button/index.js
var profile_button__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function profile_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function profile_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function profile_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var profile_button__ref = Object(preact_min["h"])(ClockIcon_default.a, null);

var profile_button__ref2 = Object(preact_min["h"])(AccountIcon_default.a, null);

var profile_button__ref3 = Object(preact_min["h"])(text_Text, { text: 'profile.session_expiration_alert.short' });

var profile_button__ref4 = Object(preact_min["h"])(profile_main_ProfileMain, null);

var profile_button_ProfileButton = function (_Component) {
    profile_button__inherits(ProfileButton, _Component);

    function ProfileButton(props) {
        profile_button__classCallCheck(this, ProfileButton);

        var _this = profile_button__possibleConstructorReturn(this, _Component.call(this, props));

        _this.update = function () {
            return _this.forceUpdate();
        };

        _this.toggleDropdown = function () {
            if (Object.keys(services_ConfigService.userProfile()).length) _this.setState({ open: !_this.state.open });
        };

        _this.state = {
            open: false
        };
        return _this;
    }

    ProfileButton.prototype.componentDidMount = function componentDidMount() {
        services_ProfileService.sessionExpiring.subscribe(this.update);
    };

    ProfileButton.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ProfileService.sessionExpiring.subscribe(this.update);
    };

    ProfileButton.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var profile = services_ConfigService.userProfile();
        var hasProfile = Object.keys(profile || {}).length;
        var buttonStyles = this.state.open ? { background: '#0079B8' } : {};

        var unreadBadge = function unreadBadge() {
            return services_ProfileService.sessionExpiring() ? Object(preact_min["h"])(
                simple_badge_SimpleBadge,
                { "class": profile_button_styles_default.a.badgeDanger },
                profile_button__ref
            ) : null;
        };

        var button = function button() {
            if (hasProfile) {
                return Object(preact_min["h"])(
                    section_component_SectionComponent,
                    null,
                    Object(preact_min["h"])(
                        "div",
                        { "class": profile_button_styles_default.a.buttonContainer },
                        Object(preact_min["h"])(
                            toolbar_button_ToolbarButton,
                            { type: 'text', onClick: _this2.toggleDropdown, title: translate('profile.title'),
                                style: profile_button__extends({ overflow: 'initial' }, buttonStyles) },
                            Object(preact_min["h"])(
                                "span",
                                { "class": profile_button_styles_default.a.profileText },
                                profile.username
                            ),
                            profile_button__ref2,
                            unreadBadge()
                        ),
                        !services_ProfileService.sessionExpiring() ? null : Object(preact_min["h"])(
                            "div",
                            { className: profile_button_styles_default.a.tooltip },
                            profile_button__ref3
                        )
                    ),
                    Object(preact_min["h"])(
                        dropdown_DropDownMenu,
                        { open: _this2.state.open, closeFunction: _this2.toggleDropdown },
                        profile_button__ref4
                    )
                );
            }
        };

        return Object(preact_min["h"])(
            outside_click_wrapper_OutsideClickWrapper,
            { watch: this.state.open, onOutsideClick: this.toggleDropdown },
            button()
        );
    };

    return ProfileButton;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/sections/personal-area/sections/messenger/messenger-button/styles.scss
var messenger_button_styles = __webpack_require__("j1oG");
var messenger_button_styles_default = /*#__PURE__*/__webpack_require__.n(messenger_button_styles);

// EXTERNAL MODULE: ../node_modules/mdi-preact/EmailIcon.js
var EmailIcon = __webpack_require__("QZby");
var EmailIcon_default = /*#__PURE__*/__webpack_require__.n(EmailIcon);

// CONCATENATED MODULE: ./services/MessageService.js
function MessageService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var MessageService_MessageServiceClass = function MessageServiceClass() {
    var _this = this;

    MessageService__classCallCheck(this, MessageServiceClass);

    this.observable = trkl_min_default()(newDate('2000-01-01T00:00:00+0000'));
    this.badge = trkl_min_default()(0);

    this.start = function () {
        if (_this.intervalId !== undefined) return;
        _this.intervalId = setInterval(_this.checkForUpdates, 300000);
    };

    this.stop = function () {
        if (_this.intervalId === undefined) return;
        clearInterval(_this.intervalId);
    };

    this.checkForUpdates = function () {
        if (!services_ConfigService.userProfile()) return;

        var url = services_ModuleInfoProvider.getModuleWebServiceUrl('messenger') + '/messages?received=1&draft=0&sortBy=updatedAt&direction=desc&limit=1';
        services_JWTClient.fetch(url).then(function (res) {
            var data = services_JsonApiDeserializer.deserializeItems(res.data, res.included);
            var date = data.length ? newDate(data[0].updatedAt) : new Date();
            if (date.getTime() > _this.observable().getTime()) {
                _this.observable(date);
            }
        }).catch(function () {});
    };
};

var MessageService = new MessageService_MessageServiceClass();
/* harmony default export */ var services_MessageService = (MessageService);
// EXTERNAL MODULE: ./components/sections/personal-area/sections/messenger/message-list-item/styles.scss
var message_list_item_styles = __webpack_require__("MVb4");
var message_list_item_styles_default = /*#__PURE__*/__webpack_require__.n(message_list_item_styles);

// CONCATENATED MODULE: ./utilities/removeHtmlTags.js
function removeHtmlTags(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}
// CONCATENATED MODULE: ./components/sections/personal-area/sections/messenger/message-list-item/index.js
var message_list_item__class, message_list_item__temp2;



function message_list_item__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function message_list_item__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function message_list_item__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var message_list_item_MessageListItem = (message_list_item__temp2 = message_list_item__class = function (_Component) {
    message_list_item__inherits(MessageListItem, _Component);

    function MessageListItem() {
        var _temp, _this, _ret;

        message_list_item__classCallCheck(this, MessageListItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = message_list_item__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.render = function (props, state, context) {
            var message = _this.props.message;
            var sender = message.sender.name;
            var content = removeHtmlTags(message.content).slice(0, 280).replace(/\W{2,}/g, ' ').trim();
            var date = Object(preact_min["h"])(simple_date_SimpleDate, { date: message.createdAt });

            var read = true;
            var reference = services_ConfigService.userProfile().reference;
            for (var _iterator = message.recipients, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var recipient = _ref;

                if (recipient.reference === reference) {
                    read = recipient.read;
                    break;
                }
            }

            var classes = [message_list_item_styles_default.a.listItemContainer, read ? null : message_list_item_styles_default.a.unread].filter(function (i) {
                return i;
            }).join(' ');

            return Object(preact_min["h"])(
                "a",
                { href: _this.getMessageUrl(), "class": classes, onClick: _this.navigateToLink },
                Object(preact_min["h"])(
                    "div",
                    { "class": message_list_item_styles_default.a.listItem },
                    Object(preact_min["h"])(
                        "h4",
                        { "class": message_list_item_styles_default.a.itemTitle },
                        message.subject
                    ),
                    Object(preact_min["h"])(
                        "div",
                        { "class": message_list_item_styles_default.a.itemBody },
                        content
                    ),
                    Object(preact_min["h"])(
                        "div",
                        { "class": message_list_item_styles_default.a.itemFooter },
                        Object(preact_min["h"])(
                            "span",
                            null,
                            sender
                        ),
                        Object(preact_min["h"])(
                            "span",
                            null,
                            date
                        )
                    )
                )
            );
        }, _this.getMessageUrl = function () {
            return services_ModuleInfoProvider.getModuleBackendUrl('extranet') + '/messages/' + _this.props.message.id;
        }, _this.navigateToLink = function (event) {
            _this.base.dispatchEvent(createEvent('closeDropdown', { bubbles: true }));
            event.preventDefault();
            event.stopPropagation();
            services_ConfigService.navigateFunction(_this.getMessageUrl());
        }, _temp), message_list_item__possibleConstructorReturn(_this, _ret);
    }

    return MessageListItem;
}(preact_min["Component"]), message_list_item__class.defaultProps = {
    message: {}
}, message_list_item__temp2);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/messenger/message-infinite-scroll-list/index.js


function message_infinite_scroll_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function message_infinite_scroll_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function message_infinite_scroll_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var message_infinite_scroll_list_MessageInfiniteScrollList = function (_InfiniteScrollList) {
    message_infinite_scroll_list__inherits(MessageInfiniteScrollList, _InfiniteScrollList);

    function MessageInfiniteScrollList(props) {
        message_infinite_scroll_list__classCallCheck(this, MessageInfiniteScrollList);

        var _this = message_infinite_scroll_list__possibleConstructorReturn(this, _InfiniteScrollList.call(this, props));

        _this.emptyStateMessage = 'message.list.empty';
        _this.messengerDomain = '';

        _this.renderItem = function (item) {
            return Object(preact_min["h"])(message_list_item_MessageListItem, { message: item });
        };

        _this.getPrevRequest = function () {
            var domain = _this.messengerDomain;
            var list = _this.state.list;
            var boundId = list.length ? list[0].id : 0;
            return services_JWTClient.fetch(domain + '/messages?received=1&draft=0&sortBy=id&direction=desc&afterId=' + boundId);
        };

        _this.getNextRequest = function () {
            var domain = _this.messengerDomain;
            var list = _this.state.list;
            var beforeId = list.length ? list[list.length - 1].id : 100000000;
            return services_JWTClient.fetch(domain + '/messages?limit=10&received=1&draft=0&sortBy=id&direction=desc&beforeId=' + beforeId);
        };

        _this.messengerDomain = services_ModuleInfoProvider.getModuleWebServiceUrl('messenger');
        return _this;
    }

    MessageInfiniteScrollList.prototype.componentDidMount = function componentDidMount() {
        this.getNext();
        services_MessageService.observable.subscribe(this.getNext);
    };

    MessageInfiniteScrollList.prototype.componentWillUnmount = function componentWillUnmount() {
        services_MessageService.observable.unsubscribe(this.getNext);
    };

    return MessageInfiniteScrollList;
}(infinite_scroll_list_InfiniteScrollList);


// EXTERNAL MODULE: ./components/sections/personal-area/sections/messenger/message-list/styles.scss
var message_list_styles = __webpack_require__("4eQi");
var message_list_styles_default = /*#__PURE__*/__webpack_require__.n(message_list_styles);

// EXTERNAL MODULE: ../node_modules/mdi-preact/EmailOutlineIcon.js
var EmailOutlineIcon = __webpack_require__("izIX");
var EmailOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(EmailOutlineIcon);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/messenger/message-list/index.js


function message_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function message_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function message_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var message_list__ref = Object(preact_min["h"])(EmailOutlineIcon_default.a, null);

var message_list__ref2 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'message.list' })
);

var message_list__ref3 = Object(preact_min["h"])(message_infinite_scroll_list_MessageInfiniteScrollList, null);

var message_list_MessageList = function (_InfiniteScrollList) {
    message_list__inherits(MessageList, _InfiniteScrollList);

    function MessageList() {
        message_list__classCallCheck(this, MessageList);

        return message_list__possibleConstructorReturn(this, _InfiniteScrollList.apply(this, arguments));
    }

    MessageList.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { "class": message_list_styles_default.a.toolbar },
                Object(preact_min["h"])(
                    "div",
                    { className: message_list_styles_default.a.iconButton },
                    message_list__ref
                ),
                message_list__ref2
            ),
            message_list__ref3
        );
    };

    return MessageList;
}(infinite_scroll_list_InfiniteScrollList);


// CONCATENATED MODULE: ./components/sections/personal-area/sections/messenger/messenger-button/index.js
var messenger_button__class, messenger_button__temp;



function messenger_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function messenger_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function messenger_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var messenger_button__ref = Object(preact_min["h"])(EmailIcon_default.a, null);

var messenger_button__ref2 = Object(preact_min["h"])(message_list_MessageList, null);

var messenger_button_MessengerButton = (messenger_button__temp = messenger_button__class = function (_Component) {
    messenger_button__inherits(MessengerButton, _Component);

    function MessengerButton(props) {
        messenger_button__classCallCheck(this, MessengerButton);

        var _this = messenger_button__possibleConstructorReturn(this, _Component.call(this, props));

        _this.toggleDropdown = function () {
            _this.setState({ open: !_this.state.open });
        };

        _this.fetchMessages = function () {
            _this.setState({ loading: true, error: false });
            var domain = services_ModuleInfoProvider.getModuleWebServiceUrl('messenger');

            services_JWTClient.fetch(domain + '/message-counter').then(function (res) {
                _this.setState({
                    loading: false,
                    error: false,
                    unreadCount: parseInt(res.data.unread)
                });
                services_MessageService.badge(parseInt(res.data.unread));
            }).catch(function (e) {
                console.log(e);
                _this.setState({ loading: false, error: true, unreadCount: 0 });
                services_MessageService.badge(0);
            });
        };

        _this.state = {
            loading: true,
            error: false,
            unreadCount: 0,
            open: false
        };
        return _this;
    }

    MessengerButton.prototype.componentDidMount = function componentDidMount() {
        this.fetchMessages();
        services_MessageService.start();
        services_MessageService.observable.subscribe(this.fetchMessages);
    };

    MessengerButton.prototype.componentWillUnmount = function componentWillUnmount() {
        services_MessageService.stop();
        services_MessageService.observable.unsubscribe(this.fetchMessages);
    };

    MessengerButton.prototype.render = function render(props) {
        var _this2 = this;

        var purchased = services_ModuleInfoProvider.getModule('messenger').purchased;
        if (!purchased) return null;

        var unreadBadge = function unreadBadge() {
            return _this2.state.unreadCount ? Object(preact_min["h"])(
                simple_badge_SimpleBadge,
                null,
                _this2.state.unreadCount
            ) : null;
        };
        var buttonStyles = this.state.open ? { background: '#0079B8' } : {};

        return Object(preact_min["h"])(
            outside_click_wrapper_OutsideClickWrapper,
            { watch: this.state.open, onOutsideClick: this.toggleDropdown },
            Object(preact_min["h"])(
                section_component_SectionComponent,
                null,
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { onClick: this.toggleDropdown, title: translate('message.list'), style: buttonStyles },
                    messenger_button__ref,
                    unreadBadge()
                ),
                Object(preact_min["h"])(
                    dropdown_DropDownMenu,
                    { open: this.state.open, closeFunction: this.toggleDropdown },
                    messenger_button__ref2
                )
            )
        );
    };

    return MessengerButton;
}(preact_min["Component"]), messenger_button__class.defaultProps = {
    jwt: ''
}, messenger_button__temp);

// EXTERNAL MODULE: ../node_modules/mdi-preact/ChatIcon.js
var ChatIcon = __webpack_require__("ad0j");
var ChatIcon_default = /*#__PURE__*/__webpack_require__.n(ChatIcon);

// EXTERNAL MODULE: ../node_modules/mdi-preact/PlusIcon.js
var PlusIcon = __webpack_require__("kpgR");
var PlusIcon_default = /*#__PURE__*/__webpack_require__.n(PlusIcon);

// CONCATENATED MODULE: ./services/ChatService.js
function ChatService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var ChatService_ChatServiceClass = function ChatServiceClass() {
    var _this = this;

    ChatService__classCallCheck(this, ChatServiceClass);

    this.observable = trkl_min_default()(newDate('2000-01-01T00:00:00+0000'));
    this.badge = trkl_min_default()(0);

    this.start = function () {
        if (_this.intervalId !== undefined) return;
        _this.intervalId = setInterval(_this.checkForUpdates, 10000);
    };

    this.stop = function () {
        if (_this.intervalId === undefined) return;
        clearInterval(_this.intervalId);
    };

    this.checkForUpdates = function () {
        if (!services_ConfigService.userProfile()) return;

        var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat') + '/chats?sortBy=lastMessage&direction=desc&limit=1';
        services_JWTClient.fetch(url).then(function (res) {
            var data = services_JsonApiDeserializer.deserializeItems(res.data, res.included);
            if (data.length) {
                var date = newDate(data[0].updatedAt);
                if (date > _this.observable()) {
                    _this.observable(date);
                }
            }
        }).catch(function () {});
    };
};

var ChatService = new ChatService_ChatServiceClass();
/* harmony default export */ var services_ChatService = (ChatService);
// EXTERNAL MODULE: ./components/sections/personal-area/sections/chat/chat-list-item/styles.scss
var chat_list_item_styles = __webpack_require__("lsHX");
var chat_list_item_styles_default = /*#__PURE__*/__webpack_require__.n(chat_list_item_styles);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/chat-list-item/index.js
var chat_list_item__class, chat_list_item__temp;



function chat_list_item__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chat_list_item__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function chat_list_item__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var chat_list_item_ChatListItem = (chat_list_item__temp = chat_list_item__class = function (_Component) {
    chat_list_item__inherits(ChatListItem, _Component);

    function ChatListItem() {
        chat_list_item__classCallCheck(this, ChatListItem);

        return chat_list_item__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ChatListItem.prototype.render = function render(props, state, context) {
        var classes = [chat_list_item_styles_default.a.container];
        if (!props.item.read) classes.push(chat_list_item_styles_default.a.unread);

        var title = this.getChatTitle(props.item);
        var subtitle = function subtitle() {
            return props.item.lastMessage ? Object(preact_min["h"])(
                "div",
                { "class": chat_list_item_styles_default.a.subtitle },
                props.item.lastMessage.content
            ) : null;
        };

        return Object(preact_min["h"])(
            toolbar_Toolbar,
            { "class": chat_list_item_styles_default.a.toolbar },
            Object(preact_min["h"])(
                toolbar_button_ToolbarButton,
                { type: 'fill text', onClick: this.props.onClick },
                Object(preact_min["h"])(
                    "div",
                    { "class": classes.join(' ') },
                    Object(preact_min["h"])(
                        "div",
                        { "class": chat_list_item_styles_default.a.icon },
                        Object(preact_min["h"])(letter_icon_LetterIcon, { text: title })
                    ),
                    Object(preact_min["h"])(
                        "div",
                        { "class": chat_list_item_styles_default.a.body },
                        Object(preact_min["h"])(
                            "div",
                            { "class": chat_list_item_styles_default.a.title },
                            title
                        ),
                        subtitle()
                    )
                )
            )
        );
    };

    ChatListItem.prototype.getChatTitle = function getChatTitle(item) {
        if (item.title) return item.title;
        var userReference = services_ConfigService.userProfile().reference;
        var subject = item.subjects.filter(function (s) {
            return s.reference !== userReference;
        })[0];
        return subject.name || subject.email;
    };

    return ChatListItem;
}(preact_min["Component"]), chat_list_item__class.defaultProps = {
    item: {},
    onClick: function onClick() {}
}, chat_list_item__temp);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/chat-infinite-scroll-list/index.js
var chat_infinite_scroll_list__class, chat_infinite_scroll_list__temp;



function chat_infinite_scroll_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chat_infinite_scroll_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function chat_infinite_scroll_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var chat_infinite_scroll_list_ChatInfiniteScrollList = (chat_infinite_scroll_list__temp = chat_infinite_scroll_list__class = function (_InfiniteScrollList) {
    chat_infinite_scroll_list__inherits(ChatInfiniteScrollList, _InfiniteScrollList);

    function ChatInfiniteScrollList(props) {
        chat_infinite_scroll_list__classCallCheck(this, ChatInfiniteScrollList);

        var _this = chat_infinite_scroll_list__possibleConstructorReturn(this, _InfiniteScrollList.call(this, props));

        _this.emptyStateMessage = 'chat.list.empty';
        _this.chatDomain = '';

        _this.renderItem = function (item) {
            return Object(preact_min["h"])(chat_list_item_ChatListItem, { item: item, onClick: function onClick() {
                    return _this.props.onChatClick(item);
                } });
        };

        _this.getRefreshRequest = function () {
            var limit = _this.state.list.length;
            return services_JWTClient.fetch(_this.chatDomain + '/chats?sortBy=lastMessage&direction=desc&page=1&limit=' + limit);
        };

        _this.getNextRequest = function () {
            return services_JWTClient.fetch(_this.chatDomain + '/chats?sortBy=lastMessage&direction=desc&limit=20&page=' + _this.state.page).then(function (res) {
                _this.setState({ page: (_this.state.page || 1) + 1 });
                return res;
            });
        };

        _this.chatDomain = services_ModuleInfoProvider.getModuleWebServiceUrl('chat');
        _this.state.page = 1;
        return _this;
    }

    ChatInfiniteScrollList.prototype.componentDidMount = function componentDidMount() {
        this.getNext();
        services_ChatService.observable.subscribe(this.refresh);
    };

    ChatInfiniteScrollList.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ChatService.observable.unsubscribe(this.refresh);
    };

    return ChatInfiniteScrollList;
}(infinite_scroll_list_InfiniteScrollList), chat_infinite_scroll_list__class.defaultProps = {
    onChatClick: function onChatClick() {}
}, chat_infinite_scroll_list__temp);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/chat/chat-list/styles.scss
var chat_list_styles = __webpack_require__("BvS8");
var chat_list_styles_default = /*#__PURE__*/__webpack_require__.n(chat_list_styles);

// EXTERNAL MODULE: ../node_modules/mdi-preact/ChatOutlineIcon.js
var ChatOutlineIcon = __webpack_require__("8lA1");
var ChatOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(ChatOutlineIcon);

// CONCATENATED MODULE: ./components/common/permission/permission.js
function permission__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function permission__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function permission__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var permission_Permission = function (_Component) {
    permission__inherits(Permission, _Component);

    function Permission(props) {
        permission__classCallCheck(this, Permission);

        var _this = permission__possibleConstructorReturn(this, _Component.call(this, props));

        _this.check = function () {
            var enabled = true;
            var permissions = _this.props.permissions || [];
            var actions = services_ConfigService.domainActions() || [];
            for (var i = 0; i < permissions.length; i++) {
                if (!actions.includes(permissions[i])) {
                    enabled = false;
                    break;
                }
            }
            _this.setState({ enabled: enabled });
        };

        _this.store = {
            enabled: false
        };
        return _this;
    }

    Permission.prototype.componentDidMount = function componentDidMount() {
        services_ConfigService.domainActions.subscribe(this.check, true);
    };

    Permission.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ConfigService.domainActions.unsubscribe(this.check);
    };

    Permission.prototype.render = function render(_ref, _ref2, context) {
        var permissions = _ref.permissions,
            children = _ref.children;
        var enabled = _ref2.enabled;

        return enabled ? children[0] || null : null;
    };

    return Permission;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/chat-list/index.js
var chat_list__class, chat_list__temp2;



function chat_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chat_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function chat_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var chat_list__ref = Object(preact_min["h"])(ChatOutlineIcon_default.a, null);

var chat_list__ref2 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'chat.title' })
);

var chat_list__ref3 = Object(preact_min["h"])(PlusIcon_default.a, null);

var chat_list_ChatList = (chat_list__temp2 = chat_list__class = function (_Component) {
    chat_list__inherits(ChatList, _Component);

    function ChatList() {
        var _temp, _this, _ret;

        chat_list__classCallCheck(this, ChatList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = chat_list__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChat = function (chat) {
            _this.props.onNavigate('read', { chat: chat });
        }, _this.newChat = function () {
            return _this.props.onNavigate('create');
        }, _temp), chat_list__possibleConstructorReturn(_this, _ret);
    }

    ChatList.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { "class": chat_list_styles_default.a.toolbar },
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexGrow: 2 } },
                    Object(preact_min["h"])(
                        "div",
                        { "class": chat_list_styles_default.a.iconButton },
                        chat_list__ref
                    ),
                    chat_list__ref2
                ),
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexShrink: 0 } },
                    Object(preact_min["h"])(
                        permission_Permission,
                        { permissions: ['chat.create'] },
                        Object(preact_min["h"])(
                            toolbar_button_ToolbarButton,
                            { onClick: this.newChat, title: translate('chat.new.title') },
                            chat_list__ref3
                        )
                    )
                )
            ),
            Object(preact_min["h"])(chat_infinite_scroll_list_ChatInfiniteScrollList, { onChatClick: this.getChat })
        );
    };

    return ChatList;
}(preact_min["Component"]), chat_list__class.defaultProps = {
    onNavigate: function onNavigate() {}
}, chat_list__temp2);

// EXTERNAL MODULE: ../node_modules/mdi-preact/SendIcon.js
var SendIcon = __webpack_require__("do9D");
var SendIcon_default = /*#__PURE__*/__webpack_require__.n(SendIcon);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/chat/contact-item/styles.scss
var contact_item_styles = __webpack_require__("lk0u");
var contact_item_styles_default = /*#__PURE__*/__webpack_require__.n(contact_item_styles);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/contact-item/index.js
var contact_item__class, contact_item__temp2;



function contact_item__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contact_item__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contact_item__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var contact_item_ContactItem = (contact_item__temp2 = contact_item__class = function (_Component) {
    contact_item__inherits(ContactItem, _Component);

    function ContactItem() {
        var _temp, _this, _ret;

        contact_item__classCallCheck(this, ContactItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = contact_item__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.toggle = function () {
            _this.props.onToggle(_this.props.item.id);
        }, _temp), contact_item__possibleConstructorReturn(_this, _ret);
    }

    ContactItem.prototype.render = function render(props, state, context) {
        var x = Object(preact_min["h"])("div", { "class": contact_item_styles_default.a.check });

        return Object(preact_min["h"])(
            toolbar_Toolbar,
            null,
            Object(preact_min["h"])(
                toolbar_button_ToolbarButton,
                { type: 'fill', onClick: this.toggle },
                Object(preact_min["h"])(
                    "div",
                    { "class": contact_item_styles_default.a.container },
                    Object(preact_min["h"])(
                        "div",
                        { "class": contact_item_styles_default.a.contactCheckbox },
                        this.props.selected ? x : null
                    ),
                    Object(preact_min["h"])(
                        "div",
                        { "class": contact_item_styles_default.a.contactBody },
                        props.item.username
                    )
                )
            )
        );
    };

    return ContactItem;
}(preact_min["Component"]), contact_item__class.defaultProps = {
    item: {},
    selected: false,
    onToggle: function onToggle() {}
}, contact_item__temp2);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/contacts-infinite-scroll-list/index.js
var contacts_infinite_scroll_list__class, contacts_infinite_scroll_list__temp;



function contacts_infinite_scroll_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contacts_infinite_scroll_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contacts_infinite_scroll_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var contacts_infinite_scroll_list_ContactsInfiniteScrollList = (contacts_infinite_scroll_list__temp = contacts_infinite_scroll_list__class = function (_InfiniteScrollList) {
    contacts_infinite_scroll_list__inherits(ContactsInfiniteScrollList, _InfiniteScrollList);

    function ContactsInfiniteScrollList(props) {
        contacts_infinite_scroll_list__classCallCheck(this, ContactsInfiniteScrollList);

        var _this = contacts_infinite_scroll_list__possibleConstructorReturn(this, _InfiniteScrollList.call(this, props));

        _this.emptyStateMessage = 'chat.list.empty';
        _this.domain = services_ConfigService.organigrammaServerUrl();
        _this.profileId = services_ConfigService.userProfile().id;

        _this.renderItem = function (item) {
            return item.id === _this.profileId ? null : Object(preact_min["h"])(contact_item_ContactItem, { item: item,
                onToggle: _this.toggle,
                selected: _this.props.selectedContacts.hasOwnProperty(item.id)
            });
        };

        _this.getNextRequest = function () {
            return services_JWTClient.fetch(_this.domain + '/users?sortBy=username&direction=asc&limit=30&page=' + _this.state.page).then(function (res) {
                _this.setState({ page: (_this.state.page || 1) + 1 });
                return res;
            });
        };

        _this.toggle = function (contactId) {
            var map = _this.props.selectedContacts;
            if (map.hasOwnProperty(contactId)) {
                delete map[contactId];
            } else {
                map[contactId] = _this.state.list.find(function (c) {
                    return c.id === contactId;
                });
            }
            _this.props.onSelect(map);
        };

        _this.state.page = 1;
        return _this;
    }

    ContactsInfiniteScrollList.prototype.componentDidMount = function componentDidMount() {
        this.getNext();
    };

    return ContactsInfiniteScrollList;
}(infinite_scroll_list_InfiniteScrollList), contacts_infinite_scroll_list__class.defaultProps = {
    onSelect: function onSelect() {},
    selectedContacts: {}
}, contacts_infinite_scroll_list__temp);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/create-chat/index.js
var create_chat__class, create_chat__temp;



function create_chat__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function create_chat__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function create_chat__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var create_chat__ref = Object(preact_min["h"])(
    backdrop_cover_BackdropCover,
    null,
    Object(preact_min["h"])(spinner_Spinner, null)
);

var create_chat__ref2 = Object(preact_min["h"])(ArrowLeftIcon_default.a, null);

var create_chat__ref3 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'chat.new.title' })
);

var create_chat__ref4 = Object(preact_min["h"])(SendIcon_default.a, null);

var create_chat__ref5 = Object(preact_min["h"])(text_Text, { text: 'error.loading' });

var create_chat__ref6 = Object(preact_min["h"])(text_Text, { text: 'action.retry' });

var create_chat_CreateChat = (create_chat__temp = create_chat__class = function (_Component) {
    create_chat__inherits(CreateChat, _Component);

    function CreateChat(props) {
        create_chat__classCallCheck(this, CreateChat);

        var _this = create_chat__possibleConstructorReturn(this, _Component.call(this, props));

        _this.onSelect = function (contacts) {
            _this.setState({ selectedContacts: contacts });
        };

        _this.newChat = function () {
            var selectedContacts = Object.keys(_this.state.selectedContacts).map(function (k) {
                return _this.state.selectedContacts[k];
            });
            if (!selectedContacts.length) return;

            if (selectedContacts.length > 1) {
                _this.props.onNavigate('createGroup', { selectedContacts: _this.state.selectedContacts });
                return;
            }

            var subjectsData = selectedContacts.map(function (c) {
                return {
                    name: c.username,
                    email: c.email,
                    reference: c.reference
                };
            });

            var profile = services_ConfigService.userProfile();
            subjectsData.push({
                name: profile.username,
                email: profile.email,
                reference: profile.reference
            });

            _this.setState({ creating: true });
            var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat');
            services_JWTClient.fetch(url + '/chats', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    type: 'singleChat',
                    subjects: subjectsData
                })
            }).then(function (res) {
                var chat = services_JsonApiDeserializer.deserializeItem(res.data, res.included);
                _this.props.onNavigate('read', { chat: chat });
                _this.setState({ creating: false, error: false });
            }).catch(function (err) {
                console.error(err);
                _this.setState({ creating: false, error: true });
            });
        };

        _this.backToList = function () {
            return _this.props.onNavigate('list');
        };

        _this.state = {
            creating: false,
            error: false,
            selectedContacts: {}
        };
        return _this;
    }

    CreateChat.prototype.componentDidMount = function componentDidMount() {
        this.setState({ selectedContacts: this.props.selectedContacts || {} });
    };

    CreateChat.prototype.render = function render(props, state, context) {
        var creationSpinner = create_chat__ref;
        var minimumSelected = Object.keys(this.state.selectedContacts).length;

        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            this.state.creating ? creationSpinner : null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { style: { borderBottom: '1px solid #eee', height: '4em' } },
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexGrow: 0 } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.backToList, title: translate('action.back') },
                        create_chat__ref2
                    )
                ),
                Object(preact_min["h"])(
                    "div",
                    { style: { flexGrow: 2 } },
                    create_chat__ref3
                ),
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexShrink: 0 } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.newChat, disabled: !minimumSelected, title: translate('action.send') },
                        create_chat__ref4
                    )
                )
            ),
            state.error ? Object(preact_min["h"])(
                error_state_ErrorState,
                null,
                create_chat__ref5,
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { type: 'primary fill', style: { marginTop: '1em' }, onClick: this.newChat },
                    create_chat__ref6
                )
            ) : Object(preact_min["h"])(contacts_infinite_scroll_list_ContactsInfiniteScrollList, { selectedContacts: state.selectedContacts, onSelect: this.onSelect })
        );
    };

    return CreateChat;
}(preact_min["Component"]), create_chat__class.defaultProps = {
    onNavigate: function onNavigate() {},
    selectedContacts: {}
}, create_chat__temp);

// EXTERNAL MODULE: ./components/common/custom-input/styles.scss
var custom_input_styles = __webpack_require__("6sAH");
var custom_input_styles_default = /*#__PURE__*/__webpack_require__.n(custom_input_styles);

// CONCATENATED MODULE: ./components/common/custom-input/index.js
var custom_input__class, custom_input__temp;



function custom_input__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function custom_input__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function custom_input__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var custom_input_CustomInput = (custom_input__temp = custom_input__class = function (_Component) {
    custom_input__inherits(CustomInput, _Component);

    function CustomInput() {
        custom_input__classCallCheck(this, CustomInput);

        return custom_input__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    CustomInput.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            toolbar_Toolbar,
            null,
            Object(preact_min["h"])("input", { "class": custom_input_styles_default.a.input,
                type: 'text',
                value: props.value,
                onInput: props.onChange,
                placeholder: props.placeholder,
                id: props.id
            })
        );
    };

    return CustomInput;
}(preact_min["Component"]), custom_input__class.defaultProps = {
    value: '',
    id: null,
    placeholder: '',
    onChange: function onChange() {}
}, custom_input__temp);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/chat/message-list/styles.scss
var chat_message_list_styles = __webpack_require__("UsHK");
var chat_message_list_styles_default = /*#__PURE__*/__webpack_require__.n(chat_message_list_styles);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/chat/message-list-item/styles.scss
var chat_message_list_item_styles = __webpack_require__("Oa0z");
var chat_message_list_item_styles_default = /*#__PURE__*/__webpack_require__.n(chat_message_list_item_styles);

// CONCATENATED MODULE: ./components/common/date/custom-date/index.js
var custom_date__class, custom_date__temp;



function custom_date__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function custom_date__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function custom_date__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var custom_date_CustomDate = (custom_date__temp = custom_date__class = function (_Component) {
    custom_date__inherits(CustomDate, _Component);

    function CustomDate() {
        custom_date__classCallCheck(this, CustomDate);

        return custom_date__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    CustomDate.prototype.render = function render(props, state, context) {
        if (!props.date) return null;

        var date = dayjs_min_default()(newDate(props.date)).locale(services_ConfigService.currentLanguage());

        var format = 'YYYY-MM-DD HH:mm';
        var dateString = date.format(format);
        var displayDateString = date.format(props.format);

        return Object(preact_min["h"])(
            "span",
            { title: dateString },
            displayDateString
        );
    };

    return CustomDate;
}(preact_min["Component"]), custom_date__class.defaultProps = {
    date: null,
    format: 'YYYY-MM-DD HH:mm'
}, custom_date__temp);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/message-list-item/index.js
var chat_message_list_item__class, message_list_item__temp;



function chat_message_list_item__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chat_message_list_item__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function chat_message_list_item__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var chat_message_list_item_MessageListItem = (message_list_item__temp = chat_message_list_item__class = function (_Component) {
    chat_message_list_item__inherits(MessageListItem, _Component);

    function MessageListItem(props) {
        chat_message_list_item__classCallCheck(this, MessageListItem);

        var _this = chat_message_list_item__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            user: services_ConfigService.userProfile().reference
        };
        return _this;
    }

    MessageListItem.prototype.render = function render(props, state, context) {
        var isFromOther = this.state.user !== this.props.message.createdBy;
        var classes = [chat_message_list_item_styles_default.a.message, isFromOther ? chat_message_list_item_styles_default.a.other : chat_message_list_item_styles_default.a.self, isIE() ? chat_message_list_item_styles_default.a.ie : null].filter(function (i) {
            return i;
        }).join(' ');
        var date = Object(preact_min["h"])(custom_date_CustomDate, { date: this.props.message.createdAt, format: 'HH:mm' });

        var user = function user() {
            return !(props.showUser && isFromOther) ? null : Object(preact_min["h"])(
                "div",
                { className: chat_message_list_item_styles_default.a.userText },
                Object(preact_min["h"])(
                    "span",
                    null,
                    props.sender.name
                )
            );
        };

        return Object(preact_min["h"])(
            "div",
            { "class": classes },
            user(),
            Object(preact_min["h"])(
                "div",
                { className: chat_message_list_item_styles_default.a.contentRow },
                Object(preact_min["h"])(
                    "div",
                    { className: chat_message_list_item_styles_default.a.textBox },
                    props.message.content
                ),
                Object(preact_min["h"])(
                    "div",
                    { className: chat_message_list_item_styles_default.a.dateText },
                    date
                )
            )
        );
    };

    return MessageListItem;
}(preact_min["Component"]), chat_message_list_item__class.defaultProps = {
    message: {},
    showUser: false,
    sender: {}
}, message_list_item__temp);

// EXTERNAL MODULE: ../node_modules/mdi-preact/InformationOutlineIcon.js
var InformationOutlineIcon = __webpack_require__("OEJM");
var InformationOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(InformationOutlineIcon);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/message-list/index.js
var message_list__class, message_list__temp;



function chat_message_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chat_message_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function chat_message_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var chat_message_list__ref = Object(preact_min["h"])(
    backdrop_cover_BackdropCover,
    null,
    Object(preact_min["h"])(spinner_Spinner, null)
);

var chat_message_list__ref2 = Object(preact_min["h"])(PlusIcon_default.a, null);

var chat_message_list__ref3 = Object(preact_min["h"])(text_Text, { text: 'action.load-previous' });

var message_list__ref4 = Object(preact_min["h"])(
    empty_state_EmptyState,
    null,
    Object(preact_min["h"])(text_Text, { text: 'chat.read.empty' })
);

var message_list__ref5 = Object(preact_min["h"])(
    error_state_ErrorState,
    null,
    Object(preact_min["h"])(text_Text, { text: 'error.loading' })
);

var message_list__ref7 = Object(preact_min["h"])(ArrowLeftIcon_default.a, null);

var message_list__ref8 = Object(preact_min["h"])(SendIcon_default.a, null);

var chat_message_list_MessageList = (message_list__temp = message_list__class = function (_Component) {
    chat_message_list__inherits(MessageList, _Component);

    function MessageList(props) {
        chat_message_list__classCallCheck(this, MessageList);

        var _this = chat_message_list__possibleConstructorReturn(this, _Component.call(this, props));

        _this.scrollableArea = Object(preact_min["createRef"])();

        _this.onSubmit = function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (_this.state.sending) return false;
            _this.sendNewMessage();
            return false;
        };

        _this.onTextChange = function (inputEvent) {
            _this.setState({ text: inputEvent.target.value });
        };

        _this.backToList = function () {
            return _this.props.onNavigate('list');
        };

        _this.nextPage = function () {
            if (_this.state.previousPages) _this.loadPreviousMessages();
        };

        _this.readChat = function () {
            if (_this.props.chat.read) return;
            var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat') + ("/chats/" + _this.props.chat.id + "/read");
            services_JWTClient.fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
            });
        };

        _this.loadPreviousMessages = function () {
            var firstSequenceNumber = _this.state.messages.length ? _this.state.messages[0].sequenceNumber : 1000000000;
            _this.setState({ loading: true, error: false });
            var filters = "?sortBy=sequenceNumber&direction=desc&limit=20&beforeSequenceNumber=" + firstSequenceNumber;
            var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat') + ("/chats/" + _this.props.chat.id + "/messages") + filters;
            return services_JWTClient.fetch(url).then(function (res) {
                var messages = services_JsonApiDeserializer.deserializeItems(res.data, res.included);
                var newList = _this.state.messages || [];
                var position = _this.scrollableArea.current.scrollBottom();
                newList.unshift.apply(newList, messages.reverse());
                _this.setState({
                    messages: newList,
                    loading: false,
                    error: false,
                    previousPages: res.meta.pagination.total_pages - 1
                });
                setTimeout(function () {
                    _this.scrollableArea.current.scrollFromBottom(position);
                }, 0);
            }).catch(function (e) {
                _this.setState({ loading: false, error: true });
            });
        };

        _this.loadNextMessages = function () {
            var lastSequenceNumber = _this.state.messages.length ? _this.state.messages[_this.state.messages.length - 1].sequenceNumber : 0;
            var filters = "?sortBy=sequenceNumber&direction=asc&afterSequenceNumber=" + lastSequenceNumber;
            var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat') + ("/chats/" + _this.props.chat.id + "/messages") + filters;
            services_JWTClient.fetch(url).then(function (res) {
                var messages = services_JsonApiDeserializer.deserializeItems(res.data, res.included);
                var newList = _this.state.messages || [];
                // save scroll position
                var position = _this.scrollableArea.current.base.scrollTop;
                newList.push.apply(newList, messages);
                _this.setState({
                    messages: newList,
                    nextPages: res.meta.pagination.total_pages - 1
                });
                // scroll to previous position
                setTimeout(function () {
                    _this.scrollableArea.current.base.scrollTop = position;
                }, 0);
                // read chat
                _this.readChat();
            });
        };

        _this.state = {
            loading: false,
            error: false,
            messages: [],
            previousPages: 0,
            text: '',
            sending: false,
            sendingError: false,
            user: services_ConfigService.userProfile().reference,
            chatSubjects: {}
        };
        return _this;
    }

    MessageList.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var spinner = chat_message_list__ref;

        var loadMoreButton = Object(preact_min["h"])(
            toolbar_Toolbar,
            null,
            Object(preact_min["h"])(
                toolbar_button_ToolbarButton,
                { type: 'fill', onClick: this.nextPage },
                chat_message_list__ref2,
                chat_message_list__ref3
            )
        );

        var emptyState = function emptyState() {
            return !_this2.state.loading && !_this2.state.messages.length && !_this2.state.error ? message_list__ref4 : null;
        };

        var errorState = function errorState() {
            return !_this2.state.loading && _this2.state.error ? message_list__ref5 : null;
        };

        var subjects = {};
        this.props.chat.subjects.forEach(function (s) {
            subjects[s.reference] = s;
        });

        var lastSender = null;
        var lastDate = dayjs_min_default()('1970-01-01');
        var messages = [];
        for (var _iterator = state.messages, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref6;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref6 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref6 = _i.value;
            }

            var message = _ref6;

            var date = dayjs_min_default()(newDate(message.createdAt)).locale(services_ConfigService.currentLanguage());
            var isCloseToLastDate = Math.abs(lastDate.diff(date, 'second')) < 10;
            var isSameAsLastDate = lastDate.isSame(date, 'date');
            var isDateSameAsToday = dayjs_min_default()().isSame(date, 'date');
            var isLastSender = lastSender === message.createdBy && isSameAsLastDate;

            if (!isSameAsLastDate) {
                messages.push(Object(preact_min["h"])(
                    "div",
                    { "class": chat_message_list_styles_default.a.dateRow },
                    Object(preact_min["h"])(
                        "span",
                        null,
                        isDateSameAsToday ? TranslateService.t('today') : date.format('D MMM YYYY')
                    )
                ));
            }

            messages.push(Object(preact_min["h"])(chat_message_list_item_MessageListItem, { message: message,
                showUser: this.props.chat.type === 'groupChat' && !isLastSender && (!isSameAsLastDate || isCloseToLastDate),
                sender: subjects[message.createdBy]
            }));

            lastSender = message.createdBy;
            lastDate = date;
        }

        // messages.reverse();

        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            this.state.loading ? spinner : null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { "class": chat_message_list_styles_default.a.toolbar },
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexGrow: 0 } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { disabled: this.state.loading, onClick: this.backToList, title: translate('action.back') },
                        message_list__ref7
                    )
                ),
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    null,
                    Object(preact_min["h"])(
                        toolbar_title_ToolbarTitle,
                        null,
                        this.getChatTitle(this.props.chat)
                    )
                )
            ),
            Object(preact_min["h"])(
                scrollable_section_ScrollableSection,
                { "class": chat_message_list_styles_default.a.listContainer, ref: this.scrollableArea },
                emptyState(),
                errorState(),
                this.state.previousPages ? loadMoreButton : null,
                messages
            ),
            Object(preact_min["h"])(
                permission_Permission,
                { permissions: ['message.create'] },
                Object(preact_min["h"])(
                    toolbar_Toolbar,
                    null,
                    Object(preact_min["h"])(
                        "form",
                        { onSubmit: this.onSubmit, "class": chat_message_list_styles_default.a.form },
                        state.sending ? spinner : null,
                        Object(preact_min["h"])(
                            "div",
                            { style: { flex: 2 } },
                            Object(preact_min["h"])(custom_input_CustomInput, { value: state.text, onChange: this.onTextChange, placeholder: translate('chat.input-placeholder') })
                        ),
                        Object(preact_min["h"])(
                            "div",
                            { style: { flex: "0 0 auto" } },
                            Object(preact_min["h"])(
                                toolbar_button_ToolbarButton,
                                { onClick: this.onSubmit, disabled: !this.state.text.length || this.state.sending, title: translate('action.send') },
                                message_list__ref8
                            )
                        )
                    )
                )
            )
        );
    };

    MessageList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {};

    MessageList.prototype.getChatTitle = function getChatTitle(item) {
        var _this3 = this;

        if (item.title) return item.title;
        var subject = item.subjects.filter(function (s) {
            return s.reference !== _this3.state.user;
        })[0];
        return subject.name || subject.email;
    };

    MessageList.prototype.componentDidMount = function componentDidMount() {
        var _this4 = this;

        this.readChat();
        this.loadPreviousMessages().then(function () {
            return _this4.scrollableArea.current.scrollFromBottom(0);
        });
        services_ChatService.observable.subscribe(this.loadNextMessages);
    };

    MessageList.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ChatService.observable.unsubscribe(this.loadNextMessages);
    };

    MessageList.prototype.sendNewMessage = function sendNewMessage() {
        var _this5 = this;

        this.setState({ sending: true, sendingError: false });
        var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat') + "/messages";
        var data = {
            content: this.state.text,
            chat: { id: parseInt(this.props.chat.id) }
        };

        services_JWTClient.fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }).then(function (res) {
            var message = services_JsonApiDeserializer.deserializeItem(res.data, res.included);
            var messages = _this5.state.messages;
            messages.push(message);
            _this5.setState({
                sending: false,
                sendingError: false,
                text: '',
                messages: messages
            });
            setTimeout(function () {
                return _this5.scrollableArea.current.scrollFromBottom(0);
            }, 0);
        }).catch(function (err) {
            _this5.setState({
                sending: false,
                sendingError: true
            });
        });
    };

    return MessageList;
}(preact_min["Component"]), message_list__class.defaultProps = {
    chat: {}
}, message_list__temp);

// EXTERNAL MODULE: ./components/common/form-row/styles.scss
var form_row_styles = __webpack_require__("n0l+");
var form_row_styles_default = /*#__PURE__*/__webpack_require__.n(form_row_styles);

// CONCATENATED MODULE: ./components/common/form-row/index.js


function form_row__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function form_row__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function form_row__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var form_row_FormRow = function (_Component) {
    form_row__inherits(FormRow, _Component);

    function FormRow() {
        form_row__classCallCheck(this, FormRow);

        return form_row__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    FormRow.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])(
            "div",
            { "class": form_row_styles_default.a.row },
            props.children
        );
    };

    return FormRow;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/sections/personal-area/sections/chat/create-group-chat/styles.scss
var create_group_chat_styles = __webpack_require__("28Ik");
var create_group_chat_styles_default = /*#__PURE__*/__webpack_require__.n(create_group_chat_styles);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/create-group-chat/index.js
var create_group_chat__class, create_group_chat__temp;



function create_group_chat__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function create_group_chat__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function create_group_chat__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var create_group_chat__ref = Object(preact_min["h"])(
    backdrop_cover_BackdropCover,
    null,
    Object(preact_min["h"])(spinner_Spinner, null)
);

var create_group_chat__ref2 = Object(preact_min["h"])(ArrowLeftIcon_default.a, null);

var create_group_chat__ref3 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'chat.group.new.title' })
);

var create_group_chat__ref4 = Object(preact_min["h"])(SendIcon_default.a, null);

var create_group_chat__ref5 = Object(preact_min["h"])(text_Text, { text: 'chat.group.form.title-label' });

var create_group_chat__ref6 = Object(preact_min["h"])(text_Text, { text: 'chat.group.form.title-description' });

var create_group_chat_CreateGroupChat = (create_group_chat__temp = create_group_chat__class = function (_Component) {
    create_group_chat__inherits(CreateGroupChat, _Component);

    function CreateGroupChat(props) {
        create_group_chat__classCallCheck(this, CreateGroupChat);

        var _this = create_group_chat__possibleConstructorReturn(this, _Component.call(this, props));

        _this.submit = function () {
            _this.setState({ loading: true, error: false });
            if (!_this.state.title.length) {
                _this.setState({ errors: ['title.required'] });
                return;
            }

            var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat') + '/chats';

            services_JWTClient.fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    type: 'groupChat',
                    title: _this.state.title,
                    description: _this.state.description,
                    subjects: Object.keys(_this.props.selectedContacts).map(function (c) {
                        return {
                            name: _this.props.selectedContacts[c].username,
                            email: _this.props.selectedContacts[c].email,
                            reference: _this.props.selectedContacts[c].reference
                        };
                    }).concat([{
                        name: _this.state.profile.username,
                        email: _this.state.profile.email,
                        reference: _this.state.profile.reference
                    }])
                })
            }).then(function (res) {
                var chat = services_JsonApiDeserializer.deserializeItem(res.data, res.included);
                _this.props.onNavigate('read', { chat: chat });
            }).finally(function () {
                _this.setState({ loading: false });
            });
        };

        _this.backToContacts = function () {
            _this.props.onNavigate('create', { selectedContacts: _this.props.selectedContacts });
        };

        _this.setTitle = function (inputEvent) {
            _this.setState({ title: inputEvent.target.value });
        };

        _this.setDescription = function (inputEvent) {
            _this.setState({ description: inputEvent.target.value });
        };

        _this.state = {
            loading: false,
            error: false,
            title: '',
            description: '',
            profile: services_ConfigService.userProfile()
        };
        return _this;
    }

    CreateGroupChat.prototype.render = function render(props, state, context) {
        var spinner = create_group_chat__ref;

        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            this.state.loading ? spinner : null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { style: { borderBottom: '1px solid #eee', height: '4em' } },
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexGrow: 0 } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.backToContacts, title: translate('action.back') },
                        create_group_chat__ref2
                    )
                ),
                Object(preact_min["h"])(
                    "div",
                    { style: { flexGrow: 2 } },
                    create_group_chat__ref3
                ),
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexShrink: 0 } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.submit, title: translate('action.send') },
                        create_group_chat__ref4
                    )
                )
            ),
            Object(preact_min["h"])(
                scrollable_section_ScrollableSection,
                null,
                Object(preact_min["h"])(
                    "form",
                    { onSubmit: this.submit, "class": create_group_chat_styles_default.a.form },
                    Object(preact_min["h"])(
                        form_row_FormRow,
                        null,
                        Object(preact_min["h"])(
                            "label",
                            { className: create_group_chat_styles_default.a.label, "for": "global-top-bar-group-chat-title" },
                            create_group_chat__ref5
                        ),
                        Object(preact_min["h"])(custom_input_CustomInput, { id: 'global-top-bar-group-chat-title', value: this.state.title, onChange: this.setTitle })
                    ),
                    Object(preact_min["h"])(
                        form_row_FormRow,
                        null,
                        Object(preact_min["h"])(
                            "label",
                            { className: create_group_chat_styles_default.a.label, "for": "global-top-bar-group-chat-description" },
                            create_group_chat__ref6
                        ),
                        Object(preact_min["h"])(custom_input_CustomInput, { id: 'global-top-bar-group-chat-description', value: this.state.description, onChange: this.setDescription })
                    )
                )
            )
        );
    };

    return CreateGroupChat;
}(preact_min["Component"]), create_group_chat__class.defaultProps = {
    onNavigate: function onNavigate() {},
    selectedContacts: {}
}, create_group_chat__temp);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/chat-main/index.js


function chat_main__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chat_main__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function chat_main__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var chat_main_ChatMain = function (_Component) {
    chat_main__inherits(ChatMain, _Component);

    function ChatMain(props) {
        chat_main__classCallCheck(this, ChatMain);

        var _this = chat_main__possibleConstructorReturn(this, _Component.call(this, props));

        _this.navigate = function (page) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _this.setState({
                page: page,
                params: params || {}
            });
        };

        _this.state = {
            page: 'list',
            params: {}
        };
        return _this;
    }

    ChatMain.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var pages = {
            list: function list() {
                return Object(preact_min["h"])(chat_list_ChatList, { onNavigate: _this2.navigate });
            },
            create: function create() {
                return Object(preact_min["h"])(create_chat_CreateChat, { onNavigate: _this2.navigate, selectedContacts: _this2.state.params.selectedContacts || {} });
            },
            read: function read() {
                return Object(preact_min["h"])(chat_message_list_MessageList, { onNavigate: _this2.navigate, chat: _this2.state.params.chat });
            },
            createGroup: function createGroup() {
                return Object(preact_min["h"])(create_group_chat_CreateGroupChat, { onNavigate: _this2.navigate, selectedContacts: _this2.state.params.selectedContacts || {} });
            }
        };

        return pages[this.state.page]();
    };

    return ChatMain;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sections/personal-area/sections/chat/chat-button/index.js
var chat_button__class, chat_button__temp;



function chat_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chat_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function chat_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var chat_button__ref = Object(preact_min["h"])(ChatIcon_default.a, null);

var chat_button__ref2 = Object(preact_min["h"])(chat_main_ChatMain, null);

var chat_button_ChatButton = (chat_button__temp = chat_button__class = function (_Component) {
    chat_button__inherits(ChatButton, _Component);

    function ChatButton(props) {
        chat_button__classCallCheck(this, ChatButton);

        var _this = chat_button__possibleConstructorReturn(this, _Component.call(this, props));

        _this.toggleDropdown = function () {
            _this.setState({ open: !_this.state.open });
        };

        _this.getUnreadChatsCount = function () {
            _this.setState({ loading: true, error: false });
            var url = services_ModuleInfoProvider.getModuleWebServiceUrl('chat') + '/message-counter';
            services_JWTClient.fetch(url).then(function (res) {
                var count = parseInt(res.data.unread);
                _this.setState({ loading: false, error: false, count: count });
                services_ChatService.badge(count);
            }).catch(function () {
                _this.setState({ loading: false, error: true, count: 0 });
                services_ChatService.badge(0);
            });
        };

        _this.state = {
            loading: true,
            error: false,
            count: 0,
            open: false
        };
        return _this;
    }

    ChatButton.prototype.componentDidMount = function componentDidMount() {
        services_ChatService.start();
        services_ChatService.observable.subscribe(this.getUnreadChatsCount, true);
    };

    ChatButton.prototype.componentWillUnmount = function componentWillUnmount() {
        services_ChatService.stop();
        services_ChatService.observable.unsubscribe(this.getUnreadChatsCount, true);
    };

    ChatButton.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var purchased = services_ModuleInfoProvider.getModule('chat').purchased;
        if (!purchased) return null;

        var badge = function badge() {
            return _this2.state.count ? Object(preact_min["h"])(
                simple_badge_SimpleBadge,
                null,
                _this2.state.count
            ) : null;
        };
        var buttonStyles = this.state.open ? { background: '#0079B8' } : {};

        return Object(preact_min["h"])(
            outside_click_wrapper_OutsideClickWrapper,
            { watch: this.state.open, onOutsideClick: this.toggleDropdown },
            Object(preact_min["h"])(
                section_component_SectionComponent,
                null,
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { onClick: this.toggleDropdown, title: translate('chat.title'), style: buttonStyles },
                    badge(),
                    chat_button__ref
                ),
                Object(preact_min["h"])(
                    dropdown_DropDownMenu,
                    { open: this.state.open, closeFunction: this.toggleDropdown },
                    chat_button__ref2
                )
            )
        );
    };

    return ChatButton;
}(preact_min["Component"]), chat_button__class.defaultProps = {
    open: false
}, chat_button__temp);

// EXTERNAL MODULE: ../node_modules/mdi-preact/AccountOffIcon.js
var AccountOffIcon = __webpack_require__("goyd");
var AccountOffIcon_default = /*#__PURE__*/__webpack_require__.n(AccountOffIcon);

// EXTERNAL MODULE: ../node_modules/mdi-preact/HelpCircleOutlineIcon.js
var HelpCircleOutlineIcon = __webpack_require__("laXD");
var HelpCircleOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(HelpCircleOutlineIcon);

// EXTERNAL MODULE: ../node_modules/mdi-preact/BookmarkOutlineIcon.js
var BookmarkOutlineIcon = __webpack_require__("rIYo");
var BookmarkOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(BookmarkOutlineIcon);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/help-desk/help-desk-menu/styles.scss
var help_desk_menu_styles = __webpack_require__("P0Gr");
var help_desk_menu_styles_default = /*#__PURE__*/__webpack_require__.n(help_desk_menu_styles);

// EXTERNAL MODULE: ../node_modules/mdi-preact/OpenInNewIcon.js
var OpenInNewIcon = __webpack_require__("zp5c");
var OpenInNewIcon_default = /*#__PURE__*/__webpack_require__.n(OpenInNewIcon);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/help-desk/help-desk-menu/index.js
var help_desk_menu__class, help_desk_menu__temp;



function help_desk_menu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function help_desk_menu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function help_desk_menu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var help_desk_menu__ref = Object(preact_min["h"])(text_Text, { text: 'manuals_dropdown_title' });

var help_desk_menu__ref2 = Object(preact_min["h"])("path", { d: "M12.5 24h-1a2.8 2.8 0 01-2.8-2.8v-.5c0-.1 0-.2-.2-.3h-.3l-.4.4a2.8 2.8 0 01-4 0l-.6-.6a2.8 2.8 0 010-4l.3-.4v-.3c0-.1 0-.2-.2-.2h-.5A2.8 2.8 0 010 12.5v-1C0 10 1.3 8.7 2.8 8.7h.5c.1 0 .2 0 .3-.2v-.3l-.4-.4a2.8 2.8 0 010-4l.6-.6a2.8 2.8 0 014 0l.4.3h.3c.1 0 .2 0 .2-.2v-.5C8.7 1.3 10 0 11.5 0h1c1.5 0 2.8 1.3 2.8 2.8v.5c0 .1 0 .2.2.3h.3l.4-.4a2.8 2.8 0 014 0l.6.6a2.8 2.8 0 010 4l-.3.4v.3c0 .1 0 .2.2.2h.5c1.5 0 2.8 1.3 2.8 2.8v1c0 1.3-.9 2.4-2.1 2.7a1 1 0 01-.5-1.8c.4-.1.7-.5.7-1v-.9c0-.5-.4-1-1-1h-.4c-.9 0-1.7-.4-2-1.3-.4-.8-.2-1.7.5-2.4l.3-.3c.2-.2.3-.4.3-.7a1 1 0 00-.3-.6l-.7-.7a1 1 0 00-1.3 0l-.3.3c-.7.7-1.6.9-2.4.5a2.2 2.2 0 01-1.4-2v-.5c0-.5-.4-1-1-1h-.9a1 1 0 00-1 1v.5c0 .9-.4 1.7-1.3 2-.8.4-1.7.2-2.4-.5l-.3-.3a1 1 0 00-1.3 0l-.7.7a1 1 0 000 1.3l.3.3c.7.7.9 1.6.5 2.4-.3.9-1.1 1.4-2 1.4h-.5a1 1 0 00-1 1v.9c0 .5.5 1 1 1h.5c.9 0 1.7.4 2 1.3.4.8.2 1.7-.5 2.4l-.3.3a1 1 0 000 1.3l.7.7a1 1 0 001.3 0l.3-.3c.7-.7 1.6-.9 2.4-.5.9.3 1.4 1.1 1.4 2v.5c0 .5.4 1 1 1h.9c.4 0 .7-.3.9-.7a1 1 0 011.8.5c-.4 1.2-1.5 2-2.7 2zm10.7-.9c.5-.5.8-1.2.8-1.9s-.3-1.4-.8-2l-6-6c.2-.6.4-1.3.4-1.9 0-1.2-.5-2.3-1.4-3.2-1-1-2.7-1.7-4.4-1.7-.6 0-1 0-1.6.3a1 1 0 00-.4 1.5l2.3 2.3-.3 1.2-1.2.3-2.3-2.3a1 1 0 00-1.6.4l-.3 1.6c0 1.4.5 2.8 1.2 3.9 1 1.2 2.3 2 3.8 2 .5 0 1.2-.2 1.9-.5l6 6a2.7 2.7 0 003.9 0zm-10.3-8c-.4.4-1.1.6-1.5.6-1.1 0-1.9-.7-2.3-1.2-.4-.6-.6-1.3-.7-2l1.2 1.2c.2.2.6.3.9.2l2.3-.5c.3 0 .6-.3.7-.7l.5-2.3c0-.3 0-.6-.2-.8l-1.3-1.3c1 .1 1.8.6 2.4 1.1.5.6.8 1.2.8 2 0 .3-.2 1-.5 1.4-.3.4-.2 1 0 1.2l6.7 6.6a.9.9 0 010 1.2.9.9 0 01-1.3 0l-6.5-6.5a1 1 0 00-1.2-.1zm0 0" });

var help_desk_menu__ref3 = Object(preact_min["h"])(text_Text, { text: 'help_desk_link_text' });

var help_desk_menu__ref4 = Object(preact_min["h"])(HelpCircleOutlineIcon_default.a, null);

var help_desk_menu__ref5 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'help_desk_dropdown_title' })
);

var help_desk_menu_HelpDeskMenu = (help_desk_menu__temp = help_desk_menu__class = function (_Component) {
    help_desk_menu__inherits(HelpDeskMenu, _Component);

    function HelpDeskMenu(props) {
        help_desk_menu__classCallCheck(this, HelpDeskMenu);

        var _this = help_desk_menu__possibleConstructorReturn(this, _Component.call(this, props));

        _this.navigateToManuals = function () {
            _this.props.onNavigate('manuals');
        };

        _this.navigateToHelpdesk = function (event) {
            event.preventDefault();
            event.stopPropagation();
            services_ConfigService.navigateFunction(services_ConfigService.helpdeskUrl());
        };

        return _this;
    }

    HelpDeskMenu.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var hasManuals = Array.isArray(services_ConfigService.manuals()) && services_ConfigService.manuals().length;
        var helpdeskUrl = services_ConfigService.helpdeskUrl();

        var manuals = function manuals() {
            return !hasManuals ? null : Object(preact_min["h"])(
                toolbar_Toolbar,
                null,
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { type: 'fill text', onClick: function onClick() {
                            _this2.navigateToManuals();
                        } },
                    Object(preact_min["h"])(BookmarkOutlineIcon_default.a, { style: { color: '#0079B8', margin: '0 1em 0 0.25em' } }),
                    help_desk_menu__ref
                )
            );
        };

        var helpdesk = function helpdesk() {
            return !helpdeskUrl || !helpdeskUrl.length ? null : Object(preact_min["h"])(
                toolbar_Toolbar,
                null,
                Object(preact_min["h"])(
                    "a",
                    { "class": help_desk_menu_styles_default.a.linkButton, href: helpdeskUrl, target: "_blank", onClick: _this2.navigateToHelpdesk },
                    Object(preact_min["h"])(
                        "svg",
                        { style: { fill: '#0079B8', margin: '0 1em 0 .25em' }, "class": "mdi-icon", xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 24 24" },
                        help_desk_menu__ref2
                    ),
                    help_desk_menu__ref3,
                    Object(preact_min["h"])(OpenInNewIcon_default.a, { "class": help_desk_menu_styles_default.a.linkIcon })
                )
            );
        };

        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { "class": help_desk_menu_styles_default.a.toolbar },
                Object(preact_min["h"])(
                    "div",
                    { "class": help_desk_menu_styles_default.a.iconButton },
                    help_desk_menu__ref4
                ),
                help_desk_menu__ref5
            ),
            Object(preact_min["h"])(
                scrollable_section_ScrollableSection,
                null,
                helpdesk(),
                manuals()
            )
        );
    };

    return HelpDeskMenu;
}(preact_min["Component"]), help_desk_menu__class.defaultProps = {
    onNavigate: function onNavigate() {}
}, help_desk_menu__temp);

// EXTERNAL MODULE: ./components/sections/personal-area/sections/help-desk/manual-list/styles.scss
var manual_list_styles = __webpack_require__("xX7b");
var manual_list_styles_default = /*#__PURE__*/__webpack_require__.n(manual_list_styles);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/help-desk/manual-list/index.js
var manual_list__class, manual_list__temp2;



function manual_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function manual_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function manual_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var manual_list__ref = Object(preact_min["h"])(ArrowLeftIcon_default.a, null);

var manual_list__ref2 = Object(preact_min["h"])(BookmarkOutlineIcon_default.a, null);

var manual_list__ref3 = Object(preact_min["h"])(
    toolbar_title_ToolbarTitle,
    null,
    Object(preact_min["h"])(text_Text, { text: 'manuals_dropdown_title' })
);

var manual_list_ManualList = (manual_list__temp2 = manual_list__class = function (_Component) {
    manual_list__inherits(ManualList, _Component);

    function ManualList() {
        var _temp, _this, _ret;

        manual_list__classCallCheck(this, ManualList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = manual_list__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.backToMain = function () {
            _this.props.onNavigate('main');
        }, _this.navigateToManual = function (url) {
            _this.base.dispatchEvent(createEvent('closeDropdown', { bubbles: true }));
            services_ConfigService.navigateFunction(url);
        }, _temp), manual_list__possibleConstructorReturn(_this, _ret);
    }

    ManualList.prototype.render = function render(props, state, context) {
        var hasManuals = Array.isArray(services_ConfigService.manuals()) && services_ConfigService.manuals().length;
        if (!hasManuals) {
            setTimeout(this.backToMain);
            return null;
        }

        return Object(preact_min["h"])(
            vertical_ui_container_VerticalUiContainer,
            null,
            Object(preact_min["h"])(
                toolbar_Toolbar,
                { "class": manual_list_styles_default.a.toolbar },
                Object(preact_min["h"])(
                    section_component_SectionComponent,
                    { style: { flexGrow: 0 } },
                    Object(preact_min["h"])(
                        toolbar_button_ToolbarButton,
                        { onClick: this.backToMain, title: translate('action.back') },
                        manual_list__ref
                    )
                ),
                Object(preact_min["h"])(
                    "div",
                    { className: manual_list_styles_default.a.iconButton },
                    manual_list__ref2
                ),
                manual_list__ref3
            ),
            Object(preact_min["h"])(
                scrollable_section_ScrollableSection,
                null,
                services_ConfigService.manuals().map(function (item, index) {
                    return Object(preact_min["h"])(
                        "a",
                        { "class": manual_list_styles_default.a.manualLink, href: TranslateService.translatable(item.url), target: "_blank" },
                        Object(preact_min["h"])(
                            "div",
                            { "class": manual_list_styles_default.a.number },
                            index + 1
                        ),
                        TranslateService.translatable(item.title),
                        Object(preact_min["h"])(OpenInNewIcon_default.a, { "class": manual_list_styles_default.a.linkIcon })
                    );
                })
            )
        );
    };

    return ManualList;
}(preact_min["Component"]), manual_list__class.defaultProps = {
    onNavigate: function onNavigate() {}
}, manual_list__temp2);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/help-desk/help-desk-main/index.js


function help_desk_main__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function help_desk_main__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function help_desk_main__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var help_desk_main_HelpDeskMain = function (_Component) {
    help_desk_main__inherits(HelpDeskMain, _Component);

    function HelpDeskMain(props) {
        help_desk_main__classCallCheck(this, HelpDeskMain);

        var _this = help_desk_main__possibleConstructorReturn(this, _Component.call(this, props));

        _this.navigate = function (page) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _this.setState({
                page: page,
                params: params || {}
            });
        };

        _this.state = {
            page: 'main',
            params: {}
        };
        return _this;
    }

    HelpDeskMain.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var pages = {
            main: function main() {
                return Object(preact_min["h"])(help_desk_menu_HelpDeskMenu, { onNavigate: _this2.navigate });
            },
            manuals: function manuals() {
                return Object(preact_min["h"])(manual_list_ManualList, { onNavigate: _this2.navigate });
            }
        };

        return pages[this.state.page]();
    };

    return HelpDeskMain;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sections/personal-area/sections/help-desk/help-desk-button/index.js


function help_desk_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function help_desk_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function help_desk_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var help_desk_button__ref = Object(preact_min["h"])(HelpCircleOutlineIcon_default.a, null);

var help_desk_button__ref2 = Object(preact_min["h"])(help_desk_main_HelpDeskMain, null);

var help_desk_button_HelpDeskButton = function (_Component) {
    help_desk_button__inherits(HelpDeskButton, _Component);

    function HelpDeskButton(props) {
        help_desk_button__classCallCheck(this, HelpDeskButton);

        var _this = help_desk_button__possibleConstructorReturn(this, _Component.call(this, props));

        _this.navigateToManual = function (url) {
            _this.base.dispatchEvent(createEvent('closeDropdown', { bubbles: true }));
            services_ConfigService.navigateFunction(url);
        };

        _this.toggleDropdown = function () {
            _this.setState({ open: !_this.state.open });
        };

        _this.state = {
            open: false
        };
        return _this;
    }

    HelpDeskButton.prototype.render = function render(props, state, context) {
        var hasManuals = Array.isArray(services_ConfigService.manuals()) && services_ConfigService.manuals().length;
        var hasHelpdeskUrl = services_ConfigService.helpdeskUrl() && services_ConfigService.helpdeskUrl().length;

        if (!hasManuals && !hasHelpdeskUrl) return null;
        var buttonStyles = this.state.open ? { background: '#0079B8' } : {};

        return Object(preact_min["h"])(
            outside_click_wrapper_OutsideClickWrapper,
            { watch: this.state.open, onOutsideClick: this.toggleDropdown },
            Object(preact_min["h"])(
                section_component_SectionComponent,
                null,
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { onClick: this.toggleDropdown, title: translate('help_desk_dropdown_title'), style: buttonStyles },
                    help_desk_button__ref
                ),
                Object(preact_min["h"])(
                    dropdown_DropDownMenu,
                    { open: this.state.open },
                    help_desk_button__ref2
                )
            )
        );
    };

    return HelpDeskButton;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/sections/personal-area/sections/sub-bar/style.scss
var sub_bar_style = __webpack_require__("krFE");
var sub_bar_style_default = /*#__PURE__*/__webpack_require__.n(sub_bar_style);

// EXTERNAL MODULE: ../node_modules/preact-portal/dist/preact-portal.js
var preact_portal = __webpack_require__("q6qL");
var preact_portal_default = /*#__PURE__*/__webpack_require__.n(preact_portal);

// CONCATENATED MODULE: ./components/sections/personal-area/sections/sub-bar/index.js


function sub_bar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sub_bar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sub_bar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var sub_bar__ref = Object(preact_min["h"])(
    "svg",
    { "class": "mdi-icon", "aria-hidden": "true", focusable: "false", "data-prefix": "fas", "data-icon": "mail-bulk", role: "img",
        xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512" },
    Object(preact_min["h"])("path", { fill: "currentColor",
        d: "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z" })
);

var sub_bar_SubBar = function (_Component) {
    sub_bar__inherits(SubBar, _Component);

    function SubBar() {
        sub_bar__classCallCheck(this, SubBar);

        var _this = sub_bar__possibleConstructorReturn(this, _Component.call(this));

        _this.counter = trkl_min["computed"](function () {
            return services_ChatService.badge() + services_MessageService.badge();
        });

        _this.toggleAdditionalToolbar = function () {
            _this.setState({ open: !_this.state.open });
        };

        _this.updateCount = function () {
            _this.setState({ count: _this.counter() });
        };

        _this.state = {
            open: false,
            count: 0
        };
        return _this;
    }

    SubBar.prototype.componentDidMount = function componentDidMount() {
        this.counter.subscribe(this.updateCount, true);
    };

    SubBar.prototype.componentWillUnmount = function componentWillUnmount() {
        this.counter.unsubscribe(this.updateCount, true);
    };

    SubBar.prototype.render = function render(props, state, context) {
        var _this2 = this;

        var subBarClasses = [sub_bar_style_default.a.subBar, this.state.open ? sub_bar_style_default.a.open : null].filter(function (i) {
            return i;
        }).join(' ');

        var buttonStyles = this.state.open ? { background: '#0079B8' } : {};
        var badge = function badge() {
            return _this2.state.count ? Object(preact_min["h"])(
                simple_badge_SimpleBadge,
                null,
                _this2.state.count
            ) : null;
        };

        return Object(preact_min["h"])(
            "div",
            { style: { height: '3em' } },
            Object(preact_min["h"])(
                toolbar_button_ToolbarButton,
                { "class": sub_bar_style_default.a.subBarButton, onClick: this.toggleAdditionalToolbar, style: buttonStyles },
                sub_bar__ref,
                badge()
            ),
            Object(preact_min["h"])(
                preact_portal_default.a,
                { into: '#dpa-global-top-bar-additional-toolbar', ref: function ref(_ref2) {
                        return _this2._portal = _ref2;
                    } },
                Object(preact_min["h"])(
                    "div",
                    { className: subBarClasses },
                    props.children
                )
            )
        );
    };

    return SubBar;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sections/personal-area/user-menu/index.js
var user_menu__class, user_menu__temp;



function user_menu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function user_menu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function user_menu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var user_menu__ref = Object(preact_min["h"])(
    toolbar_button_ToolbarButton,
    { disabled: true },
    Object(preact_min["h"])(spinner_Spinner, null)
);

var user_menu__ref2 = Object(preact_min["h"])(AccountOffIcon_default.a, null);

var user_menu__ref3 = Object(preact_min["h"])(notifications_button_NotificationsButton, null);

var user_menu__ref4 = Object(preact_min["h"])(messenger_button_MessengerButton, null);

var user_menu__ref5 = Object(preact_min["h"])(chat_button_ChatButton, null);

var user_menu__ref6 = Object(preact_min["h"])(help_desk_button_HelpDeskButton, null);

var user_menu__ref7 = Object(preact_min["h"])(profile_button_ProfileButton, null);

var user_menu_UserMenu = (user_menu__temp = user_menu__class = function (_Component) {
    user_menu__inherits(UserMenu, _Component);

    function UserMenu(props) {
        user_menu__classCallCheck(this, UserMenu);

        var _this = user_menu__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            loading: true,
            error: false
        };
        return _this;
    }

    UserMenu.prototype.render = function render(props) {
        var _this2 = this;

        var spinner = function spinner() {
            return user_menu__ref;
        };
        var profile = services_ConfigService.userProfile();
        var profileIsDefined = profile && Object.keys(profile).length;
        var messengerIsEnabled = services_ModuleInfoProvider.isEnabled('messenger');
        var chatIsEnabled = services_ModuleInfoProvider.isEnabled('chat');

        var retryButton = function retryButton() {
            return !_this2.state.loading && !profileIsDefined ? Object(preact_min["h"])(
                section_component_SectionComponent,
                null,
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { type: 'text', onClick: _this2.fetchProfile, title: translate('action.retry') },
                    user_menu__ref2
                )
            ) : null;
        };

        var children = function children() {
            return !_this2.state.loading && profileIsDefined ? [user_menu__ref3, Object(preact_min["h"])(
                sub_bar_SubBar,
                null,
                messengerIsEnabled ? user_menu__ref4 : null,
                chatIsEnabled ? user_menu__ref5 : null,
                user_menu__ref6,
                user_menu__ref7
            )] : null;
        };

        return Object(preact_min["h"])(
            section_component_SectionComponent,
            null,
            this.state.loading ? spinner() : null,
            retryButton(),
            children()
        );
    };

    UserMenu.prototype.componentDidMount = function componentDidMount() {
        this.fetchProfile();
    };

    UserMenu.prototype.fetchProfile = function fetchProfile() {
        var _this3 = this;

        this.setState({ loading: true, error: false });
        Promise.all([services_JWTClient.fetch(this.props.organigrammaServerUrl + '/profile').then(function (res) {
            services_ConfigService.userProfile(services_JsonApiDeserializer.deserializeItem(res.data, res.included));
        }), services_JWTClient.fetch(this.props.organigrammaServerUrl + '/profile/domain-actions').then(function (res) {
            services_ConfigService.domainActions(res.data.map(function (i) {
                return i.name;
            }));
        })]).then(function () {
            return _this3.setState({ loading: false, error: false });
        }).catch(function (e) {
            console.log(e);
            _this3.setState({ loading: false, error: true, profile: {} });
        });
    };

    return UserMenu;
}(preact_min["Component"]), user_menu__class.defaultProps = {
    organigrammaServerUrl: ''
}, user_menu__temp);

// EXTERNAL MODULE: ../node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__("Qy1v");
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);

// EXTERNAL MODULE: ../node_modules/dayjs/locale/it.js
var locale_it = __webpack_require__("9oST");
var locale_it_default = /*#__PURE__*/__webpack_require__.n(locale_it);

// CONCATENATED MODULE: ./components/layout/global-container/index.js
var global_container__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var global_container__class, global_container__temp;



function global_container__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function global_container__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function global_container__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














//date library



dayjs_min_default.a.extend(relativeTime_default.a);

var global_container__ref = Object(preact_min["h"])(
    section_container_SectionContainer,
    null,
    Object(preact_min["h"])(spinner_Spinner, null)
);

var global_container_GlobalContainer = (global_container__temp = global_container__class = function (_Component) {
    global_container__inherits(GlobalContainer, _Component);

    function GlobalContainer(props) {
        global_container__classCallCheck(this, GlobalContainer);

        var _this = global_container__possibleConstructorReturn(this, _Component.call(this, props));

        _this.start = function () {
            _this.setState({
                loading: true,
                error: false,
                hidden: false
            });
            _this.setPropConfiguration();
            _this.fetchConfiguration();
        };

        _this.stop = function () {
            _this.setState({ hidden: true });
        };

        _this.setPropConfiguration = function () {
            var config = _this.getFromPath(window, _this.props.config);

            services_ConfigService.currentAppKey(config.currentAppKey);
            services_ConfigService.organigrammaServerUrl(config.organigrammaServerUrl);
            services_ConfigService.cdnConfiguration(config.cdnConfiguration);
            services_ConfigService.navigateFunction = config.navigateFunction;
            services_ConfigService.manuals(config.manuals);
            services_ConfigService.helpdeskUrl(config.helpdeskUrl);
            services_ConfigService.homepageUrl(config.homepageUrl);
            if (config.iconBaseUrl) services_ConfigService.iconBaseUrl(config.iconBaseUrl);

            services_ConfigService.jwt(config.jwt);
            services_ConfigService.refreshToken(config.refreshToken);
            services_ConfigService.logoutRedirectUrl(config.logoutRedirectUrl);
            services_ConfigService.logoutCallback = config.logoutCallback;
            services_ConfigService.authFailureCallback = config.authFailureCallback;

            services_ConfigService.currentLanguage(config.currentLanguage);
            services_ConfigService.availableLanguages(config.availableLanguages);
            services_ConfigService.setCurrentLanguage = config.setCurrentLanguage;
        };

        _this.fetchConfiguration = function () {
            _this.setState({ loading: true, error: false });
            fetch_fetch(services_ConfigService.organigrammaServerUrl() + '/configuration').then(function (res) {
                return res.json();
            }).then(function (res) {
                services_ConfigService.modules(services_ModuleInfoProvider.createFlatModuleArray(res.data.modules));
                services_ConfigService.localization(res.data.localization);
                _this.setState({ loading: false });
            }).catch(function () {
                return _this.setState({ error: true });
            });
        };

        _this.setState({
            loading: true,
            error: false,
            hidden: false
        });
        return _this;
    }

    GlobalContainer.prototype.componentDidMount = function componentDidMount() {
        this.registerGlobal();
        if (this.props.startHidden === 'true') this.stop();else this.start();
    };

    GlobalContainer.prototype.render = function render(props) {
        var _this2 = this;

        var loadingSpinner = function loadingSpinner() {
            return global_container__ref;
        };

        var errorSection = function errorSection() {
            return Object(preact_min["h"])(
                section_container_SectionContainer,
                null,
                Object(preact_min["h"])(
                    "div",
                    { "class": style_default.a.errorAlert },
                    TranslateService.t("configuration.loading.error")
                ),
                Object(preact_min["h"])(
                    toolbar_button_ToolbarButton,
                    { onClick: _this2.fetchConfiguration },
                    TranslateService.t("action.retry")
                )
            );
        };

        var currentApp = services_ConfigService.modules().find(function (m) {
            return m.key === services_ConfigService.currentAppKey();
        });
        var sections = function sections() {
            return _this2.state.hidden ? [] : [Object(preact_min["h"])(
                section_container_SectionContainer,
                { style: { justifyContent: 'flex-start', flexGrow: 2 } },
                Object(preact_min["h"])(app_list_OrganigrammaAppList, { currentApp: currentApp, apps: services_ConfigService.modules() })
            ), Object(preact_min["h"])(
                section_container_SectionContainer,
                { style: { justifyContent: 'flex-end', flexGrow: 1 } },
                Object(preact_min["h"])(user_menu_UserMenu, { organigrammaServerUrl: services_ConfigService.organigrammaServerUrl() })
            )];
        };

        var barClasses = [style_reset_default.a.clean, this.state.hidden ? ' hidden-bar' : null].filter(function (i) {
            return i;
        }).join(' ');

        return Object(preact_min["h"])(
            "div",
            { "class": barClasses, style: { display: this.state.hidden ? 'none' : 'block' } },
            Object(preact_min["h"])(
                "div",
                { "class": style_default.a.globalContainer },
                Object(preact_min["h"])(
                    "div",
                    { "class": style_default.a.mainToolbar },
                    !this.state.error && !this.state.loading && sections().map(function (i) {
                        return i;
                    }),
                    !this.state.error && this.state.loading && loadingSpinner(),
                    this.state.error && errorSection()
                ),
                global_container__ref2
            )
        );
    };

    GlobalContainer.prototype.registerGlobal = function registerGlobal() {
        var _this3 = this;

        window.dpaGlobalTopBar = {
            stop: this.stop,
            start: this.start,
            getState: function getState() {
                return global_container__extends({}, _this3.state);
            },
            update: this.setPropConfiguration
        };
    };

    GlobalContainer.prototype.getFromPath = function getFromPath(base, path) {
        if (!path.length) return function () {};
        var object = base;
        path.split('.').forEach(function (p) {
            return object = object[p];
        });
        return object;
    };

    return GlobalContainer;
}(preact_min["Component"]), global_container__class.defaultProps = {
    startHidden: false,
    config: ''

    /**
     * props.config example
     * {
        // context
        currentAppKey: 'extranet',
        organigrammaServerUrl: 'http://organigramma-server.test',
        cdnConfiguration: {},
        navigateFunction: (url) => window.location = url
        manuals: [
            {
                title: {
                    it: 'titolo manuale'
                },
                url: 'example.com'
            }
        ],
        helpdeskUrl: ''
        homePageUrl: ''
         // authentication
        jwt: '',
        refreshToken: '',
        logoutRedirectUrl: '/',
        logoutCallback: () => {},
         // localization
        currentLanguage: 'it',
        availableLanguages: ['it', 'en', 'es'],
        setCurrentLanguage: () => {},
    }
     *
     */
}, global_container__temp);


var global_container_DefaultPortal = function (_Component2) {
    global_container__inherits(DefaultPortal, _Component2);

    function DefaultPortal() {
        var _temp2, _this4, _ret;

        global_container__classCallCheck(this, DefaultPortal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp2 = (_this4 = global_container__possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this4), _this4.shouldComponentUpdate = function () {
            return false;
        }, _temp2), global_container__possibleConstructorReturn(_this4, _ret);
    }

    DefaultPortal.prototype.render = function render(props, state, context) {
        return Object(preact_min["h"])("div", {
            id: 'dpa-global-top-bar-additional-toolbar',
            className: [style_default.a.mainToolbar, style_default.a.additionalToolbar].join(' ')
        });
    };

    return DefaultPortal;
}(preact_min["Component"]);

var global_container__ref2 = Object(preact_min["h"])(global_container_DefaultPortal, null);
// CONCATENATED MODULE: ./index.js





































































































var _habitat = preact_habitat_es(global_container_GlobalContainer);
_habitat.render({
  clean: true,
  selector: '.dpa-global-top-bar-container'
});

/***/ }),

/***/ "K3/J":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("izCb");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("e3Bp") });

/***/ }),

/***/ "K46i":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__("nw8e");
var gOPD = __webpack_require__("uIjZ");
var getPrototypeOf = __webpack_require__("8q6y");
var has = __webpack_require__("2uHg");
var $export = __webpack_require__("izCb");
var createDesc = __webpack_require__("uJ6d");
var anObject = __webpack_require__("eT53");
var isObject = __webpack_require__("M7z6");

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

/***/ }),

/***/ "K8tU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var DotsHorizontalIcon = function DotsHorizontalIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z' }));
};

module.exports = DotsHorizontalIcon;

/***/ }),

/***/ "KGao":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("eT53");
var toObject = __webpack_require__("rfVX");
var toLength = __webpack_require__("dJBs");
var toInteger = __webpack_require__("yjVO");
var advanceStringIndex = __webpack_require__("/t3a");
var regExpExec = __webpack_require__("sNFG");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function maybeToString(it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("LmBS")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
  // `String.prototype.replace` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
  },
  // `RegExp.prototype[@@replace]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
  function (regexp, replaceValue) {
    var res = maybeCallNative($replace, regexp, this, replaceValue);
    if (res.done) return res.value;

    var rx = anObject(regexp);
    var S = String(this);
    var functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = String(replaceValue);
    var global = rx.global;
    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }
    var results = [];
    while (true) {
      var result = regExpExec(rx, S);
      if (result === null) break;
      results.push(result);
      if (!global) break;
      var matchStr = String(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
    }
    var accumulatedResult = '';
    var nextSourcePosition = 0;
    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = String(result[0]);
      var position = max(min(toInteger(result.index), S.length), 0);
      var captures = [];
      // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
      for (var j = 1; j < result.length; j++) {
        captures.push(maybeToString(result[j]));
      }var namedCaptures = result.groups;
      if (functionalReplace) {
        var replacerArgs = [matched].concat(captures, position, S);
        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
        var replacement = String(replaceValue.apply(undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }
      if (position >= nextSourcePosition) {
        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }
    return accumulatedResult + S.slice(nextSourcePosition);
  }];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$':
          return '$';
        case '&':
          return matched;
        case '`':
          return str.slice(0, position);
        case "'":
          return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KY9y":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("E3Kh");
var invoke = __webpack_require__("xcbV");
var html = __webpack_require__("xj/b");
var cel = __webpack_require__("/vZ6");
var global = __webpack_require__("5qf4");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("Z5df")(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),

/***/ "Kqgs":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),

/***/ "L5z5":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__("izCb");
var setProto = __webpack_require__("vn3S");

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),

/***/ "L7XN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)

var aFunction = __webpack_require__("6kYj");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),

/***/ "LmBS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("S07n");
var redefine = __webpack_require__("PHot");
var hide = __webpack_require__("0NXb");
var fails = __webpack_require__("5BXi");
var defined = __webpack_require__("+Bjj");
var wks = __webpack_require__("44AI");
var regexpExec = __webpack_require__("ZcPD");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () {
    return originalExec.apply(this, arguments);
  };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () {
      return 7;
    };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () {
      execCalled = true;return null;
    };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () {
        return re;
      };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
    // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
    ? function (string, arg) {
      return rxfn.call(string, this, arg);
    }
    // 21.2.5.6 RegExp.prototype[@@match](string)
    // 21.2.5.9 RegExp.prototype[@@search](string)
    : function (string) {
      return rxfn.call(string, this);
    });
  }
};

/***/ }),

/***/ "Ltmz":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("izCb");
var $values = __webpack_require__("ljQU")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),

/***/ "M12F":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jtyH");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "M7z6":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "MVb4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("z0BR");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Mej7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("FIMm");
var util = __webpack_require__("5YsI");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,


// Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,


// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],


// RFC 2396: characters not allowed for various reasons.
unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),


// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = ['\''].concat(unwise),

// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,

// protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that never have a hostname.
hostlessProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that always contain a // bit.
slashedProtocol = {
  'http': true,
  'https': true,
  'ftp': true,
  'gopher': true,
  'file': true,
  'http:': true,
  'https:': true,
  'ftp:': true,
  'gopher:': true,
  'file:': true
},
    querystring = __webpack_require__("+00f");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || query && '?' + query || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) {}
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
      isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
      mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || result.host && srcPath.length;

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

/***/ }),

/***/ "MiMz":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("nw8e");
var anObject = __webpack_require__("eT53");
var getKeys = __webpack_require__("U9a7");

module.exports = __webpack_require__("P9Ib") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),

/***/ "MlqR":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__("izCb");
$export($export.S, 'Object', { is: __webpack_require__("zutv") });

/***/ }),

/***/ "N3yi":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("nw8e").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("P9Ib") && dP(FProto, NAME, {
  configurable: true,
  get: function get() {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

/***/ }),

/***/ "NNbH":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("M7z6");
var isArray = __webpack_require__("JTrm");
var SPECIES = __webpack_require__("44AI")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),

/***/ "NaGB":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("6zGc")('keys');
var uid = __webpack_require__("U49f");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "O5uh":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("5qf4");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

/***/ }),

/***/ "OEJM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var InformationOutlineIcon = function InformationOutlineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z' }));
};

module.exports = InformationOutlineIcon;

/***/ }),

/***/ "OTsy":
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__("5qf4");
var $export = __webpack_require__("izCb");
var userAgent = __webpack_require__("O5uh");
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function wrap(set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),

/***/ "OWTq":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__("izCb");

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

/***/ }),

/***/ "Oa0z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("j6LS");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Oppn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)


var toObject = __webpack_require__("rfVX");
var toAbsoluteIndex = __webpack_require__("vfEH");
var toLength = __webpack_require__("dJBs");

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];else delete O[to];
    to += inc;
    from += inc;
  }return O;
};

/***/ }),

/***/ "P06D":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".form__29SCr{padding:1em .5em}.label__2S_2P{padding:0 1.25em;font-size:.8em;font-weight:700;letter-spacing:.05em;margin-bottom:-.5em;display:block}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/create-group-chat/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/create-group-chat/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/create-group-chat/styles.scss"],"names":[],"mappings":"AAAA,aACE,gBAAiB,CAClB,cAGC,iBACA,eACA,gBACA,qBACA,oBACA,aAAc,CACf","file":"styles.scss","sourcesContent":[".form {\n  padding: 1em .5em;\n}\n\n.label {\n  padding: 0 1.25em;\n  font-size: .8em;\n  font-weight: 700;\n  letter-spacing: .05em;\n  margin-bottom: -.5em;\n  display: block;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"form": "form__29SCr",
	"label": "label__2S_2P"
};

/***/ }),

/***/ "P0Gr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dVO+");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "P9Ib":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("5BXi")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "PFYP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PU2a");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "PHVl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8RlZ");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "PHot":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("5qf4");
var hide = __webpack_require__("0NXb");
var has = __webpack_require__("2uHg");
var SRC = __webpack_require__("U49f")('src');
var $toString = __webpack_require__("d5RU");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("ss9A").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),

/***/ "PU2a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbarContainer__2GEQE{height:3em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/toolbar/C:/dev/globalTopBar/src/components/layout/toolbar/C:/dev/globalTopBar/src/components/layout/toolbar/styles.scss"],"names":[],"mappings":"AAAA,yBACE,WACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,wBACA,yBAAA,sBAAA,mBACA,oBAAA,aAAc,CACf","file":"styles.scss","sourcesContent":[".toolbarContainer {\n  height: 3em;\n  display: flex;\n  justify-content: stretch;\n  align-items: center;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbarContainer": "toolbarContainer__2GEQE"
};

/***/ }),

/***/ "Pjta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__("H21C");
var global = __webpack_require__("5qf4");
var ctx = __webpack_require__("E3Kh");
var classof = __webpack_require__("GM7B");
var $export = __webpack_require__("izCb");
var isObject = __webpack_require__("M7z6");
var aFunction = __webpack_require__("6kYj");
var anInstance = __webpack_require__("yJTF");
var forOf = __webpack_require__("Abke");
var speciesConstructor = __webpack_require__("Ex+G");
var task = __webpack_require__("KY9y").set;
var microtask = __webpack_require__("sFAp")();
var newPromiseCapabilityModule = __webpack_require__("L7XN");
var perform = __webpack_require__("tyG8");
var userAgent = __webpack_require__("O5uh");
var promiseResolve = __webpack_require__("cNG8");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {/* empty */};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("44AI")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {/* empty */}
}();

// helpers
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__("J0Tl")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("rq3q")($Promise, PROMISE);
__webpack_require__("5h4d")(PROMISE);
Wrapper = __webpack_require__("ss9A")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("md62")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),

/***/ "QTtY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "QZby":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var EmailIcon = function EmailIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z' }));
};

module.exports = EmailIcon;

/***/ }),

/***/ "Qppk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__("izCb");
var $find = __webpack_require__("AuPh")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("Z7e/")(KEY);

/***/ }),

/***/ "Qy1v":
/***/ (function(module, exports, __webpack_require__) {

!function (r, t) {
   true ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : r.dayjs_plugin_relativeTime = t();
}(this, function () {
  "use strict";
  return function (r, t, e) {
    r = r || {};var n = t.prototype;e.en.relativeTime = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };var o = function o(t, n, _o, d) {
      for (var i, u, a, s = _o.$locale().relativeTime, f = r.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], l = f.length, h = 0; h < l; h += 1) {
        var m = f[h];m.d && (i = d ? e(t).diff(_o, m.d, !0) : _o.diff(t, m.d, !0));var c = (r.rounding || Math.round)(Math.abs(i));if (a = i > 0, c <= m.r || !m.r) {
          c <= 1 && h > 0 && (m = f[h - 1]);var y = s[m.l];u = "string" == typeof y ? y.replace("%d", c) : y(c, n, m.l, a);break;
        }
      }return n ? u : (a ? s.future : s.past).replace("%s", u);
    };n.to = function (r, t) {
      return o(r, t, this, !0);
    }, n.from = function (r, t) {
      return o(r, t, this);
    };var d = function d(r) {
      return r.$u ? e.utc() : e();
    };n.toNow = function (r) {
      return this.to(d(this), r);
    }, n.fromNow = function (r) {
      return this.from(d(this), r);
    };
  };
});

/***/ }),

/***/ "R2Qc":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__("izCb");

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),

/***/ "RB6b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__("izCb");
var createProperty = __webpack_require__("JCwR");

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__("5BXi")(function () {
  function F() {/* empty */}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of() /* ...args */{
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) {
      createProperty(result, index, arguments[index++]);
    }result.length = aLen;
    return result;
  }
});

/***/ }),

/***/ "RGSg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var BellIcon = function BellIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21' }));
};

module.exports = BellIcon;

/***/ }),

/***/ "RRcs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__("E3Kh");
var $export = __webpack_require__("izCb");
var toObject = __webpack_require__("rfVX");
var call = __webpack_require__("RnO+");
var isArrayIter = __webpack_require__("0B0p");
var toLength = __webpack_require__("dJBs");
var createProperty = __webpack_require__("JCwR");
var getIterFn = __webpack_require__("ia+4");

$export($export.S + $export.F * !__webpack_require__("md62")(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),

/***/ "RTfC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("eT53");
var toLength = __webpack_require__("dJBs");
var advanceStringIndex = __webpack_require__("/t3a");
var regExpExec = __webpack_require__("sNFG");

// @@match logic
__webpack_require__("LmBS")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
  // `String.prototype.match` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.match
  function match(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  },
  // `RegExp.prototype[@@match]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
  function (regexp) {
    var res = maybeCallNative($match, regexp, this);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    if (!rx.global) return regExpExec(rx, S);
    var fullUnicode = rx.unicode;
    rx.lastIndex = 0;
    var A = [];
    var n = 0;
    var result;
    while ((result = regExpExec(rx, S)) !== null) {
      var matchStr = String(result[0]);
      A[n] = matchStr;
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      n++;
    }
    return n === 0 ? null : A;
  }];
});

/***/ }),

/***/ "RnO+":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("eT53");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ "Rq41":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".badge__e-sAW{width:.75em;height:.75em;display:block;border-radius:1em;background:red;position:absolute;top:1em;right:1em;border:.125em solid #fff}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/messenger-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/messenger-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/messenger-button/styles.scss"],"names":[],"mappings":"AAAA,cACE,YACA,aACA,cACA,kBACA,eACA,kBACA,QACA,UACA,wBAA0B,CAC3B","file":"styles.scss","sourcesContent":[".badge {\n  width: .75em;\n  height: .75em;\n  display: block;\n  border-radius: 1em;\n  background: red;\n  position: absolute;\n  top: 1em;\n  right: 1em;\n  border: .125em solid white;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"badge": "badge__e-sAW"
};

/***/ }),

/***/ "RwSX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ExclamationIcon = function ExclamationIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M11,4.5H13V15.5H11V4.5M13,17.5V19.5H11V17.5H13Z' }));
};

module.exports = ExclamationIcon;

/***/ }),

/***/ "S07n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpExec = __webpack_require__("ZcPD");
__webpack_require__("izCb")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});

/***/ }),

/***/ "S841":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__("nw8e");
var $export = __webpack_require__("izCb");
var anObject = __webpack_require__("eT53");
var toPrimitive = __webpack_require__("9y37");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__("5BXi")(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),

/***/ "Sj4M":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iZqw");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "SsgJ":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("izCb");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

/***/ }),

/***/ "Szfd":
/***/ (function(module, exports) {

module.exports = {"action.back":"Back","action.load-previous":"Load Previous","action.load-next":"Load Next","action.login":"Login","action.logout":"Logout","action.retry":"Retry","action.send":"Send","app.list.title":"Software","chat.group.form.title-label":"Title","chat.group.form.title-description":"Description","chat.group.new.title":"New Group","chat.input-placeholder":"Write a message","chat.list.empty":"You haven't started any conversation yet.","chat.new.title":"New Conversation","chat.new.empty":"You have no contacts.","chat.read.empty":"You have no messages.","chat.title":"Chat","configuration.loading.error":"Connection error.","error.loading":"Loading error","help_desk_dropdown_title":"Help Desk","help_desk_link_text":"Request Assistance","message.list":"Inbox","language_dropdown_title":"Language","language.it":"Italian","language.en":"English","language.es":"Spanish","manuals_dropdown_title":"Manuals","message.list.empty":"You have no messages.","notification.list":"Notifications","notification.list.empty":"You have no notifications","profile.attribute.email":"Email","profile.attribute.username":"Username","profile.session_expiration":"Session expiration date","profile.session_expiration_alert":"Session will expire when no activity is detected.","profile.session_expiration_alert.short":"Session is going to expire soon.","profile.title":"Profile","profile.edit":"Edit","today":"today","user.not-logged":"You are not logged in."}

/***/ }),

/***/ "T4z7":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("M7z6");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),

/***/ "TLss":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__("izCb");
var $includes = __webpack_require__("4Ca7")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("Z7e/")('includes');

/***/ }),

/***/ "TeL6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".customButton__aZCWv{background:none;border:none;text-transform:uppercase;letter-spacing:.03em;height:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 1.125em;position:relative;line-height:2em;color:inherit;font:inherit;font-size:1em!important}.customButton__aZCWv:hover{background:rgba(0,0,0,.1);cursor:pointer}.customButton__aZCWv>span{height:100%;width:100%}.ie__n1XQp.classic__2trOj{max-width:none}.primary__MFWw4{background:#03354c;color:#fff}.primary__MFWw4:hover{background:#032f43}.secondary__6dESl{background:#bf0201;color:#fff}.secondary__6dESl:hover{background:#a80201}.tertiary__1SXYj{background:#0079b8;color:#fff}.tertiary__1SXYj:hover{background:#006aa2}.warning__1mvwh{color:red;fill:red}.disabled__1-OT1,.disabled__1-OT1:active,.disabled__1-OT1:focus,.disabled__1-OT1:hover{opacity:.2;background:none;cursor:auto;outline:0}.small__3e38s{font-size:.75em}.fill__3kPZp{width:100%;display:block}.text__3DDws{text-transform:unset;letter-spacing:unset;font-weight:unset;text-align:left}.classic__2trOj{height:2em;margin:.5em;border-radius:.25em;max-width:calc(100% - 1em)}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/toolbar-button/C:/dev/globalTopBar/src/components/common/toolbar-button/C:/dev/globalTopBar/src/components/common/toolbar-button/styles.scss"],"names":[],"mappings":"AAAA,qBACE,gBACA,YACA,yBACA,qBACA,YACA,mBACA,gBACA,uBACA,kBACA,kBACA,gBACA,cACA,aACA,uBAAyB,CAd3B,2BAiBI,0BACA,cAAe,CAlBnB,0BAsBI,YACA,UAAW,CACZ,0BAID,cAAkB,CACnB,gBAGC,mBACA,UAAY,CAFd,sBAKI,kBAAmB,CACpB,kBAID,mBACA,UAAY,CAFd,wBAKI,kBAAmB,CACpB,iBAID,mBACA,UAAY,CAFd,uBAKI,kBAAmB,CACpB,gBAID,UACA,QAAS,CACV,uFAIG,WACA,gBACA,YACA,SAAU,CACX,cAID,eAAiB,CAClB,aAGC,WACA,aAAc,CACf,aAGC,qBACA,qBACA,kBACA,eAAgB,CACjB,gBAGC,WACA,YACA,oBACA,0BAA2B,CAC5B","file":"styles.scss","sourcesContent":[".customButton {\n  background: none;\n  border: none;\n  text-transform: uppercase;\n  letter-spacing: .03em;\n  height: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 1.125em;\n  position: relative;\n  line-height: 2em;\n  color: inherit;\n  font: inherit;\n  font-size: 1em !important;\n\n  &:hover {\n    background: rgba(black, 0.1);\n    cursor: pointer;\n  }\n\n  > span {\n    height: 100%;\n    width: 100%;\n  }\n}\n\n.ie.classic {\n  max-width: initial;\n}\n\n.primary {\n  background: #03354c;\n  color: white;\n\n  &:hover {\n    background: #032f43;\n  }\n}\n\n.secondary {\n  background: #bf0201;\n  color: white;\n\n  &:hover {\n    background: #a80201;\n  }\n}\n\n.tertiary {\n  background: #0079B8;\n  color: white;\n\n  &:hover {\n    background: #006aa2;\n  }\n}\n\n.warning {\n  color: red;\n  fill: red;\n}\n\n.disabled {\n  &, &:hover, &:focus, &:active {\n    opacity: 0.2;\n    background: none;\n    cursor: auto;\n    outline: 0;\n  }\n}\n\n.small {\n  font-size: 0.75em;\n}\n\n.fill {\n  width: 100%;\n  display: block;\n}\n\n.text {\n  text-transform: unset;\n  letter-spacing: unset;\n  font-weight: unset;\n  text-align: left;\n}\n\n.classic {\n  height: 2em;\n  margin: .5em;\n  border-radius: .25em;\n  max-width: calc(100% - 1em);\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"customButton": "customButton__aZCWv",
	"ie": "ie__n1XQp",
	"classic": "classic__2trOj",
	"primary": "primary__MFWw4",
	"secondary": "secondary__6dESl",
	"tertiary": "tertiary__1SXYj",
	"warning": "warning__1mvwh",
	"disabled": "disabled__1-OT1",
	"small": "small__3e38s",
	"fill": "fill__3kPZp",
	"text": "text__3DDws"
};

/***/ }),

/***/ "U49f":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "U9a7":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("vL0Z");
var enumBugKeys = __webpack_require__("9bbv");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "UH4U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__("yjVO");
var defined = __webpack_require__("+Bjj");

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) res += str;
  }return res;
};

/***/ }),

/***/ "UUq2":
/***/ (function(module, exports) {

// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function () {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = i >= 0 ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function (path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function (p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function (path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function () {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function (p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};

// path.relative(from, to)
// posix version
exports.relative = function (from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
      } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
  // We saw a non-dot character immediately before the dot
  preDotState === 0 ||
  // The (right-most) trimmed path component is exactly '..'
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter(xs, f) {
  if (xs.filter) return xs.filter(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    if (f(xs[i], i, xs)) res.push(xs[i]);
  }
  return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
  return str.substr(start, len);
} : function (str, start, len) {
  if (start < 0) start = str.length + start;
  return str.substr(start, len);
};

/***/ }),

/***/ "UVb7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6ano");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Ujpk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__("5qf4");
var DESCRIPTORS = __webpack_require__("P9Ib");
var LIBRARY = __webpack_require__("H21C");
var $typed = __webpack_require__("fero");
var hide = __webpack_require__("0NXb");
var redefineAll = __webpack_require__("J0Tl");
var fails = __webpack_require__("5BXi");
var anInstance = __webpack_require__("yJTF");
var toInteger = __webpack_require__("yjVO");
var toLength = __webpack_require__("dJBs");
var toIndex = __webpack_require__("16zj");
var gOPN = __webpack_require__("Vzm0").f;
var dP = __webpack_require__("nw8e").f;
var arrayFill = __webpack_require__("hphS");
var setToStringTag = __webpack_require__("rq3q");
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  }return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function get() {
      return this[internal];
    } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) {
    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
  }
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),

/***/ "UsHK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0feo");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "UtQj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbar__1BU1v{height:4em;border-bottom:1px solid #eee}.iconButton__QFD4f{color:#0079b8;margin:0 .75em 0 1em;font-size:1.25em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notification-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notification-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notification-list/styles.scss"],"names":[],"mappings":"AAAA,gBACE,WACA,4BAA6B,CAC9B,mBAGC,cACA,qBACA,gBAAiB,CAClB","file":"styles.scss","sourcesContent":[".toolbar {\n  height: 4em;\n  border-bottom: 1px solid #eee;\n}\n\n.iconButton {\n  color: #0079b8;\n  margin: 0 .75em 0 1em;\n  font-size: 1.25em;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbar": "toolbar__1BU1v",
	"iconButton": "iconButton__QFD4f"
};

/***/ }),

/***/ "V1F4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbar__1lC3m{height:4em;border-bottom:1px solid #eee}.iconButton__3yL9B{color:#0079b8;margin:0 1em 0 1.25em;font-size:1.25em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/chat-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/chat-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/chat-list/styles.scss"],"names":[],"mappings":"AAAA,gBACE,WACA,4BAA6B,CAC9B,mBAGC,cACA,sBACA,gBAAiB,CAClB","file":"styles.scss","sourcesContent":[".toolbar {\n  height: 4em;\n  border-bottom: 1px solid #eee;\n}\n\n.iconButton {\n  color: #0079b8;\n  margin: 0 1em 0 1.25em;\n  font-size: 1.25em;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbar": "toolbar__1lC3m",
	"iconButton": "iconButton__3yL9B"
};

/***/ }),

/***/ "VUW8":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__("izCb");

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

/***/ }),

/***/ "Vzm0":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("vL0Z");
var hiddenKeys = __webpack_require__("9bbv").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),

/***/ "WG/o":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".container__2Exxp{color:#666;fill:#666;width:100%;padding:1em;text-align:center;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.icon__1WJwy{display:block}.icon__1WJwy svg.mdi-icon{width:3em;height:3em;-webkit-transform:none;transform:none}.text__3Buc8{display:block}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/empty-state/C:/dev/globalTopBar/src/components/common/empty-state/C:/dev/globalTopBar/src/components/common/empty-state/styles.scss"],"names":[],"mappings":"AAAA,kBACE,WACA,UACA,WACA,YACA,kBACA,YACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,sBAAuB,CACxB,aAGC,aAAc,CADhB,0BAGI,UACA,WACA,uBAAA,cAAe,CAChB,aAID,aAAc,CACf","file":"styles.scss","sourcesContent":[".container {\n  color: #666;\n  fill: #666;\n  width: 100%;\n  padding: 1em;\n  text-align: center;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  display: block;\n  :global svg.mdi-icon {\n    width: 3em;\n    height: 3em;\n    transform: none;\n  }\n}\n\n.text {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__2Exxp",
	"icon": "icon__1WJwy",
	"text": "text__3Buc8"
};

/***/ }),

/***/ "YMyA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".badge__3ySnA{padding:.4em;font-size:.6em;line-height:.76em;z-index:100;color:#000;font-weight:700;display:block;border-radius:1em;background:orange;position:absolute;top:.5em;right:1em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/simple-badge/C:/dev/globalTopBar/src/components/common/simple-badge/C:/dev/globalTopBar/src/components/common/simple-badge/styles.scss"],"names":[],"mappings":"AAAA,cACE,aACA,eACA,kBACA,YACA,WACA,gBACA,cACA,kBACA,kBACA,kBACA,SACA,SAAU,CACX","file":"styles.scss","sourcesContent":[".badge {\n  padding: .4em;\n  font-size: .6em;\n  line-height: .76em;\n  z-index: 100;\n  color: black;\n  font-weight: bold;\n  display: block;\n  border-radius: 1em;\n  background: #ffa500;\n  position: absolute;\n  top: .5em;\n  right: 1em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"badge": "badge__3ySnA"
};

/***/ }),

/***/ "YRuK":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__("izCb");
var sign = __webpack_require__("qtVy");

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),

/***/ "Z1rp":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__("M7z6");

__webpack_require__("s7uf")('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),

/***/ "Z5df":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "Z7e/":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("44AI")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("0NXb")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),

/***/ "ZVay":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kyfi");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ZcPD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("hgks");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
}();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;

/***/ }),

/***/ "a/o/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("6WEV");
var anObject = __webpack_require__("eT53");
var speciesConstructor = __webpack_require__("Ex+G");
var advanceStringIndex = __webpack_require__("/t3a");
var toLength = __webpack_require__("dJBs");
var callRegExpExec = __webpack_require__("sNFG");
var regexpExec = __webpack_require__("ZcPD");
var fails = __webpack_require__("5BXi");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () {
  RegExp(MAX_UINT32, 'y');
});

// @@split logic
__webpack_require__("LmBS")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function internalSplit(separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
  // `String.prototype.split` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = defined(this);
    var splitter = separator == undefined ? undefined : separator[SPLIT];
    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
  },
  // `RegExp.prototype[@@split]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (regexp, limit) {
    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
    if (res.done) return res.value;

    var rx = anObject(regexp);
    var S = String(this);
    var C = speciesConstructor(rx, RegExp);

    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g');

    // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.
    var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];
    while (q < S.length) {
      splitter.lastIndex = SUPPORTS_Y ? q : 0;
      var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
      var e;
      if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
        q = advanceStringIndex(S, q, unicodeMatching);
      } else {
        A.push(S.slice(p, q));
        if (A.length === lim) return A;
        for (var i = 1; i <= z.length - 1; i++) {
          A.push(z[i]);
          if (A.length === lim) return A;
        }
        q = p = e;
      }
    }
    A.push(S.slice(p));
    return A;
  }];
});

/***/ }),

/***/ "a0xl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("z1Rj");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "aZF3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".spinner__2loJO{width:1em;height:1em;display:inline-block;margin:.5em;border-radius:1em;border:.15em solid #000;border-bottom:.15em solid transparent;border-left:.15em solid transparent;-webkit-animation:spin__ZpZ2E 1s linear infinite;animation:spin__ZpZ2E 1s linear infinite}@-webkit-keyframes spin__ZpZ2E{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin__ZpZ2E{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/spinner/C:/dev/globalTopBar/src/components/common/spinner/C:/dev/globalTopBar/src/components/common/spinner/style.scss"],"names":[],"mappings":"AAEA,gBACE,UACA,WACA,qBACA,YAEA,kBACA,wBACA,sCACA,oCACA,iDAAA,wCAAkC,CACnC,+BAIC,GACE,+BAAA,sBAAuB,CAGzB,GACE,gCAAA,uBAAyB,CAAA,CAT5B,uBAIC,GACE,+BAAA,sBAAuB,CAGzB,GACE,gCAAA,uBAAyB,CAAA,CAAA","file":"style.scss","sourcesContent":["$spinner-width: .15em;\n\n.spinner {\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  margin: .5em;\n\n  border-radius: 1em;\n  border: $spinner-width solid black;\n  border-bottom: $spinner-width solid transparent;\n  border-left: $spinner-width solid transparent;\n  animation: spin 1s linear infinite;\n}\n\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"spinner": "spinner__2loJO",
	"spin": "spin__ZpZ2E"
};

/***/ }),

/***/ "ad0j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ChatIcon = function ChatIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3Z' }));
};

module.exports = ChatIcon;

/***/ }),

/***/ "bFYF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oJgK");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bRUR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var weak = __webpack_require__("BNoi");
var validate = __webpack_require__("1FW4");
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__("hWYB")(WEAK_SET, function (get) {
  return function WeakSet() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

/***/ }),

/***/ "bvhO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),

/***/ "cNG8":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("eT53");
var isObject = __webpack_require__("M7z6");
var newPromiseCapability = __webpack_require__("L7XN");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),

/***/ "cUGc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("k6WP");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "chwh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbar__2ewqU{height:4em;border-bottom:1px solid #eee}.iconButton__jV80Q{color:#0079b8;margin-right:.25em;font-size:1.25em}.manualLink__CaGGc{position:relative;padding:.75em 3em .75em 1em;border-bottom:1px solid #eee;font-size:.875em;font-weight:700;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-decoration:none!important;color:#000!important}.manualLink__CaGGc .number__8O_rt{width:28px;height:28px;border:2px solid #064264;border-radius:100%;margin-right:12px;text-align:center;line-height:24px;font-size:14px;font-weight:700;-ms-flex-negative:0;flex-shrink:0}.manualLink__CaGGc svg.linkIcon__3UGub{color:#0079b8;position:absolute;right:1em;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.manualLink__CaGGc:focus,.manualLink__CaGGc:hover{background:#eee;outline:none}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/help-desk/manual-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/help-desk/manual-list/C:/dev/globalTopBar/src/components/sections/personal-area/sections/help-desk/manual-list/styles.scss"],"names":[],"mappings":"AAAA,gBACE,WACA,4BAA6B,CAC9B,mBAGC,cACA,mBACA,gBAAiB,CAClB,mBAGC,kBACA,4BACA,6BACA,iBACA,gBACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,+BACA,oBAAuB,CATzB,kCAYI,WACA,YACA,yBACA,mBACA,kBACA,kBACA,iBACA,eACA,gBACA,oBAAA,aAAc,CArBlB,uCAyBI,cACA,kBACA,UACA,QACA,mCAAA,0BAA2B,CA7B/B,kDAiCI,gBACA,YAAa,CACd","file":"styles.scss","sourcesContent":[".toolbar {\n  height: 4em;\n  border-bottom: 1px solid #eee;\n}\n\n.iconButton {\n  color: #0079b8;\n  margin-right: .25em;\n  font-size: 1.25em;\n}\n\n.manualLink {\n  position: relative;\n  padding: .75em 3em .75em 1em;\n  border-bottom: 1px solid rgb(238, 238, 238);\n  font-size: 0.875em;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  text-decoration: none !important;\n  color: black !important;\n\n  .number {\n    width: 28px;\n    height: 28px;\n    border: 2px solid #064264;\n    border-radius: 100%;\n    margin-right: 12px;\n    text-align: center;\n    line-height: 24px;\n    font-size: 14px;\n    font-weight: 700;\n    flex-shrink: 0;\n  }\n\n  svg.linkIcon {\n    color: #0079b8;\n    position: absolute;\n    right: 1em;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &:hover, &:focus {\n    background: #eee;\n    outline: none;\n  }\n}\n\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbar": "toolbar__2ewqU",
	"iconButton": "iconButton__jV80Q",
	"manualLink": "manualLink__CaGGc",
	"number": "number__8O_rt",
	"linkIcon": "linkIcon__3UGub"
};

/***/ }),

/***/ "coyu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__("8aIi");
var validate = __webpack_require__("1FW4");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("hWYB")(SET, function (get) {
  return function Set() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),

/***/ "d0aC":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__("izCb");
var getProto = __webpack_require__("8q6y");
var anObject = __webpack_require__("eT53");

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

/***/ }),

/***/ "d5RU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("6zGc")('native-function-to-string', Function.toString);

/***/ }),

/***/ "dJBs":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("yjVO");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "dVO+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbar__2SEMW{height:4em;border-bottom:1px solid #eee}.iconButton__2wg6r{color:#0079b8;margin:0 .75em 0 1em;font-size:1.25em}.linkButton__1BcQY{width:100%;background:none;border:none;text-decoration:none;height:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 1.125em;position:relative;color:inherit;font:inherit;line-height:3em}.linkButton__1BcQY:hover{background:rgba(0,0,0,.1);cursor:pointer;color:inherit}.linkButton__1BcQY>span{height:100%;width:100%}.linkButton__1BcQY svg.linkIcon__2aHvP{color:#0079b8;position:absolute;right:1em;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/help-desk/help-desk-menu/C:/dev/globalTopBar/src/components/sections/personal-area/sections/help-desk/help-desk-menu/C:/dev/globalTopBar/src/components/sections/personal-area/sections/help-desk/help-desk-menu/styles.scss"],"names":[],"mappings":"AAAA,gBACE,WACA,4BAA6B,CAC9B,mBAGC,cACA,qBACA,gBAAiB,CAClB,mBAGC,WACA,gBACA,YACA,qBACA,YACA,mBACA,gBACA,uBACA,kBACA,kBACA,cACA,aACA,eAAgB,CAblB,yBAgBI,0BACA,eACA,aAAc,CAlBlB,wBAsBI,YACA,UAAW,CAvBf,uCA2BI,cACA,kBACA,UACA,QACA,mCAAA,0BAA2B,CAC5B","file":"styles.scss","sourcesContent":[".toolbar {\n  height: 4em;\n  border-bottom: 1px solid #eee;\n}\n\n.iconButton {\n  color: #0079b8;\n  margin: 0 .75em 0 1em;\n  font-size: 1.25em;\n}\n\n.linkButton {\n  width: 100%;\n  background: none;\n  border: none;\n  text-decoration: none;\n  height: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 1.125em;\n  position: relative;\n  color: inherit;\n  font: inherit;\n  line-height: 3em;\n\n  &:hover {\n    background: rgba(black, 0.1);\n    cursor: pointer;\n    color: inherit;\n  }\n\n  > span {\n    height: 100%;\n    width: 100%;\n  }\n\n  svg.linkIcon {\n    color: #0079b8;\n    position: absolute;\n    right: 1em;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbar": "toolbar__2SEMW",
	"iconButton": "iconButton__2wg6r",
	"linkButton": "linkButton__1BcQY",
	"linkIcon": "linkIcon__2aHvP"
};

/***/ }),

/***/ "deHu":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__("izCb");
var anObject = __webpack_require__("eT53");
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),

/***/ "dgPI":
/***/ (function(module, exports) {

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	'use strict';

	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) {/**/}

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	'use strict';

	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || typeof target !== 'object' && typeof target !== 'function') {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

						// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

/***/ }),

/***/ "do9D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var SendIcon = function SendIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M2,21L23,12L2,3V10L17,12L2,14V21Z' }));
};

module.exports = SendIcon;

/***/ }),

/***/ "dvol":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("g6sb");
var gOPN = __webpack_require__("Vzm0").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),

/***/ "e3Bp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__("P9Ib");
var getKeys = __webpack_require__("U9a7");
var gOPS = __webpack_require__("EWMd");
var pIE = __webpack_require__("vjRp");
var toObject = __webpack_require__("rfVX");
var IObject = __webpack_require__("nGau");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("5BXi")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),

/***/ "e6SV":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__("izCb");

$export($export.S, 'Reflect', { ownKeys: __webpack_require__("kABk") });

/***/ }),

/***/ "eT53":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("M7z6");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "eYdE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".input__dN4-k{width:calc(100% - 1em);height:calc(100% - 1em);max-width:none;display:block;background:#eee;padding:0 .5em;margin:auto;border-radius:3px;border:0;-webkit-box-shadow:inset 0 3px 6px #ddd;box-shadow:inset 0 3px 6px #ddd}.input__dN4-k:focus{border:1px solid #3ea6ff;outline:none}.input__dN4-k::-webkit-input-placeholder{opacity:.7}.input__dN4-k::-moz-placeholder{opacity:.7}.input__dN4-k::-ms-input-placeholder{opacity:.7}.input__dN4-k::placeholder{opacity:.7}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/custom-input/C:/dev/globalTopBar/src/components/common/custom-input/C:/dev/globalTopBar/src/components/common/custom-input/styles.scss"],"names":[],"mappings":"AAAA,cACE,uBACA,wBACA,eACA,cACA,gBACA,eACA,YACA,kBACA,SACA,wCAAA,+BAAgC,CAVlC,oBAaI,yBACA,YAAa,CAdjB,yCAkBI,UAAY,CAlBhB,gCAkBI,UAAY,CAlBhB,qCAkBI,UAAY,CAlBhB,2BAkBI,UAAY,CACb","file":"styles.scss","sourcesContent":[".input {\n  width: calc(100% - 1em);\n  height: calc(100% - 1em);\n  max-width: none;\n  display: block;\n  background: #eee;\n  padding: 0 .5em;\n  margin: auto;\n  border-radius: 3px;\n  border: 0;\n  box-shadow: inset 0 3px 6px #ddd;\n\n  &:focus {\n    border: 1px solid #3ea6ff;\n    outline: none;\n  }\n\n  &::placeholder {\n    opacity: 0.7;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"input": "input__dN4-k"
};

/***/ }),

/***/ "ebgP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__("sYaK");
var descriptor = __webpack_require__("uJ6d");
var setToStringTag = __webpack_require__("rq3q");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("0NXb")(IteratorPrototype, __webpack_require__("44AI")('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),

/***/ "efTI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var AccountIcon = function AccountIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z' }));
};

module.exports = AccountIcon;

/***/ }),

/***/ "fEGw":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "fH7p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__("izCb");
var context = __webpack_require__("GbTB");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("Ah+n")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),

/***/ "fero":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("5qf4");
var hide = __webpack_require__("0NXb");
var uid = __webpack_require__("U49f");
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

/***/ }),

/***/ "ffBc":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbar__2k-6m{height:4em;border-bottom:1px solid #eee}.container__2x-_4{display:-webkit-box;display:-ms-flexbox;display:flex;margin:-.25em;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.unread__eItT9{font-weight:700}.icon__3JZW2{-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:1.25em}.body__19gNH{margin-left:.75em;width:100%;text-align:left;overflow:hidden}.subtitle__1M3vX,.title__1R6Iz{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.subtitle__1M3vX{font-size:.8em;color:#666;width:100%;margin-top:-.25em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/chat-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/chat-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/chat-list-item/styles.scss"],"names":[],"mappings":"AAAA,gBACE,WACA,4BAA6B,CAC9B,kBAGC,oBAAA,oBAAA,aACA,cACA,YACA,yBAAA,sBAAA,kBAAmB,CACpB,eAGC,eAAiB,CAClB,aAGC,oBAAA,cACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,gBAAiB,CAClB,aAGC,kBACA,WACA,gBACA,eAAgB,CACjB,AAMA,+BAHC,mBACA,uBACA,eAAgB,CAWjB,AAVA,iBAGC,eACA,WACA,AACA,WACA,AAEA,iBAAkB,CACnB","file":"styles.scss","sourcesContent":[".toolbar {\n  height: 4em;\n  border-bottom: 1px solid #eee;\n}\n\n.container {\n  display: flex;\n  margin: -.25em;\n  height: 100%;\n  align-items: center;\n}\n\n.unread {\n  font-weight: bold;\n}\n\n.icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25em;\n}\n\n.body {\n  margin-left: .75em;\n  width: 100%;\n  text-align: left;\n  overflow: hidden;\n}\n\n.title {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.subtitle {\n  font-size: 0.8em;\n  color: #666;\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: -.25em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbar": "toolbar__2k-6m",
	"container": "container__2x-_4",
	"unread": "unread__eItT9",
	"icon": "icon__3JZW2",
	"body": "body__19gNH",
	"title": "title__1R6Iz",
	"subtitle": "subtitle__1M3vX"
};

/***/ }),

/***/ "fzty":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UtQj");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "g1JJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("YMyA");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "g6sb":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("nGau");
var defined = __webpack_require__("+Bjj");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "ggmj":
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),

/***/ "goyd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var AccountOffIcon = function AccountOffIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M12,4A4,4 0 0,1 16,8C16,9.95 14.6,11.58 12.75,11.93L8.07,7.25C8.42,5.4 10.05,4 12,4M12.28,14L18.28,20L20,21.72L18.73,23L15.73,20H4V18C4,16.16 6.5,14.61 9.87,14.14L2.78,7.05L4.05,5.78L12.28,14M20,18V19.18L15.14,14.32C18,14.93 20,16.35 20,18Z' }));
};

module.exports = AccountOffIcon;

/***/ }),

/***/ "gxEP":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("izCb");
var $entries = __webpack_require__("ljQU")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "h83E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aFunction = __webpack_require__("6kYj");
var isObject = __webpack_require__("M7z6");
var invoke = __webpack_require__("xcbV");
var arraySlice = [].slice;
var factories = {};

var construct = function construct(F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) {
      n[i] = 'a[' + i + ']';
    } // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  }return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function bound() /* args... */{
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

/***/ }),

/***/ "hIko":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "hJCV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var CheckIcon = function CheckIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' }));
};

module.exports = CheckIcon;

/***/ }),

/***/ "hO6G":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1wQ/");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hUQ6":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__("izCb");

$export($export.P, 'Array', { fill: __webpack_require__("hphS") });

__webpack_require__("Z7e/")('fill');

/***/ }),

/***/ "hWYB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__("5qf4");
var $export = __webpack_require__("izCb");
var redefine = __webpack_require__("PHot");
var redefineAll = __webpack_require__("J0Tl");
var meta = __webpack_require__("AoVy");
var forOf = __webpack_require__("Abke");
var anInstance = __webpack_require__("yJTF");
var isObject = __webpack_require__("M7z6");
var fails = __webpack_require__("5BXi");
var $iterDetect = __webpack_require__("md62");
var setToStringTag = __webpack_require__("rq3q");
var inheritIfRequired = __webpack_require__("ogxf");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);return this;
    });
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) {
        $instance[ADDER](index, index);
      }return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),

/***/ "hgks":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags

var anObject = __webpack_require__("eT53");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

/***/ }),

/***/ "hphS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)


var toObject = __webpack_require__("rfVX");
var toAbsoluteIndex = __webpack_require__("vfEH");
var toLength = __webpack_require__("dJBs");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) {
    O[index++] = value;
  }return O;
};

/***/ }),

/***/ "i23/":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("s7uf")('getOwnPropertyNames', function () {
  return __webpack_require__("dvol").f;
});

/***/ }),

/***/ "iUik":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__("izCb");
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),

/***/ "iZqw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".globalContainer__1_uhY{font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;background:#03354c}@media screen and (max-width:40em){.globalContainer__1_uhY{overflow:hidden;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}}.mainToolbar__2svTF{height:3em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}.additionalToolbar__2mx3s{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;height:auto}.errorAlert__2gBQO{color:red;font-weight:700}.stretchSection__1kRAG{-webkit-box-flex:2;-ms-flex:2;flex:2}.shrinkSection__1M_Ex{-webkit-box-flex:1;-ms-flex:1;flex:1}.globalContainer__1_uhY svg.mdi-icon{height:1em;width:1em;display:inline-block;line-height:1em;-webkit-transform:scale(1.125);transform:scale(1.25);position:relative;top:.125em;vertical-align:unset}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/global-container/C:/dev/globalTopBar/src/components/layout/global-container/C:/dev/globalTopBar/src/components/layout/global-container/style.scss"],"names":[],"mappings":"AAAA,wBACE,eACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,wBACA,yBAAA,sBAAA,mBACA,WACA,kBAAmB,CAEnB,mCARF,wBASI,gBACA,4BAAA,6BAAA,0BAAA,sBACA,0BAAA,uBAAA,mBAAoB,CAEvB,CAED,oBACE,WACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,wBACA,mBAAA,oBAAA,WAAY,CACb,0BAGC,mBAAA,oBAAA,YACA,WAAY,CACb,mBAGC,UACA,eAAiB,CAClB,uBAGC,mBAAA,WAAA,MAAO,CACR,sBAGC,mBAAA,WAAA,MAAO,CACR,qCAKK,WACA,UACA,qBACA,gBACA,+BACA,sBAEA,kBACA,WACA,oBAAqB,CACtB","file":"style.scss","sourcesContent":[".globalContainer {\n  font-size: 16px;\n  display: flex;\n  justify-content: stretch;\n  align-items: center;\n  color: white;\n  background: #03354c;\n\n  @media screen and (max-width: 40em) {\n    overflow: hidden;\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.mainToolbar {\n  height: 3em;\n  display: flex;\n  justify-content: stretch;\n  flex-grow: 2;\n}\n\n.additionalToolbar {\n  flex-grow: 0;\n  height: auto;\n}\n\n.errorAlert {\n  color: red;\n  font-weight: bold;\n}\n\n.stretchSection {\n  flex: 2;\n}\n\n.shrinkSection {\n  flex: 1;\n}\n\n.globalContainer {\n  :global {\n    & svg.mdi-icon {\n      height: 1em;\n      width: 1em;\n      display: inline-block;\n      line-height: 1em;\n      -webkit-transform: scale(1.125);\n      -ms-transform: scale(1.125);\n      transform: scale(1.25);\n      position: relative;\n      top: .125em;\n      vertical-align: unset;\n    }\n  }\n}\n\n\n\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"globalContainer": "globalContainer__1_uhY",
	"mainToolbar": "mainToolbar__2svTF",
	"additionalToolbar": "additionalToolbar__2mx3s",
	"errorAlert": "errorAlert__2gBQO",
	"stretchSection": "stretchSection__1kRAG",
	"shrinkSection": "shrinkSection__1M_Ex"
};

/***/ }),

/***/ "ia+4":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("GM7B");
var ITERATOR = __webpack_require__("44AI")('iterator');
var Iterators = __webpack_require__("JO4d");
module.exports = __webpack_require__("ss9A").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ "igas":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("NNbH");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),

/***/ "ioKM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__("8aIi");
var validate = __webpack_require__("1FW4");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("hWYB")(MAP, function (get) {
  return function Map() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),

/***/ "irmv":
/***/ (function(module, exports) {

module.exports = {"action.back":"Indietro","action.load-previous":"Carica precedenti","action.load-next":"Carica successivi","action.login":"Login","action.logout":"Logout","action.retry":"Riprova","action.send":"Invia","app.list.title":"Software","chat.group.form.title-label":"Titolo","chat.group.form.title-description":"Descrizione","chat.group.new.title":"Nuovo gruppo","chat.input-placeholder":"Scrivi un messaggio","chat.list.empty":"Non hai ancora iniziato nessuna chat.","chat.new.title":"Nuova Chat","chat.new.empty":"Nessun contatto disponibile.","chat.read.empty":"Non c'è ancora nessun messaggio.","chat.title":"Chat","configuration.loading.error":"Collegamento col server fallito.","error.loading":"Errore di caricamento","help_desk_dropdown_title":"Help Desk","help_desk_link_text":"Richiedi Assistenza","message.list":"Messaggi Ricevuti","language_dropdown_title":"Lingua","language.it":"Italiano","language.en":"Inglese","language.es":"Spagnolo","manuals_dropdown_title":"Manualistica","message.list.empty":"Non è presente nessun messaggio","notification.list":"Notifiche","notification.list.empty":"Non è presente nessuna notifica","profile.attribute.email":"Email","profile.attribute.username":"Nome utente","profile.session_expiration":"Scadenza sessione","profile.session_expiration_alert":"La sessione scadrà se non verrà rilevata alcuna attività.","profile.session_expiration_alert.short":"La sessione sta per scadere","profile.title":"Profilo","profile.edit":"Modifica","today":"oggi","user.not-logged":"Non sei loggato"}

/***/ }),

/***/ "izCb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("5qf4");
var core = __webpack_require__("ss9A");
var hide = __webpack_require__("0NXb");
var redefine = __webpack_require__("PHot");
var ctx = __webpack_require__("E3Kh");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "izIX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var EmailOutlineIcon = function EmailOutlineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z' }));
};

module.exports = EmailOutlineIcon;

/***/ }),

/***/ "j1oG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Rq41");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "j6LS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".message__2z-G8{display:block;padding:0 .5em;margin:.5em 0;position:relative;width:100%}.message__2z-G8 .contentRow__1HKUF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch}.message__2z-G8 .textBox__3q3Nw{max-width:70%;padding:.75em 1em;background:#fff;position:relative;word-break:break-word;display:inline-block;text-align:left;-webkit-box-shadow:0 .25em 1em rgba(0,0,0,.125);box-shadow:0 .25em 1em rgba(0,0,0,.125);min-width:3em}.message__2z-G8 .userText__1_AEI{font-size:.75em;font-weight:700}.message__2z-G8 .dateText__1Zlba{font-size:.75em;font-weight:400;line-height:1em;opacity:.7}.ie__2NtxG .textBox__3q3Nw{word-break:break-all}.other__2FCy7{margin-left:0;margin-right:auto}.other__2FCy7 .textBox__3q3Nw{border-radius:0 1.5em 1.5em 1.5em}.other__2FCy7 .userText__1_AEI{text-align:left}.self__3dDLB{margin-left:auto;margin-right:0;text-align:right}.self__3dDLB .contentRow__1HKUF{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.self__3dDLB .textBox__3q3Nw{border-radius:1.5em 1.5em 0 1.5em}.self__3dDLB .userText__1_AEI{text-align:right}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/message-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/message-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/message-list-item/styles.scss"],"names":[],"mappings":"AAEA,gBACE,cACA,eACA,cACA,kBACA,UAAW,CALb,mCAQI,oBAAA,oBAAA,aACA,sBAAA,mBAAA,qBACA,yBAAA,sBAAA,uBAAwB,CAV5B,gCAcI,cACA,kBACA,gBACA,kBACA,sBACA,qBACA,gBACA,gDAAA,wCACA,aAAc,CAtBlB,iCA0BI,gBACA,eAAiB,CA3BrB,iCA+BI,gBACA,gBACA,gBACA,UAAW,CACZ,2BAKC,oBAAqB,CACtB,cAID,cACA,iBAAkB,CAFpB,8BAKI,iCAAkC,CALtC,+BASI,eAAgB,CACjB,aAID,iBACA,eACA,gBAAiB,CAHnB,gCAMI,8BAAA,8BAAA,+BAAA,0BAA2B,CAN/B,6BAUI,iCAAkC,CAVtC,8BAcI,gBAAiB,CAClB","file":"styles.scss","sourcesContent":["$message-background: #fff;\n\n.message {\n  display: block;\n  padding: 0 .5em;\n  margin: .5em 0;\n  position: relative;\n  width: 100%;\n\n  .contentRow {\n    display: flex;\n    align-items: flex-end;\n    justify-content: stretch;\n  }\n\n  .textBox {\n    max-width: 70%;\n    padding: .75em 1em;\n    background: $message-background;\n    position: relative;\n    word-break: break-word;\n    display: inline-block;\n    text-align: left;\n    box-shadow: 0 0.25em 1em rgba(black, 0.125);\n    min-width: 3em;\n  }\n\n  .userText {\n    font-size: 0.75em;\n    font-weight: bold;\n  }\n\n  .dateText {\n    font-size: 0.75em;\n    font-weight: normal;\n    line-height: 1em;\n    opacity: .7;\n  }\n}\n\n.ie {\n  .textBox {\n    word-break: break-all;\n  }\n}\n\n.other {\n  margin-left: 0;\n  margin-right: auto;\n\n  .textBox {\n    border-radius: 0 1.5em 1.5em 1.5em;\n  }\n\n  .userText {\n    text-align: left;\n  }\n}\n\n.self {\n  margin-left: auto;\n  margin-right: 0;\n  text-align: right;\n\n  .contentRow {\n    flex-direction: row-reverse;\n  }\n\n  .textBox {\n    border-radius: 1.5em 1.5em 0 1.5em;\n  }\n\n  .userText {\n    text-align: right;\n  }\n}\n\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"message": "message__2z-G8",
	"contentRow": "contentRow__1HKUF",
	"textBox": "textBox__3q3Nw",
	"userText": "userText__1_AEI",
	"dateText": "dateText__1Zlba",
	"ie": "ie__2NtxG",
	"other": "other__2FCy7",
	"self": "self__3dDLB"
};

/***/ }),

/***/ "jfh9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TeL6");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jtyH":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".sectionContainer__2wM_k{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-flex:1;-ms-flex:1;flex:1;position:relative}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/section-container/C:/dev/globalTopBar/src/components/layout/section-container/C:/dev/globalTopBar/src/components/layout/section-container/style.scss"],"names":[],"mappings":"AAAA,yBACE,YACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,mBAAA,WAAA,OACA,iBAAkB,CACnB","file":"style.scss","sourcesContent":[".sectionContainer {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"sectionContainer": "sectionContainer__2wM_k"
};

/***/ }),

/***/ "k6WP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".container__1fuXk{display:inline-block;width:1em;height:1em}.error__2D-Ju,.loading__17Vw5,.success__3jhD7{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;contain:strict}.loading__17Vw5{background:#0001}.error__2D-Ju{background:rgba(255,0,0,.5)}.success__3jhD7>*{display:block;max-width:100%;max-height:100%;fill:currentColor}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/icon/C:/dev/globalTopBar/src/components/common/icon/C:/dev/globalTopBar/src/components/common/icon/styles.scss"],"names":[],"mappings":"AAAA,kBACI,qBACA,UACA,UAAW,CACd,8CAKG,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,WACA,YACA,cAAe,CAClB,gBAIG,gBAAiB,CACpB,cAGG,2BAAgC,CACnC,kBAGG,cACA,eACA,gBACA,iBAAkB,CACrB","file":"styles.scss","sourcesContent":[".container {\r\n    display: inline-block;\r\n    width: 1em;\r\n    height: 1em;\r\n}\r\n\r\n.loading,\r\n.error,\r\n.success {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    contain: strict;\r\n}\r\n\r\n\r\n.loading {\r\n    background: #0001;\r\n}\r\n\r\n.error {\r\n    background: rgba(255, 0, 0, 0.5);\r\n}\r\n\r\n.success > * {\r\n    display: block;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    fill: currentColor;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__1fuXk",
	"loading": "loading__17Vw5",
	"error": "error__2D-Ju",
	"success": "success__3jhD7"
};

/***/ }),

/***/ "kABk":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("Vzm0");
var gOPS = __webpack_require__("EWMd");
var anObject = __webpack_require__("eT53");
var Reflect = __webpack_require__("5qf4").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),

/***/ "kG2B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (C) 2014 yanni4night.com
 * index.js
 *
 * changelog
 * 2014-08-16[14:31:02]:authorized
 * 2014-08-19[14:05:43]:fixed crash when first piece is empty
 * 2014-11-16[21:15:06]:support windows \\
 *
 * @author yanni4night@gmail.com
 * @version 0.1.2
 * @since 0.1.0
 */



var extend = __webpack_require__("dgPI");
var url = __webpack_require__("Mej7");
var path = __webpack_require__("UUq2");

/**
 * Join two or more url pieces into one.
 *
 * Only the protocol/port/host in the first piece is saved,but all the get parameters
 * will be saved.
 *
 * @param {String|Function}... Multiple url pieces in function or string type.
 * @return {String} The URL joined.
 */
module.exports = function urljoin() {

    //convert to Array
    var pieces = Array.prototype.slice.call(arguments);
    var query = {};
    var first, paths;

    if (!pieces.length) {
        return '';
    } else if (1 === pieces.length) {
        return pieces[0];
    }

    paths = pieces.map(function (piece) {
        var pieceStr = 'function' === typeof piece ? piece() : String(piece || '');

        if (!pieceStr) {
            return '';
        }

        var parsed = url.parse(pieceStr, true);

        if (!first && parsed) {
            first = parsed;
        }

        extend(query, parsed.query);
        return parsed.pathname;
    }).filter(function (piece) {
        return !!piece;
    });

    delete first.search; //we use query instead of search
    first.query = query;
    first.pathname = path.join.apply(path, paths).replace(new RegExp('\\' + path.sep, 'g'), '/');
    return url.format(first);
};

/***/ }),

/***/ "kLut":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__("izCb");
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) {
    // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),

/***/ "kpgR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var PlusIcon = function PlusIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z' }));
};

module.exports = PlusIcon;

/***/ }),

/***/ "krFE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sJxL");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kv8Z":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__("uIjZ");
var getPrototypeOf = __webpack_require__("8q6y");
var has = __webpack_require__("2uHg");
var $export = __webpack_require__("izCb");
var isObject = __webpack_require__("M7z6");
var anObject = __webpack_require__("eT53");

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

/***/ }),

/***/ "kyfi":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".flag__3ElLU{display:inline-block;margin-right:.5em;height:1em;width:1.5em;-o-object-fit:cover;object-fit:cover;border:1px solid #fff}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/language-flag-icon/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/language-flag-icon/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/language-flag-icon/styles.scss"],"names":[],"mappings":"AAAA,aACE,qBACA,kBACA,WACA,YACA,oBAAA,iBACA,qBAAuB,CACxB","file":"styles.scss","sourcesContent":[".flag {\n  display: inline-block;\n  margin-right: .5em;\n  height: 1em;\n  width: 1.5em;\n  object-fit: cover;\n  border: 1px solid white;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"flag": "flag__3ElLU"
};

/***/ }),

/***/ "l262":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "laXD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var HelpCircleOutlineIcon = function HelpCircleOutlineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z' }));
};

module.exports = HelpCircleOutlineIcon;

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "le1D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var BellOutlineIcon = function BellOutlineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M16,17H7V10.5C7,8 9,6 11.5,6C14,6 16,8 16,10.5M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22A2,2 0 0,0 13.5,20H9.5A2,2 0 0,0 11.5,22Z' }));
};

module.exports = BellOutlineIcon;

/***/ }),

/***/ "ljC3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("167e");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ljQU":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("P9Ib");
var getKeys = __webpack_require__("U9a7");
var toIObject = __webpack_require__("g6sb");
var isEnum = __webpack_require__("vjRp").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

/***/ }),

/***/ "lk0u":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5omu");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "lsHX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ffBc");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "m0zb":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__("izCb");
var expm1 = __webpack_require__("A+f6");
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__("5BXi")(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),

/***/ "m9aB":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("rfVX");
var $keys = __webpack_require__("U9a7");

__webpack_require__("s7uf")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

/***/ }),

/***/ "mH0U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__("H21C");
var $export = __webpack_require__("izCb");
var redefine = __webpack_require__("PHot");
var hide = __webpack_require__("0NXb");
var Iterators = __webpack_require__("JO4d");
var $iterCreate = __webpack_require__("ebgP");
var setToStringTag = __webpack_require__("rq3q");
var getPrototypeOf = __webpack_require__("8q6y");
var ITERATOR = __webpack_require__("44AI")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),

/***/ "mZl9":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__("izCb");

$export($export.S, 'Math', { sign: __webpack_require__("qtVy") });

/***/ }),

/***/ "md62":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("44AI")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),

/***/ "n0l+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("IBtt");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "n20m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__("izCb");
var $pad = __webpack_require__("+lQn");
var userAgent = __webpack_require__("O5uh");

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),

/***/ "nEse":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__("izCb");
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),

/***/ "nGau":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("Z5df");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "nIty":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("g6sb");
var $getOwnPropertyDescriptor = __webpack_require__("uIjZ").f;

__webpack_require__("s7uf")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),

/***/ "nw8e":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("eT53");
var IE8_DOM_DEFINE = __webpack_require__("/o6G");
var toPrimitive = __webpack_require__("9y37");
var dP = Object.defineProperty;

exports.f = __webpack_require__("P9Ib") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "nwv8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vKoD");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "oJgK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".badge__28Cv6{width:.75em;height:.75em;display:block;border-radius:1em;background:red;position:absolute;top:1em;right:1em;border:.125em solid #fff}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notifications-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notifications-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notifications-button/styles.scss"],"names":[],"mappings":"AAAA,cACE,YACA,aACA,cACA,kBACA,eACA,kBACA,QACA,UACA,wBAA0B,CAC3B","file":"styles.scss","sourcesContent":[".badge {\n  width: .75em;\n  height: .75em;\n  display: block;\n  border-radius: 1em;\n  background: red;\n  position: absolute;\n  top: 1em;\n  right: 1em;\n  border: .125em solid white;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"badge": "badge__28Cv6"
};

/***/ }),

/***/ "ob11":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__("izCb");
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

/***/ }),

/***/ "ogxf":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("M7z6");
var setPrototypeOf = __webpack_require__("vn3S").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }return that;
};

/***/ }),

/***/ "pDhD":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("P9Ib") && /./g.flags != 'g') __webpack_require__("nw8e").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("hgks")
});

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "pwRL":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("izCb");

$export($export.S, 'Number', { isInteger: __webpack_require__("T4z7") });

/***/ }),

/***/ "py3/":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__("izCb");
var log1p = __webpack_require__("ggmj");
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
// V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
&& Math.floor($acosh(Number.MAX_VALUE)) == 710
// Tor Browser bug: Math.acosh(Infinity) -> NaN
&& $acosh(Infinity) == Infinity), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),

/***/ "q6qL":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory(__webpack_require__("KM04")) : typeof define === 'function' && define.amd ? define(['preact'], factory) : global.preactPortal = factory(global.preact);
})(this, function (preact) {
  'use strict';

  var asyncGenerator = function () {
    function AwaitValue(value) {
      this.value = value;
    }

    function AsyncGenerator(gen) {
      var front, back;

      function send(key, arg) {
        return new Promise(function (resolve, reject) {
          var request = {
            key: key,
            arg: arg,
            resolve: resolve,
            reject: reject,
            next: null
          };

          if (back) {
            back = back.next = request;
          } else {
            front = back = request;
            resume(key, arg);
          }
        });
      }

      function resume(key, arg) {
        try {
          var result = gen[key](arg);
          var value = result.value;

          if (value instanceof AwaitValue) {
            Promise.resolve(value.value).then(function (arg) {
              resume("next", arg);
            }, function (arg) {
              resume("throw", arg);
            });
          } else {
            settle(result.done ? "return" : "normal", result.value);
          }
        } catch (err) {
          settle("throw", err);
        }
      }

      function settle(type, value) {
        switch (type) {
          case "return":
            front.resolve({
              value: value,
              done: true
            });
            break;

          case "throw":
            front.reject(value);
            break;

          default:
            front.resolve({
              value: value,
              done: false
            });
            break;
        }

        front = front.next;

        if (front) {
          resume(front.key, front.arg);
        } else {
          back = null;
        }
      }

      this._invoke = send;

      if (typeof gen.return !== "function") {
        this.return = undefined;
      }
    }

    if (typeof Symbol === "function" && Symbol.asyncIterator) {
      AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
        return this;
      };
    }

    AsyncGenerator.prototype.next = function (arg) {
      return this._invoke("next", arg);
    };

    AsyncGenerator.prototype.throw = function (arg) {
      return this._invoke("throw", arg);
    };

    AsyncGenerator.prototype.return = function (arg) {
      return this._invoke("return", arg);
    };

    return {
      wrap: function wrap(fn) {
        return function () {
          return new AsyncGenerator(fn.apply(this, arguments));
        };
      },
      await: function _await(value) {
        return new AwaitValue(value);
      }
    };
  }();

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  var Portal = function (_Component) {
    inherits(Portal, _Component);

    function Portal() {
      classCallCheck(this, Portal);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
      for (var i in props) {
        if (props[i] !== this.props[i]) {
          return setTimeout(this.renderLayer);
        }
      }
    };

    Portal.prototype.componentDidMount = function componentDidMount() {
      this.isMounted = true;
      this.renderLayer = this.renderLayer.bind(this);
      this.renderLayer();
    };

    Portal.prototype.componentWillUnmount = function componentWillUnmount() {
      this.renderLayer(false);
      this.isMounted = false;
      if (this.remote) this.remote.parentNode.removeChild(this.remote);
    };

    Portal.prototype.findNode = function findNode(node) {
      return typeof node === 'string' ? document.querySelector(node) : node;
    };

    Portal.prototype.renderLayer = function renderLayer() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.isMounted) return;

      if (this.props.into !== this.intoPointer) {
        this.intoPointer = this.props.into;
        if (this.into && this.remote) {
          this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
        }
        this.into = this.findNode(this.props.into);
      }

      this.remote = preact.render(preact.h(PortalProxy, { context: this.context }, show && this.props.children || null), this.into, this.remote);
    };

    Portal.prototype.render = function render() {
      return null;
    };

    return Portal;
  }(preact.Component);

  var PortalProxy = function (_Component2) {
    inherits(PortalProxy, _Component2);

    function PortalProxy() {
      classCallCheck(this, PortalProxy);
      return possibleConstructorReturn(this, _Component2.apply(this, arguments));
    }

    PortalProxy.prototype.getChildContext = function getChildContext() {
      return this.props.context;
    };

    PortalProxy.prototype.render = function render(_ref) {
      var children = _ref.children;

      return children && children[0] || null;
    };

    return PortalProxy;
  }(preact.Component);

  return Portal;
});
//# sourceMappingURL=preact-portal.js.map

/***/ }),

/***/ "qtVy":
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),

/***/ "qtpC":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__("izCb");

$export($export.S, 'Math', { log1p: __webpack_require__("ggmj") });

/***/ }),

/***/ "r4vV":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("5qf4");
var core = __webpack_require__("ss9A");
var LIBRARY = __webpack_require__("H21C");
var wksExt = __webpack_require__("AuE7");
var defineProperty = __webpack_require__("nw8e").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),

/***/ "rIYo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var BookmarkOutlineIcon = function BookmarkOutlineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z' }));
};

module.exports = BookmarkOutlineIcon;

/***/ }),

/***/ "rfVX":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("+Bjj");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "rq3q":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("nw8e").f;
var has = __webpack_require__("2uHg");
var TAG = __webpack_require__("44AI")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),

/***/ "s7uf":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("izCb");
var core = __webpack_require__("ss9A");
var fails = __webpack_require__("5BXi");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),

/***/ "sBdN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".scrollableContainer__vsgTB{min-height:3em;overflow-y:auto;--scrollbar-width:.5em;--scrollbar-background:transparent;--thumb-background:#ccc;scrollbar-width:thin;scrollbar-color:var(--thumb-background) var(--scrollbar-background);overscroll-behavior-y:contain}.scrollableContainer__vsgTB::-webkit-scrollbar{width:var(--scrollbar-width)}.scrollableContainer__vsgTB::-webkit-scrollbar-track{background:var(--scrollbar-background)}.scrollableContainer__vsgTB::-webkit-scrollbar-thumb{background:var(--thumb-background)}@media screen and (max-width:40em){.scrollableContainer__vsgTB{-webkit-box-flex:6;-ms-flex-positive:6;flex-grow:6}}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/scrollable-section/C:/dev/globalTopBar/src/components/layout/scrollable-section/C:/dev/globalTopBar/src/components/layout/scrollable-section/styles.scss"],"names":[],"mappings":"AAAA,4BACE,eACA,gBACA,uBACA,mCACA,wBACA,qBACA,oEACA,6BAA8B,CARhC,+CAYI,4BAA6B,CAZjC,qDAgBI,sCAAuC,CAhB3C,qDAoBI,kCAAmC,CACpC,mCArBH,4BAwBI,mBAAA,oBAAA,WAAY,CAEf,CAAA","file":"styles.scss","sourcesContent":[".scrollableContainer {\n  min-height: 3em;\n  overflow-y: auto;\n  --scrollbar-width: .5em;\n  --scrollbar-background: transparent;\n  --thumb-background: #ccc;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumb-background) var(--scrollbar-background);\n  overscroll-behavior-y: contain;\n\n\n  &::-webkit-scrollbar {\n    width: var(--scrollbar-width);\n  }\n\n  &::-webkit-scrollbar-track {\n    background: var(--scrollbar-background)\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--thumb-background);\n  }\n\n  @media screen and (max-width: 40em){\n    flex-grow: 6;\n  }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"scrollableContainer": "scrollableContainer__vsgTB"
};

/***/ }),

/***/ "sFAp":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("5qf4");
var macrotask = __webpack_require__("KY9y").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("Z5df")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),

/***/ "sJxL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".subBarButton__32RHT{display:none}@media screen and (max-width:40em){.subBarButton__32RHT{display:inline}}.subBar__3Vo5r{display:-webkit-box;display:-ms-flexbox;display:flex;height:3em}@media screen and (max-width:40em){.subBar__3Vo5r{background:#00475f;height:0;visibility:hidden;overflow:hidden;-webkit-transition:all .5s ease;transition:all .5s ease;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}@media screen and (max-width:40em){.open__2f0YA{visibility:visible;height:3em}}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/sub-bar/C:/dev/globalTopBar/src/components/sections/personal-area/sections/sub-bar/C:/dev/globalTopBar/src/components/sections/personal-area/sections/sub-bar/style.scss"],"names":[],"mappings":"AAAA,qBACE,YAAa,CAEb,mCAHF,qBAII,cAAe,CAElB,CAED,eACE,oBAAA,oBAAA,aACA,UAAW,CAEX,mCAJF,eAKI,mBACA,SACA,kBACA,gBACA,gCAAA,wBACA,WACA,yBAAA,sBAAA,6BAA8B,CAEjC,CAGC,mCADF,aAEI,mBACA,UAAW,CAEd,CAAA","file":"style.scss","sourcesContent":[".subBarButton {\n  display: none;\n\n  @media screen and (max-width:40em) {\n    display: inline;\n  }\n}\n\n.subBar {\n  display: flex;\n  height: 3em;\n\n  @media screen and (max-width:40em) {\n    background: #00475f;\n    height: 0;\n    visibility: hidden;\n    overflow: hidden;\n    transition: 0.5s all ease;\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n.open {\n  @media screen and (max-width:40em) {\n    visibility: visible;\n    height: 3em;\n  }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"subBarButton": "subBarButton__32RHT",
	"subBar": "subBar__3Vo5r",
	"open": "open__2f0YA"
};

/***/ }),

/***/ "sNFG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("GM7B");
var builtinExec = RegExp.prototype.exec;

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

/***/ }),

/***/ "sYaK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("eT53");
var dPs = __webpack_require__("MiMz");
var enumBugKeys = __webpack_require__("9bbv");
var IE_PROTO = __webpack_require__("NaGB")('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("/vZ6")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("xj/b").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),

/***/ "ss9A":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "t2/9":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("izCb");
var toIObject = __webpack_require__("g6sb");
var toLength = __webpack_require__("dJBs");

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    }return res.join('');
  }
});

/***/ }),

/***/ "tNPN":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "tWTB":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__("izCb");

$export($export.P, 'Array', { copyWithin: __webpack_require__("Oppn") });

__webpack_require__("Z7e/")('copyWithin');

/***/ }),

/***/ "tiOR":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__("izCb");

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),

/***/ "twy8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("EAOR");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style-reset.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style-reset.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "tyG8":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

/***/ }),

/***/ "uDeg":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GTru");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uIjZ":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("vjRp");
var createDesc = __webpack_require__("uJ6d");
var toIObject = __webpack_require__("g6sb");
var toPrimitive = __webpack_require__("9y37");
var has = __webpack_require__("2uHg");
var IE8_DOM_DEFINE = __webpack_require__("/o6G");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("P9Ib") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),

/***/ "uJ6d":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "uVn9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var global = __webpack_require__("5qf4");
var has = __webpack_require__("2uHg");
var DESCRIPTORS = __webpack_require__("P9Ib");
var $export = __webpack_require__("izCb");
var redefine = __webpack_require__("PHot");
var META = __webpack_require__("AoVy").KEY;
var $fails = __webpack_require__("5BXi");
var shared = __webpack_require__("6zGc");
var setToStringTag = __webpack_require__("rq3q");
var uid = __webpack_require__("U49f");
var wks = __webpack_require__("44AI");
var wksExt = __webpack_require__("AuE7");
var wksDefine = __webpack_require__("r4vV");
var enumKeys = __webpack_require__("0jjw");
var isArray = __webpack_require__("JTrm");
var anObject = __webpack_require__("eT53");
var isObject = __webpack_require__("M7z6");
var toObject = __webpack_require__("rfVX");
var toIObject = __webpack_require__("g6sb");
var toPrimitive = __webpack_require__("9y37");
var createDesc = __webpack_require__("uJ6d");
var _create = __webpack_require__("sYaK");
var gOPNExt = __webpack_require__("dvol");
var $GOPD = __webpack_require__("uIjZ");
var $GOPS = __webpack_require__("EWMd");
var $DP = __webpack_require__("nw8e");
var $keys = __webpack_require__("U9a7");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("Vzm0").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("vjRp").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("H21C")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("0NXb")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),

/***/ "ud3u":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("rfVX");
var $getPrototypeOf = __webpack_require__("8q6y");

__webpack_require__("s7uf")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),

/***/ "v6Aj":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("6w+v");
var getKeys = __webpack_require__("U9a7");
var redefine = __webpack_require__("PHot");
var global = __webpack_require__("5qf4");
var hide = __webpack_require__("0NXb");
var Iterators = __webpack_require__("JO4d");
var wks = __webpack_require__("44AI");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),

/***/ "vKoD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".sectionComponent__3lyTz{position:relative;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/section-component/C:/dev/globalTopBar/src/components/layout/section-component/C:/dev/globalTopBar/src/components/layout/section-component/styles.scss"],"names":[],"mappings":"AAAA,yBACE,kBACA,YACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,SAAU,CACX","file":"styles.scss","sourcesContent":[".sectionComponent {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"sectionComponent": "sectionComponent__3lyTz"
};

/***/ }),

/***/ "vL0Z":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("2uHg");
var toIObject = __webpack_require__("g6sb");
var arrayIndexOf = __webpack_require__("4Ca7")(false);
var IE_PROTO = __webpack_require__("NaGB")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "vfEH":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("yjVO");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "vjRp":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "vmlq":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__("izCb");

$export($export.S, 'Math', { fround: __webpack_require__("z6h7") });

/***/ }),

/***/ "vn3S":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("M7z6");
var anObject = __webpack_require__("eT53");
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__("E3Kh")(Function.call, __webpack_require__("uIjZ").f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),

/***/ "w2SA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])


var $export = __webpack_require__("izCb");
var toLength = __webpack_require__("dJBs");
var context = __webpack_require__("GbTB");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("Ah+n")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
  }
});

/***/ }),

/***/ "wqM+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "x5yM":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("yjVO");
var defined = __webpack_require__("+Bjj");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),

/***/ "x8b3":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),

/***/ "xKrr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__("H0qN"),
    qs = __webpack_require__("yScC"),
    slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
    protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
    whitespace = '[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]',
    left = new RegExp('^' + whitespace + '+');

/**
 * Trim a given string.
 *
 * @param {String} str String to trim.
 * @public
 */
function trimLeft(str) {
  return (str ? str : '').toString().replace(left, '');
}

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [['#', 'hash'], // Extract from the back.
['?', 'query'], // Extract from the back.
function sanitize(address) {
  // Sanitize what is left of the address
  return address.replace('\\', '/');
}, ['/', 'pathname'], // Extract from the back.
['@', 'auth', 1], // Extract from the front.
[NaN, 'host', undefined, 1, 1], // Set left over value.
[/:(\d+)$/, 'port', undefined, 1], // RegExp the back.
[NaN, 'hostname', undefined, 1, 1] // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;else if (typeof global !== 'undefined') globalVar = global;else if (typeof self !== 'undefined') globalVar = self;else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {},
      type = typeof loc,
      key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) {
      delete finaldestination[key];
    }
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address) {
  address = trimLeft(address);
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  if (relative === '') return base;

  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')),
      i = path.length,
      last = path[i - 1],
      unshift = false,
      up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  address = trimLeft(address);

  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative,
      extracted,
      parse,
      instruction,
      index,
      key,
      instructions = rules.slice(),
      type = typeof location,
      url = this,
      i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if (index = parse.exec(address)) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:' ? url.protocol + '//' + url.host : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname + ':' + value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':' + url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:' ? url.protocol + '//' + url.host : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query,
      url = this,
      protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':' + url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?' + query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;

module.exports = Url;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "xSM3":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("izCb");
var toAbsoluteIndex = __webpack_require__("vfEH");
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) {
    // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
    }return res.join('');
  }
});

/***/ }),

/***/ "xX7b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("chwh");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xcbV":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),

/***/ "xj/b":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("5qf4").document;
module.exports = document && document.documentElement;

/***/ }),

/***/ "xyd6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4fd0")('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),

/***/ "yJTF":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),

/***/ "yScC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty,
    undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */
function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}

/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */
function encode(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g,
      result = {},
      part;

  while (part = parser.exec(query)) {
    var key = decode(part[1]),
        value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //
    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [],
      value,
      key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encodeURIComponent(key);
      value = encodeURIComponent(value);

      //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //
      if (key === null || value === null) continue;
      pairs.push(key + '=' + value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;

/***/ }),

/***/ "yW3h":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HyuQ");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yjVO":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "z0BR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".listItemContainer__3Rs7O{text-decoration:none;color:inherit;display:block;border-bottom:1px solid #eee}.listItemContainer__3Rs7O:active,.listItemContainer__3Rs7O:focus,.listItemContainer__3Rs7O:visited{text-decoration:none;color:initial}.listItemContainer__3Rs7O:hover{background:#eee;text-decoration:none}.unread__3jnBj,.unread__3jnBj .itemTitle__2q_vj{font-weight:700}.listItem__3Lde6{width:100%;display:block;padding:1em;color:#000}.listItem__3Lde6:hover{border-color:#008b8b}.itemTitle__2q_vj{font-size:1em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.itemBody__1K4ii{max-height:3em;font-size:.9em;line-height:1.5em;overflow:hidden;word-break:break-word}.itemFooter__1PV3S{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.75em;padding:0;text-align:right;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-weight:700;text-transform:uppercase;letter-spacing:.03em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/message-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/message-list-item/C:/dev/globalTopBar/src/components/sections/personal-area/sections/messenger/message-list-item/styles.scss"],"names":[],"mappings":"AAAA,0BACE,qBACA,cACA,cACA,4BAA6B,CAJ/B,mGAOI,qBACA,aAAc,CARlB,gCAYI,gBACA,oBAAqB,CACtB,AAGH,gDAII,eAAiB,CAClB,iBAID,WACA,cACA,YACA,UAAY,CAJd,uBAOI,oBAAsB,CACvB,kBAID,cACA,mBACA,gBACA,sBAAuB,CACxB,iBAGC,eACA,eACA,kBACA,gBACA,qBAAsB,CACvB,mBAGC,oBAAA,oBAAA,aACA,gBACA,UACA,iBACA,yBAAA,sBAAA,8BACA,gBACA,yBACA,oBAAqB,CACtB","file":"styles.scss","sourcesContent":[".listItemContainer {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n  border-bottom: 1px solid #eee;\n\n  &:active, &:visited, &:focus {\n    text-decoration: none;\n    color: initial;\n  }\n\n  &:hover {\n    background: #eee;\n    text-decoration: none;\n  }\n}\n\n.unread {\n  font-weight: bold;\n\n  .itemTitle {\n    font-weight: bold;\n  }\n}\n\n.listItem {\n  width: 100%;\n  display: block;\n  padding: 1em;\n  color: black;\n\n  &:hover {\n    border-color: darkcyan;\n  }\n}\n\n.itemTitle {\n  font-size: 1em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.itemBody {\n  max-height: 3em;\n  font-size: 0.9em;\n  line-height: 1.5em;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.itemFooter {\n  display: flex;\n  font-size: .75em;\n  padding: 0;\n  text-align: right;\n  justify-content: space-between;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: .03em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"listItemContainer": "listItemContainer__3Rs7O",
	"unread": "unread__3jnBj",
	"itemTitle": "itemTitle__2q_vj",
	"listItem": "listItem__3Lde6",
	"itemBody": "itemBody__1K4ii",
	"itemFooter": "itemFooter__1PV3S"
};

/***/ }),

/***/ "z1Rj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".toolbarTitle__lP6lT{padding:0 .5em 0 0;line-height:3em;height:3em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:700;font-size:1.125em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/toolbar-title/C:/dev/globalTopBar/src/components/layout/toolbar-title/C:/dev/globalTopBar/src/components/layout/toolbar-title/styles.scss"],"names":[],"mappings":"AAAA,qBACE,mBACA,gBACA,WACA,mBACA,gBACA,uBACA,gBACA,iBAAkB,CACnB","file":"styles.scss","sourcesContent":[".toolbarTitle {\n  padding: 0 .5em 0 0;\n  line-height: 3em;\n  height: 3em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: bold;\n  font-size: 1.125em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbarTitle": "toolbarTitle__lP6lT"
};

/***/ }),

/***/ "z6h7":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__("qtVy");
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function roundTiesToEven(n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

/***/ }),

/***/ "zOab":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("eT53");
var sameValue = __webpack_require__("zutv");
var regExpExec = __webpack_require__("sNFG");

// @@search logic
__webpack_require__("LmBS")('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
  // `String.prototype.search` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.search
  function search(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  },
  // `RegExp.prototype[@@search]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
  function (regexp) {
    var res = maybeCallNative($search, regexp, this);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    var previousLastIndex = rx.lastIndex;
    if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
    var result = regExpExec(rx, S);
    if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
    return result === null ? -1 : result.index;
  }];
});

/***/ }),

/***/ "zR9y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__("izCb");
var $at = __webpack_require__("x5yM")(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

/***/ }),

/***/ "zRn7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])


var $export = __webpack_require__("izCb");
var toLength = __webpack_require__("dJBs");
var context = __webpack_require__("GbTB");
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__("Ah+n")(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
  }
});

/***/ }),

/***/ "zj1X":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__("uIjZ");
var $export = __webpack_require__("izCb");
var anObject = __webpack_require__("eT53");

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),

/***/ "zp5c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var preact = __webpack_require__("KM04");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var OpenInNewIcon = function OpenInNewIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.class || props.className || '');

  return preact.h('svg', _extends({}, props, { 'class': className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }), preact.h('path', { d: 'M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z' }));
};

module.exports = OpenInNewIcon;

/***/ }),

/***/ "zutv":
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// bundle.js